import { createElementBlock as _, openBlock as v, normalizeClass as G, renderSlot as Y, createCommentVNode as O, createTextVNode as L, normalizeStyle as ht, resolveDirective as Be, withDirectives as te, toDisplayString as I, createElementVNode as b, computed as w, resolveComponent as B, createBlock as D, createVNode as q, Fragment as E, renderList as X, withCtx as N, inject as se, unref as K, provide as ye, ref as J, onMounted as Le, onUnmounted as mo, watch as he, reactive as vt, watchEffect as yo, toRefs as Fh, capitalize as Ep, shallowRef as oe, warn as Lp, getCurrentInstance as Nh, defineComponent as Mp, isRef as Me, toRef as Q, onScopeDispose as Dp, effectScope as jp, toRaw as Bp, onBeforeUnmount as qt, onUpdated as Fp, mergeProps as ie, Text as Np, readonly as Uh, resolveDynamicComponent as Up, nextTick as Hh, TransitionGroup as bo, Transition as Co, h as So, vShow as De, camelize as Hp, withModifiers as Gp, vModelSelect as Qo, vModelText as zp } from "vue";
function Vp(e) {
  return { all: e = e || /* @__PURE__ */ new Map(), on: function(t, r) {
    var n = e.get(t);
    n ? n.push(r) : e.set(t, [r]);
  }, off: function(t, r) {
    var n = e.get(t);
    n && (r ? n.splice(n.indexOf(r) >>> 0, 1) : e.set(t, []));
  }, emit: function(t, r) {
    var n = e.get(t);
    n && n.slice().map(function(a) {
      a(r);
    }), (n = e.get("*")) && n.slice().map(function(a) {
      a(t, r);
    });
  } };
}
const ae = Vp(), z = (e, t) => {
  const r = e.__vccOpts || e;
  for (const [n, a] of t)
    r[n] = a;
  return r;
}, Wp = {
  name: "CollapseButton",
  inject: {
    getStateOverride: { default: null }
  },
  props: {
    name: {
      type: String,
      required: !0
    },
    state: {
      // expanded or collapsed
      type: String,
      required: !0
    },
    keepContentsOnToggle: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  data() {
    return {
      dataName: this.name,
      visible: !0
    };
  },
  computed: {
    stateOverrideValue() {
      return this.getStateOverride ? this.getStateOverride() : null;
    }
  },
  watch: {
    // https://stackoverflow.com/questions/60416153/making-vue-js-provide-inject-reactive
    stateOverrideValue(e) {
      this.visible && e === "collapsed" ? this.click() : !this.visible && e === "expanded" && this.click();
    }
  },
  created() {
    this.visible = this.state === "expanded", ae.on("collapse-toggle", this.toggle);
  },
  beforeUnmount() {
    ae.off("collapse-toggle", this.toggle);
  },
  methods: {
    click() {
      ae.emit("collapse-toggle", this.dataName);
    },
    toggle(e) {
      this.dataName === e && (this.visible = !this.visible);
    }
  }
}, Kp = ["data-test", "aria-label"];
function Xp(e, t, r, n, a, i) {
  return v(), _("button", {
    class: G([{ visible: a.visible }, "collapsible-title"]),
    "data-test": a.dataName,
    "aria-label": a.visible ? `collapse ${a.dataName}` : `expand ${a.dataName}`,
    onClick: t[0] || (t[0] = (...s) => i.click && i.click(...s))
  }, [
    a.visible && !r.keepContentsOnToggle ? Y(e.$slots, "expanded", { key: 0 }, () => [
      t[1] || (t[1] = L(" Hide "))
    ]) : O("", !0),
    !a.visible && !r.keepContentsOnToggle ? Y(e.$slots, "collapsed", { key: 1 }, () => [
      t[2] || (t[2] = L(" Show "))
    ]) : O("", !0),
    r.keepContentsOnToggle ? Y(e.$slots, "contents", { key: 2 }, () => [
      t[3] || (t[3] = L(" Click here "))
    ]) : O("", !0)
  ], 10, Kp);
}
const Qe = /* @__PURE__ */ z(Wp, [["render", Xp]]), Yp = {
  name: "Collapsible",
  created: function() {
    requestAnimationFrame(() => {
      var e, t;
      this.visible = this.state === "expanded", this.visible || (t = (e = this.$refs.target) == null ? void 0 : e.classList) == null || t.add("display-none");
    }), ae.on("collapse-toggle", this.toggle);
  },
  mounted: function() {
    window.addEventListener("resize", this.resize), window.addEventListener("transitionend", this.toggleDisplay);
  },
  unmounted: function() {
    window.removeEventListener("resize", this.resize), window.removeEventListener("transitionend", this.toggleDisplay);
  },
  props: {
    name: {
      type: String,
      required: !0
    },
    state: {
      //expanded or collapsed
      type: String,
      required: !0
    },
    transition: {
      type: String,
      required: !1,
      default: "0.5s"
    },
    overflow: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  data: function() {
    return {
      dataName: this.name,
      height: "auto",
      visible: !1,
      styles: {
        transition: this.transition,
        overflow: "hidden"
      }
    };
  },
  methods: {
    resize: function() {
      this.computeHeight();
    },
    toggleDisplay: function() {
      this.visible ? (this.$refs.target.style.height = "auto", this.state === "collapsed" && this.overflow && (this.$refs.target.style.overflow = "visible")) : this.$refs.target && (this.$refs.target.classList.add("display-none"), this.$refs.target.style.oveflow = "hidden");
    },
    toggle: function(e) {
      this.dataName === e && (this.$refs.target && (this.$refs.target.classList.remove("display-none"), this.$refs.target.style.overflow = "hidden"), requestAnimationFrame(() => {
        this.computeHeight(), requestAnimationFrame(() => {
          this.visible = !this.visible;
        });
      }));
    },
    getStyle: function() {
      return this.$refs.target ? window.getComputedStyle(this.$refs.target) : "auto";
    },
    setProps: function(e, t, r, n) {
      this.$refs.target.style.visibility = e, this.$refs.target.style.display = t, this.$refs.target.style.position = r, this.$refs.target.style.height = n;
    },
    computeHeightInternal: function() {
      if (this.getStyle().display === "none")
        return "auto";
      this.$refs.target && (this.$refs.target.classList.remove("invisible"), this.setProps("hidden", "block", "absolute", "auto"));
      const e = this.getStyle().height;
      return this.$refs.target && this.setProps(null, null, null, e), !this.visible && this.$refs.target && this.$refs.target.classList.add("invisible"), e;
    },
    computeHeight: function() {
      this.height = this.computeHeightInternal();
    }
  }
}, Jp = ["data-test"];
function Zp(e, t, r, n, a, i) {
  return v(), _("div", {
    ref: "target",
    "data-test": e.dataName,
    class: G({ invisible: !e.visible }),
    style: ht([e.styles])
  }, [
    Y(e.$slots, "default")
  ], 14, Jp);
}
const et = /* @__PURE__ */ z(Yp, [["render", Zp]]), Qp = {
  name: "Dropdown",
  props: {
    initialActive: {
      type: Boolean,
      required: !0,
      default: !1
    },
    selection: {
      type: String,
      required: !0,
      default: "Select Date"
    }
  },
  data() {
    return {
      active: this.initialActive
    };
  },
  methods: {
    toggle() {
      this.active = !this.active;
    },
    away() {
      this.active = !1;
    }
  }
};
function eg(e, t, r, n, a, i) {
  const s = Be("clickaway");
  return v(), _("div", null, [
    Y(e.$slots, "toggler", { toggle: i.toggle }, () => [
      te((v(), _("button", {
        class: "dropdown-button ds-c-field",
        onClick: t[0] || (t[0] = (...o) => i.toggle && i.toggle(...o))
      }, [
        L(I(r.selection), 1)
      ])), [
        [s, i.away]
      ])
    ]),
    Y(e.$slots, "default", { active: a.active })
  ]);
}
const Wq = /* @__PURE__ */ z(Qp, [["render", eg]]), tg = {
  name: "DropdownContent",
  props: {
    active: {
      type: Boolean,
      default: !1
    }
  }
}, rg = {
  key: 0,
  class: "dropdown-content"
}, ng = { class: "dropdown-list" };
function ag(e, t, r, n, a, i) {
  return r.active ? (v(), _("div", rg, [
    b("ul", ng, [
      Y(e.$slots, "default")
    ])
  ])) : O("", !0);
}
const Kq = /* @__PURE__ */ z(tg, [["render", ag]]), ig = {
  name: "DropdownHeader"
}, sg = { class: "dropdown-header" };
function og(e, t, r, n, a, i) {
  return v(), _("li", sg, [
    Y(e.$slots, "default")
  ]);
}
const Xq = /* @__PURE__ */ z(ig, [["render", og]]), ug = {
  name: "DropdownItem"
}, lg = { class: "dropdown-item" }, cg = ["href"];
function dg(e, t, r, n, a, i) {
  return v(), _("li", lg, [
    b("a", {
      href: e.href,
      class: "dropdown-link"
    }, [
      Y(e.$slots, "default")
    ], 8, cg)
  ]);
}
const Yq = /* @__PURE__ */ z(ug, [["render", dg]]);
var qe = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function ce(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Kt, eu;
function Gh() {
  if (eu) return Kt;
  eu = 1;
  var e = typeof qe == "object" && qe && qe.Object === Object && qe;
  return Kt = e, Kt;
}
var Xt, tu;
function be() {
  if (tu) return Xt;
  tu = 1;
  var e = Gh(), t = typeof self == "object" && self && self.Object === Object && self, r = e || t || Function("return this")();
  return Xt = r, Xt;
}
var Yt, ru;
function tt() {
  if (ru) return Yt;
  ru = 1;
  var e = be(), t = e.Symbol;
  return Yt = t, Yt;
}
var Jt, nu;
function fg() {
  if (nu) return Jt;
  nu = 1;
  var e = tt(), t = Object.prototype, r = t.hasOwnProperty, n = t.toString, a = e ? e.toStringTag : void 0;
  function i(s) {
    var o = r.call(s, a), u = s[a];
    try {
      s[a] = void 0;
      var l = !0;
    } catch {
    }
    var d = n.call(s);
    return l && (o ? s[a] = u : delete s[a]), d;
  }
  return Jt = i, Jt;
}
var Zt, au;
function hg() {
  if (au) return Zt;
  au = 1;
  var e = Object.prototype, t = e.toString;
  function r(n) {
    return t.call(n);
  }
  return Zt = r, Zt;
}
var Qt, iu;
function Ae() {
  if (iu) return Qt;
  iu = 1;
  var e = tt(), t = fg(), r = hg(), n = "[object Null]", a = "[object Undefined]", i = e ? e.toStringTag : void 0;
  function s(o) {
    return o == null ? o === void 0 ? a : n : i && i in Object(o) ? t(o) : r(o);
  }
  return Qt = s, Qt;
}
var er, su;
function we() {
  if (su) return er;
  su = 1;
  function e(t) {
    return t != null && typeof t == "object";
  }
  return er = e, er;
}
var tr, ou;
function vg() {
  if (ou) return tr;
  ou = 1;
  var e = Ae(), t = we(), r = "[object Boolean]";
  function n(a) {
    return a === !0 || a === !1 || t(a) && e(a) == r;
  }
  return tr = n, tr;
}
var pg = vg();
const gg = /* @__PURE__ */ ce(pg);
var rr, uu;
function rt() {
  if (uu) return rr;
  uu = 1;
  function e(t) {
    var r = typeof t;
    return t != null && (r == "object" || r == "function");
  }
  return rr = e, rr;
}
var nr, lu;
function qo() {
  if (lu) return nr;
  lu = 1;
  var e = Ae(), t = rt(), r = "[object AsyncFunction]", n = "[object Function]", a = "[object GeneratorFunction]", i = "[object Proxy]";
  function s(o) {
    if (!t(o))
      return !1;
    var u = e(o);
    return u == n || u == a || u == r || u == i;
  }
  return nr = s, nr;
}
var _g = qo();
const mg = /* @__PURE__ */ ce(_g);
var ar, cu;
function yg() {
  if (cu) return ar;
  cu = 1;
  function e(t) {
    return t == null;
  }
  return ar = e, ar;
}
var bg = yg();
const zh = /* @__PURE__ */ ce(bg);
var Cg = rt();
const Sg = /* @__PURE__ */ ce(Cg);
var ir, du;
function Vh() {
  if (du) return ir;
  du = 1;
  function e(t, r) {
    for (var n = -1, a = t == null ? 0 : t.length, i = 0, s = []; ++n < a; ) {
      var o = t[n];
      r(o, n, t) && (s[i++] = o);
    }
    return s;
  }
  return ir = e, ir;
}
var sr, fu;
function qg() {
  if (fu) return sr;
  fu = 1;
  function e(t) {
    return function(r, n, a) {
      for (var i = -1, s = Object(r), o = a(r), u = o.length; u--; ) {
        var l = o[t ? u : ++i];
        if (n(s[l], l, s) === !1)
          break;
      }
      return r;
    };
  }
  return sr = e, sr;
}
var or, hu;
function wg() {
  if (hu) return or;
  hu = 1;
  var e = qg(), t = e();
  return or = t, or;
}
var ur, vu;
function $g() {
  if (vu) return ur;
  vu = 1;
  function e(t, r) {
    for (var n = -1, a = Array(t); ++n < t; )
      a[n] = r(n);
    return a;
  }
  return ur = e, ur;
}
var lr, pu;
function Tg() {
  if (pu) return lr;
  pu = 1;
  var e = Ae(), t = we(), r = "[object Arguments]";
  function n(a) {
    return t(a) && e(a) == r;
  }
  return lr = n, lr;
}
var cr, gu;
function wt() {
  if (gu) return cr;
  gu = 1;
  var e = Tg(), t = we(), r = Object.prototype, n = r.hasOwnProperty, a = r.propertyIsEnumerable, i = e(/* @__PURE__ */ function() {
    return arguments;
  }()) ? e : function(s) {
    return t(s) && n.call(s, "callee") && !a.call(s, "callee");
  };
  return cr = i, cr;
}
var dr, _u;
function de() {
  if (_u) return dr;
  _u = 1;
  var e = Array.isArray;
  return dr = e, dr;
}
var Ne = { exports: {} }, fr, mu;
function Rg() {
  if (mu) return fr;
  mu = 1;
  function e() {
    return !1;
  }
  return fr = e, fr;
}
Ne.exports;
var yu;
function wo() {
  return yu || (yu = 1, function(e, t) {
    var r = be(), n = Rg(), a = t && !t.nodeType && t, i = a && !0 && e && !e.nodeType && e, s = i && i.exports === a, o = s ? r.Buffer : void 0, u = o ? o.isBuffer : void 0, l = u || n;
    e.exports = l;
  }(Ne, Ne.exports)), Ne.exports;
}
var hr, bu;
function Wh() {
  if (bu) return hr;
  bu = 1;
  var e = 9007199254740991, t = /^(?:0|[1-9]\d*)$/;
  function r(n, a) {
    var i = typeof n;
    return a = a ?? e, !!a && (i == "number" || i != "symbol" && t.test(n)) && n > -1 && n % 1 == 0 && n < a;
  }
  return hr = r, hr;
}
var vr, Cu;
function $o() {
  if (Cu) return vr;
  Cu = 1;
  var e = 9007199254740991;
  function t(r) {
    return typeof r == "number" && r > -1 && r % 1 == 0 && r <= e;
  }
  return vr = t, vr;
}
var pr, Su;
function Ag() {
  if (Su) return pr;
  Su = 1;
  var e = Ae(), t = $o(), r = we(), n = "[object Arguments]", a = "[object Array]", i = "[object Boolean]", s = "[object Date]", o = "[object Error]", u = "[object Function]", l = "[object Map]", d = "[object Number]", c = "[object Object]", f = "[object RegExp]", h = "[object Set]", g = "[object String]", p = "[object WeakMap]", m = "[object ArrayBuffer]", C = "[object DataView]", y = "[object Float32Array]", A = "[object Float64Array]", S = "[object Int8Array]", k = "[object Int16Array]", T = "[object Int32Array]", $ = "[object Uint8Array]", M = "[object Uint8ClampedArray]", j = "[object Uint16Array]", F = "[object Uint32Array]", R = {};
  R[y] = R[A] = R[S] = R[k] = R[T] = R[$] = R[M] = R[j] = R[F] = !0, R[n] = R[a] = R[m] = R[i] = R[C] = R[s] = R[o] = R[u] = R[l] = R[d] = R[c] = R[f] = R[h] = R[g] = R[p] = !1;
  function V(H) {
    return r(H) && t(H.length) && !!R[e(H)];
  }
  return pr = V, pr;
}
var gr, qu;
function Kh() {
  if (qu) return gr;
  qu = 1;
  function e(t) {
    return function(r) {
      return t(r);
    };
  }
  return gr = e, gr;
}
var Ue = { exports: {} };
Ue.exports;
var wu;
function kg() {
  return wu || (wu = 1, function(e, t) {
    var r = Gh(), n = t && !t.nodeType && t, a = n && !0 && e && !e.nodeType && e, i = a && a.exports === n, s = i && r.process, o = function() {
      try {
        var u = a && a.require && a.require("util").types;
        return u || s && s.binding && s.binding("util");
      } catch {
      }
    }();
    e.exports = o;
  }(Ue, Ue.exports)), Ue.exports;
}
var _r, $u;
function To() {
  if ($u) return _r;
  $u = 1;
  var e = Ag(), t = Kh(), r = kg(), n = r && r.isTypedArray, a = n ? t(n) : e;
  return _r = a, _r;
}
var mr, Tu;
function Ig() {
  if (Tu) return mr;
  Tu = 1;
  var e = $g(), t = wt(), r = de(), n = wo(), a = Wh(), i = To(), s = Object.prototype, o = s.hasOwnProperty;
  function u(l, d) {
    var c = r(l), f = !c && t(l), h = !c && !f && n(l), g = !c && !f && !h && i(l), p = c || f || h || g, m = p ? e(l.length, String) : [], C = m.length;
    for (var y in l)
      (d || o.call(l, y)) && !(p && // Safari 9 has enumerable `arguments.length` in strict mode.
      (y == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      h && (y == "offset" || y == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      g && (y == "buffer" || y == "byteLength" || y == "byteOffset") || // Skip index properties.
      a(y, C))) && m.push(y);
    return m;
  }
  return mr = u, mr;
}
var yr, Ru;
function Xh() {
  if (Ru) return yr;
  Ru = 1;
  var e = Object.prototype;
  function t(r) {
    var n = r && r.constructor, a = typeof n == "function" && n.prototype || e;
    return r === a;
  }
  return yr = t, yr;
}
var br, Au;
function xg() {
  if (Au) return br;
  Au = 1;
  function e(t, r) {
    return function(n) {
      return t(r(n));
    };
  }
  return br = e, br;
}
var Cr, ku;
function Pg() {
  if (ku) return Cr;
  ku = 1;
  var e = xg(), t = e(Object.keys, Object);
  return Cr = t, Cr;
}
var Sr, Iu;
function Yh() {
  if (Iu) return Sr;
  Iu = 1;
  var e = Xh(), t = Pg(), r = Object.prototype, n = r.hasOwnProperty;
  function a(i) {
    if (!e(i))
      return t(i);
    var s = [];
    for (var o in Object(i))
      n.call(i, o) && o != "constructor" && s.push(o);
    return s;
  }
  return Sr = a, Sr;
}
var qr, xu;
function nt() {
  if (xu) return qr;
  xu = 1;
  var e = qo(), t = $o();
  function r(n) {
    return n != null && t(n.length) && !e(n);
  }
  return qr = r, qr;
}
var wr, Pu;
function $t() {
  if (Pu) return wr;
  Pu = 1;
  var e = Ig(), t = Yh(), r = nt();
  function n(a) {
    return r(a) ? e(a) : t(a);
  }
  return wr = n, wr;
}
var $r, Ou;
function Og() {
  if (Ou) return $r;
  Ou = 1;
  var e = wg(), t = $t();
  function r(n, a) {
    return n && e(n, a, t);
  }
  return $r = r, $r;
}
var Tr, Eu;
function Eg() {
  if (Eu) return Tr;
  Eu = 1;
  var e = nt();
  function t(r, n) {
    return function(a, i) {
      if (a == null)
        return a;
      if (!e(a))
        return r(a, i);
      for (var s = a.length, o = n ? s : -1, u = Object(a); (n ? o-- : ++o < s) && i(u[o], o, u) !== !1; )
        ;
      return a;
    };
  }
  return Tr = t, Tr;
}
var Rr, Lu;
function Jh() {
  if (Lu) return Rr;
  Lu = 1;
  var e = Og(), t = Eg(), r = t(e);
  return Rr = r, Rr;
}
var Ar, Mu;
function Lg() {
  if (Mu) return Ar;
  Mu = 1;
  var e = Jh();
  function t(r, n) {
    var a = [];
    return e(r, function(i, s, o) {
      n(i, s, o) && a.push(i);
    }), a;
  }
  return Ar = t, Ar;
}
var kr, Du;
function Mg() {
  if (Du) return kr;
  Du = 1;
  function e() {
    this.__data__ = [], this.size = 0;
  }
  return kr = e, kr;
}
var Ir, ju;
function Zh() {
  if (ju) return Ir;
  ju = 1;
  function e(t, r) {
    return t === r || t !== t && r !== r;
  }
  return Ir = e, Ir;
}
var xr, Bu;
function Tt() {
  if (Bu) return xr;
  Bu = 1;
  var e = Zh();
  function t(r, n) {
    for (var a = r.length; a--; )
      if (e(r[a][0], n))
        return a;
    return -1;
  }
  return xr = t, xr;
}
var Pr, Fu;
function Dg() {
  if (Fu) return Pr;
  Fu = 1;
  var e = Tt(), t = Array.prototype, r = t.splice;
  function n(a) {
    var i = this.__data__, s = e(i, a);
    if (s < 0)
      return !1;
    var o = i.length - 1;
    return s == o ? i.pop() : r.call(i, s, 1), --this.size, !0;
  }
  return Pr = n, Pr;
}
var Or, Nu;
function jg() {
  if (Nu) return Or;
  Nu = 1;
  var e = Tt();
  function t(r) {
    var n = this.__data__, a = e(n, r);
    return a < 0 ? void 0 : n[a][1];
  }
  return Or = t, Or;
}
var Er, Uu;
function Bg() {
  if (Uu) return Er;
  Uu = 1;
  var e = Tt();
  function t(r) {
    return e(this.__data__, r) > -1;
  }
  return Er = t, Er;
}
var Lr, Hu;
function Fg() {
  if (Hu) return Lr;
  Hu = 1;
  var e = Tt();
  function t(r, n) {
    var a = this.__data__, i = e(a, r);
    return i < 0 ? (++this.size, a.push([r, n])) : a[i][1] = n, this;
  }
  return Lr = t, Lr;
}
var Mr, Gu;
function Rt() {
  if (Gu) return Mr;
  Gu = 1;
  var e = Mg(), t = Dg(), r = jg(), n = Bg(), a = Fg();
  function i(s) {
    var o = -1, u = s == null ? 0 : s.length;
    for (this.clear(); ++o < u; ) {
      var l = s[o];
      this.set(l[0], l[1]);
    }
  }
  return i.prototype.clear = e, i.prototype.delete = t, i.prototype.get = r, i.prototype.has = n, i.prototype.set = a, Mr = i, Mr;
}
var Dr, zu;
function Ng() {
  if (zu) return Dr;
  zu = 1;
  var e = Rt();
  function t() {
    this.__data__ = new e(), this.size = 0;
  }
  return Dr = t, Dr;
}
var jr, Vu;
function Ug() {
  if (Vu) return jr;
  Vu = 1;
  function e(t) {
    var r = this.__data__, n = r.delete(t);
    return this.size = r.size, n;
  }
  return jr = e, jr;
}
var Br, Wu;
function Hg() {
  if (Wu) return Br;
  Wu = 1;
  function e(t) {
    return this.__data__.get(t);
  }
  return Br = e, Br;
}
var Fr, Ku;
function Gg() {
  if (Ku) return Fr;
  Ku = 1;
  function e(t) {
    return this.__data__.has(t);
  }
  return Fr = e, Fr;
}
var Nr, Xu;
function zg() {
  if (Xu) return Nr;
  Xu = 1;
  var e = be(), t = e["__core-js_shared__"];
  return Nr = t, Nr;
}
var Ur, Yu;
function Vg() {
  if (Yu) return Ur;
  Yu = 1;
  var e = zg(), t = function() {
    var n = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
    return n ? "Symbol(src)_1." + n : "";
  }();
  function r(n) {
    return !!t && t in n;
  }
  return Ur = r, Ur;
}
var Hr, Ju;
function Qh() {
  if (Ju) return Hr;
  Ju = 1;
  var e = Function.prototype, t = e.toString;
  function r(n) {
    if (n != null) {
      try {
        return t.call(n);
      } catch {
      }
      try {
        return n + "";
      } catch {
      }
    }
    return "";
  }
  return Hr = r, Hr;
}
var Gr, Zu;
function Wg() {
  if (Zu) return Gr;
  Zu = 1;
  var e = qo(), t = Vg(), r = rt(), n = Qh(), a = /[\\^$.*+?()[\]{}|]/g, i = /^\[object .+?Constructor\]$/, s = Function.prototype, o = Object.prototype, u = s.toString, l = o.hasOwnProperty, d = RegExp(
    "^" + u.call(l).replace(a, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function c(f) {
    if (!r(f) || t(f))
      return !1;
    var h = e(f) ? d : i;
    return h.test(n(f));
  }
  return Gr = c, Gr;
}
var zr, Qu;
function Kg() {
  if (Qu) return zr;
  Qu = 1;
  function e(t, r) {
    return t == null ? void 0 : t[r];
  }
  return zr = e, zr;
}
var Vr, el;
function ke() {
  if (el) return Vr;
  el = 1;
  var e = Wg(), t = Kg();
  function r(n, a) {
    var i = t(n, a);
    return e(i) ? i : void 0;
  }
  return Vr = r, Vr;
}
var Wr, tl;
function Ro() {
  if (tl) return Wr;
  tl = 1;
  var e = ke(), t = be(), r = e(t, "Map");
  return Wr = r, Wr;
}
var Kr, rl;
function At() {
  if (rl) return Kr;
  rl = 1;
  var e = ke(), t = e(Object, "create");
  return Kr = t, Kr;
}
var Xr, nl;
function Xg() {
  if (nl) return Xr;
  nl = 1;
  var e = At();
  function t() {
    this.__data__ = e ? e(null) : {}, this.size = 0;
  }
  return Xr = t, Xr;
}
var Yr, al;
function Yg() {
  if (al) return Yr;
  al = 1;
  function e(t) {
    var r = this.has(t) && delete this.__data__[t];
    return this.size -= r ? 1 : 0, r;
  }
  return Yr = e, Yr;
}
var Jr, il;
function Jg() {
  if (il) return Jr;
  il = 1;
  var e = At(), t = "__lodash_hash_undefined__", r = Object.prototype, n = r.hasOwnProperty;
  function a(i) {
    var s = this.__data__;
    if (e) {
      var o = s[i];
      return o === t ? void 0 : o;
    }
    return n.call(s, i) ? s[i] : void 0;
  }
  return Jr = a, Jr;
}
var Zr, sl;
function Zg() {
  if (sl) return Zr;
  sl = 1;
  var e = At(), t = Object.prototype, r = t.hasOwnProperty;
  function n(a) {
    var i = this.__data__;
    return e ? i[a] !== void 0 : r.call(i, a);
  }
  return Zr = n, Zr;
}
var Qr, ol;
function Qg() {
  if (ol) return Qr;
  ol = 1;
  var e = At(), t = "__lodash_hash_undefined__";
  function r(n, a) {
    var i = this.__data__;
    return this.size += this.has(n) ? 0 : 1, i[n] = e && a === void 0 ? t : a, this;
  }
  return Qr = r, Qr;
}
var en, ul;
function e_() {
  if (ul) return en;
  ul = 1;
  var e = Xg(), t = Yg(), r = Jg(), n = Zg(), a = Qg();
  function i(s) {
    var o = -1, u = s == null ? 0 : s.length;
    for (this.clear(); ++o < u; ) {
      var l = s[o];
      this.set(l[0], l[1]);
    }
  }
  return i.prototype.clear = e, i.prototype.delete = t, i.prototype.get = r, i.prototype.has = n, i.prototype.set = a, en = i, en;
}
var tn, ll;
function t_() {
  if (ll) return tn;
  ll = 1;
  var e = e_(), t = Rt(), r = Ro();
  function n() {
    this.size = 0, this.__data__ = {
      hash: new e(),
      map: new (r || t)(),
      string: new e()
    };
  }
  return tn = n, tn;
}
var rn, cl;
function r_() {
  if (cl) return rn;
  cl = 1;
  function e(t) {
    var r = typeof t;
    return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? t !== "__proto__" : t === null;
  }
  return rn = e, rn;
}
var nn, dl;
function kt() {
  if (dl) return nn;
  dl = 1;
  var e = r_();
  function t(r, n) {
    var a = r.__data__;
    return e(n) ? a[typeof n == "string" ? "string" : "hash"] : a.map;
  }
  return nn = t, nn;
}
var an, fl;
function n_() {
  if (fl) return an;
  fl = 1;
  var e = kt();
  function t(r) {
    var n = e(this, r).delete(r);
    return this.size -= n ? 1 : 0, n;
  }
  return an = t, an;
}
var sn, hl;
function a_() {
  if (hl) return sn;
  hl = 1;
  var e = kt();
  function t(r) {
    return e(this, r).get(r);
  }
  return sn = t, sn;
}
var on, vl;
function i_() {
  if (vl) return on;
  vl = 1;
  var e = kt();
  function t(r) {
    return e(this, r).has(r);
  }
  return on = t, on;
}
var un, pl;
function s_() {
  if (pl) return un;
  pl = 1;
  var e = kt();
  function t(r, n) {
    var a = e(this, r), i = a.size;
    return a.set(r, n), this.size += a.size == i ? 0 : 1, this;
  }
  return un = t, un;
}
var ln, gl;
function Ao() {
  if (gl) return ln;
  gl = 1;
  var e = t_(), t = n_(), r = a_(), n = i_(), a = s_();
  function i(s) {
    var o = -1, u = s == null ? 0 : s.length;
    for (this.clear(); ++o < u; ) {
      var l = s[o];
      this.set(l[0], l[1]);
    }
  }
  return i.prototype.clear = e, i.prototype.delete = t, i.prototype.get = r, i.prototype.has = n, i.prototype.set = a, ln = i, ln;
}
var cn, _l;
function o_() {
  if (_l) return cn;
  _l = 1;
  var e = Rt(), t = Ro(), r = Ao(), n = 200;
  function a(i, s) {
    var o = this.__data__;
    if (o instanceof e) {
      var u = o.__data__;
      if (!t || u.length < n - 1)
        return u.push([i, s]), this.size = ++o.size, this;
      o = this.__data__ = new r(u);
    }
    return o.set(i, s), this.size = o.size, this;
  }
  return cn = a, cn;
}
var dn, ml;
function ev() {
  if (ml) return dn;
  ml = 1;
  var e = Rt(), t = Ng(), r = Ug(), n = Hg(), a = Gg(), i = o_();
  function s(o) {
    var u = this.__data__ = new e(o);
    this.size = u.size;
  }
  return s.prototype.clear = t, s.prototype.delete = r, s.prototype.get = n, s.prototype.has = a, s.prototype.set = i, dn = s, dn;
}
var fn, yl;
function u_() {
  if (yl) return fn;
  yl = 1;
  var e = "__lodash_hash_undefined__";
  function t(r) {
    return this.__data__.set(r, e), this;
  }
  return fn = t, fn;
}
var hn, bl;
function l_() {
  if (bl) return hn;
  bl = 1;
  function e(t) {
    return this.__data__.has(t);
  }
  return hn = e, hn;
}
var vn, Cl;
function tv() {
  if (Cl) return vn;
  Cl = 1;
  var e = Ao(), t = u_(), r = l_();
  function n(a) {
    var i = -1, s = a == null ? 0 : a.length;
    for (this.__data__ = new e(); ++i < s; )
      this.add(a[i]);
  }
  return n.prototype.add = n.prototype.push = t, n.prototype.has = r, vn = n, vn;
}
var pn, Sl;
function c_() {
  if (Sl) return pn;
  Sl = 1;
  function e(t, r) {
    for (var n = -1, a = t == null ? 0 : t.length; ++n < a; )
      if (r(t[n], n, t))
        return !0;
    return !1;
  }
  return pn = e, pn;
}
var gn, ql;
function rv() {
  if (ql) return gn;
  ql = 1;
  function e(t, r) {
    return t.has(r);
  }
  return gn = e, gn;
}
var _n, wl;
function nv() {
  if (wl) return _n;
  wl = 1;
  var e = tv(), t = c_(), r = rv(), n = 1, a = 2;
  function i(s, o, u, l, d, c) {
    var f = u & n, h = s.length, g = o.length;
    if (h != g && !(f && g > h))
      return !1;
    var p = c.get(s), m = c.get(o);
    if (p && m)
      return p == o && m == s;
    var C = -1, y = !0, A = u & a ? new e() : void 0;
    for (c.set(s, o), c.set(o, s); ++C < h; ) {
      var S = s[C], k = o[C];
      if (l)
        var T = f ? l(k, S, C, o, s, c) : l(S, k, C, s, o, c);
      if (T !== void 0) {
        if (T)
          continue;
        y = !1;
        break;
      }
      if (A) {
        if (!t(o, function($, M) {
          if (!r(A, M) && (S === $ || d(S, $, u, l, c)))
            return A.push(M);
        })) {
          y = !1;
          break;
        }
      } else if (!(S === k || d(S, k, u, l, c))) {
        y = !1;
        break;
      }
    }
    return c.delete(s), c.delete(o), y;
  }
  return _n = i, _n;
}
var mn, $l;
function d_() {
  if ($l) return mn;
  $l = 1;
  var e = be(), t = e.Uint8Array;
  return mn = t, mn;
}
var yn, Tl;
function f_() {
  if (Tl) return yn;
  Tl = 1;
  function e(t) {
    var r = -1, n = Array(t.size);
    return t.forEach(function(a, i) {
      n[++r] = [i, a];
    }), n;
  }
  return yn = e, yn;
}
var bn, Rl;
function h_() {
  if (Rl) return bn;
  Rl = 1;
  function e(t) {
    var r = -1, n = Array(t.size);
    return t.forEach(function(a) {
      n[++r] = a;
    }), n;
  }
  return bn = e, bn;
}
var Cn, Al;
function v_() {
  if (Al) return Cn;
  Al = 1;
  var e = tt(), t = d_(), r = Zh(), n = nv(), a = f_(), i = h_(), s = 1, o = 2, u = "[object Boolean]", l = "[object Date]", d = "[object Error]", c = "[object Map]", f = "[object Number]", h = "[object RegExp]", g = "[object Set]", p = "[object String]", m = "[object Symbol]", C = "[object ArrayBuffer]", y = "[object DataView]", A = e ? e.prototype : void 0, S = A ? A.valueOf : void 0;
  function k(T, $, M, j, F, R, V) {
    switch (M) {
      case y:
        if (T.byteLength != $.byteLength || T.byteOffset != $.byteOffset)
          return !1;
        T = T.buffer, $ = $.buffer;
      case C:
        return !(T.byteLength != $.byteLength || !R(new t(T), new t($)));
      case u:
      case l:
      case f:
        return r(+T, +$);
      case d:
        return T.name == $.name && T.message == $.message;
      case h:
      case p:
        return T == $ + "";
      case c:
        var H = a;
      case g:
        var ee = j & s;
        if (H || (H = i), T.size != $.size && !ee)
          return !1;
        var Z = V.get(T);
        if (Z)
          return Z == $;
        j |= o, V.set(T, $);
        var _e = n(H(T), H($), j, F, R, V);
        return V.delete(T), _e;
      case m:
        if (S)
          return S.call(T) == S.call($);
    }
    return !1;
  }
  return Cn = k, Cn;
}
var Sn, kl;
function av() {
  if (kl) return Sn;
  kl = 1;
  function e(t, r) {
    for (var n = -1, a = r.length, i = t.length; ++n < a; )
      t[i + n] = r[n];
    return t;
  }
  return Sn = e, Sn;
}
var qn, Il;
function p_() {
  if (Il) return qn;
  Il = 1;
  var e = av(), t = de();
  function r(n, a, i) {
    var s = a(n);
    return t(n) ? s : e(s, i(n));
  }
  return qn = r, qn;
}
var wn, xl;
function g_() {
  if (xl) return wn;
  xl = 1;
  function e() {
    return [];
  }
  return wn = e, wn;
}
var $n, Pl;
function __() {
  if (Pl) return $n;
  Pl = 1;
  var e = Vh(), t = g_(), r = Object.prototype, n = r.propertyIsEnumerable, a = Object.getOwnPropertySymbols, i = a ? function(s) {
    return s == null ? [] : (s = Object(s), e(a(s), function(o) {
      return n.call(s, o);
    }));
  } : t;
  return $n = i, $n;
}
var Tn, Ol;
function m_() {
  if (Ol) return Tn;
  Ol = 1;
  var e = p_(), t = __(), r = $t();
  function n(a) {
    return e(a, r, t);
  }
  return Tn = n, Tn;
}
var Rn, El;
function y_() {
  if (El) return Rn;
  El = 1;
  var e = m_(), t = 1, r = Object.prototype, n = r.hasOwnProperty;
  function a(i, s, o, u, l, d) {
    var c = o & t, f = e(i), h = f.length, g = e(s), p = g.length;
    if (h != p && !c)
      return !1;
    for (var m = h; m--; ) {
      var C = f[m];
      if (!(c ? C in s : n.call(s, C)))
        return !1;
    }
    var y = d.get(i), A = d.get(s);
    if (y && A)
      return y == s && A == i;
    var S = !0;
    d.set(i, s), d.set(s, i);
    for (var k = c; ++m < h; ) {
      C = f[m];
      var T = i[C], $ = s[C];
      if (u)
        var M = c ? u($, T, C, s, i, d) : u(T, $, C, i, s, d);
      if (!(M === void 0 ? T === $ || l(T, $, o, u, d) : M)) {
        S = !1;
        break;
      }
      k || (k = C == "constructor");
    }
    if (S && !k) {
      var j = i.constructor, F = s.constructor;
      j != F && "constructor" in i && "constructor" in s && !(typeof j == "function" && j instanceof j && typeof F == "function" && F instanceof F) && (S = !1);
    }
    return d.delete(i), d.delete(s), S;
  }
  return Rn = a, Rn;
}
var An, Ll;
function b_() {
  if (Ll) return An;
  Ll = 1;
  var e = ke(), t = be(), r = e(t, "DataView");
  return An = r, An;
}
var kn, Ml;
function C_() {
  if (Ml) return kn;
  Ml = 1;
  var e = ke(), t = be(), r = e(t, "Promise");
  return kn = r, kn;
}
var In, Dl;
function S_() {
  if (Dl) return In;
  Dl = 1;
  var e = ke(), t = be(), r = e(t, "Set");
  return In = r, In;
}
var xn, jl;
function q_() {
  if (jl) return xn;
  jl = 1;
  var e = ke(), t = be(), r = e(t, "WeakMap");
  return xn = r, xn;
}
var Pn, Bl;
function iv() {
  if (Bl) return Pn;
  Bl = 1;
  var e = b_(), t = Ro(), r = C_(), n = S_(), a = q_(), i = Ae(), s = Qh(), o = "[object Map]", u = "[object Object]", l = "[object Promise]", d = "[object Set]", c = "[object WeakMap]", f = "[object DataView]", h = s(e), g = s(t), p = s(r), m = s(n), C = s(a), y = i;
  return (e && y(new e(new ArrayBuffer(1))) != f || t && y(new t()) != o || r && y(r.resolve()) != l || n && y(new n()) != d || a && y(new a()) != c) && (y = function(A) {
    var S = i(A), k = S == u ? A.constructor : void 0, T = k ? s(k) : "";
    if (T)
      switch (T) {
        case h:
          return f;
        case g:
          return o;
        case p:
          return l;
        case m:
          return d;
        case C:
          return c;
      }
    return S;
  }), Pn = y, Pn;
}
var On, Fl;
function w_() {
  if (Fl) return On;
  Fl = 1;
  var e = ev(), t = nv(), r = v_(), n = y_(), a = iv(), i = de(), s = wo(), o = To(), u = 1, l = "[object Arguments]", d = "[object Array]", c = "[object Object]", f = Object.prototype, h = f.hasOwnProperty;
  function g(p, m, C, y, A, S) {
    var k = i(p), T = i(m), $ = k ? d : a(p), M = T ? d : a(m);
    $ = $ == l ? c : $, M = M == l ? c : M;
    var j = $ == c, F = M == c, R = $ == M;
    if (R && s(p)) {
      if (!s(m))
        return !1;
      k = !0, j = !1;
    }
    if (R && !j)
      return S || (S = new e()), k || o(p) ? t(p, m, C, y, A, S) : r(p, m, $, C, y, A, S);
    if (!(C & u)) {
      var V = j && h.call(p, "__wrapped__"), H = F && h.call(m, "__wrapped__");
      if (V || H) {
        var ee = V ? p.value() : p, Z = H ? m.value() : m;
        return S || (S = new e()), A(ee, Z, C, y, S);
      }
    }
    return R ? (S || (S = new e()), n(p, m, C, y, A, S)) : !1;
  }
  return On = g, On;
}
var En, Nl;
function sv() {
  if (Nl) return En;
  Nl = 1;
  var e = w_(), t = we();
  function r(n, a, i, s, o) {
    return n === a ? !0 : n == null || a == null || !t(n) && !t(a) ? n !== n && a !== a : e(n, a, i, s, r, o);
  }
  return En = r, En;
}
var Ln, Ul;
function $_() {
  if (Ul) return Ln;
  Ul = 1;
  var e = ev(), t = sv(), r = 1, n = 2;
  function a(i, s, o, u) {
    var l = o.length, d = l, c = !u;
    if (i == null)
      return !d;
    for (i = Object(i); l--; ) {
      var f = o[l];
      if (c && f[2] ? f[1] !== i[f[0]] : !(f[0] in i))
        return !1;
    }
    for (; ++l < d; ) {
      f = o[l];
      var h = f[0], g = i[h], p = f[1];
      if (c && f[2]) {
        if (g === void 0 && !(h in i))
          return !1;
      } else {
        var m = new e();
        if (u)
          var C = u(g, p, h, i, s, m);
        if (!(C === void 0 ? t(p, g, r | n, u, m) : C))
          return !1;
      }
    }
    return !0;
  }
  return Ln = a, Ln;
}
var Mn, Hl;
function ov() {
  if (Hl) return Mn;
  Hl = 1;
  var e = rt();
  function t(r) {
    return r === r && !e(r);
  }
  return Mn = t, Mn;
}
var Dn, Gl;
function T_() {
  if (Gl) return Dn;
  Gl = 1;
  var e = ov(), t = $t();
  function r(n) {
    for (var a = t(n), i = a.length; i--; ) {
      var s = a[i], o = n[s];
      a[i] = [s, o, e(o)];
    }
    return a;
  }
  return Dn = r, Dn;
}
var jn, zl;
function uv() {
  if (zl) return jn;
  zl = 1;
  function e(t, r) {
    return function(n) {
      return n == null ? !1 : n[t] === r && (r !== void 0 || t in Object(n));
    };
  }
  return jn = e, jn;
}
var Bn, Vl;
function R_() {
  if (Vl) return Bn;
  Vl = 1;
  var e = $_(), t = T_(), r = uv();
  function n(a) {
    var i = t(a);
    return i.length == 1 && i[0][2] ? r(i[0][0], i[0][1]) : function(s) {
      return s === a || e(s, a, i);
    };
  }
  return Bn = n, Bn;
}
var Fn, Wl;
function It() {
  if (Wl) return Fn;
  Wl = 1;
  var e = Ae(), t = we(), r = "[object Symbol]";
  function n(a) {
    return typeof a == "symbol" || t(a) && e(a) == r;
  }
  return Fn = n, Fn;
}
var Nn, Kl;
function ko() {
  if (Kl) return Nn;
  Kl = 1;
  var e = de(), t = It(), r = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, n = /^\w*$/;
  function a(i, s) {
    if (e(i))
      return !1;
    var o = typeof i;
    return o == "number" || o == "symbol" || o == "boolean" || i == null || t(i) ? !0 : n.test(i) || !r.test(i) || s != null && i in Object(s);
  }
  return Nn = a, Nn;
}
var Un, Xl;
function A_() {
  if (Xl) return Un;
  Xl = 1;
  var e = Ao(), t = "Expected a function";
  function r(n, a) {
    if (typeof n != "function" || a != null && typeof a != "function")
      throw new TypeError(t);
    var i = function() {
      var s = arguments, o = a ? a.apply(this, s) : s[0], u = i.cache;
      if (u.has(o))
        return u.get(o);
      var l = n.apply(this, s);
      return i.cache = u.set(o, l) || u, l;
    };
    return i.cache = new (r.Cache || e)(), i;
  }
  return r.Cache = e, Un = r, Un;
}
var Hn, Yl;
function k_() {
  if (Yl) return Hn;
  Yl = 1;
  var e = A_(), t = 500;
  function r(n) {
    var a = e(n, function(s) {
      return i.size === t && i.clear(), s;
    }), i = a.cache;
    return a;
  }
  return Hn = r, Hn;
}
var Gn, Jl;
function I_() {
  if (Jl) return Gn;
  Jl = 1;
  var e = k_(), t = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, r = /\\(\\)?/g, n = e(function(a) {
    var i = [];
    return a.charCodeAt(0) === 46 && i.push(""), a.replace(t, function(s, o, u, l) {
      i.push(u ? l.replace(r, "$1") : o || s);
    }), i;
  });
  return Gn = n, Gn;
}
var zn, Zl;
function Io() {
  if (Zl) return zn;
  Zl = 1;
  function e(t, r) {
    for (var n = -1, a = t == null ? 0 : t.length, i = Array(a); ++n < a; )
      i[n] = r(t[n], n, t);
    return i;
  }
  return zn = e, zn;
}
var Vn, Ql;
function lv() {
  if (Ql) return Vn;
  Ql = 1;
  var e = tt(), t = Io(), r = de(), n = It(), a = e ? e.prototype : void 0, i = a ? a.toString : void 0;
  function s(o) {
    if (typeof o == "string")
      return o;
    if (r(o))
      return t(o, s) + "";
    if (n(o))
      return i ? i.call(o) : "";
    var u = o + "";
    return u == "0" && 1 / o == -1 / 0 ? "-0" : u;
  }
  return Vn = s, Vn;
}
var Wn, ec;
function cv() {
  if (ec) return Wn;
  ec = 1;
  var e = lv();
  function t(r) {
    return r == null ? "" : e(r);
  }
  return Wn = t, Wn;
}
var Kn, tc;
function dv() {
  if (tc) return Kn;
  tc = 1;
  var e = de(), t = ko(), r = I_(), n = cv();
  function a(i, s) {
    return e(i) ? i : t(i, s) ? [i] : r(n(i));
  }
  return Kn = a, Kn;
}
var Xn, rc;
function xt() {
  if (rc) return Xn;
  rc = 1;
  var e = It();
  function t(r) {
    if (typeof r == "string" || e(r))
      return r;
    var n = r + "";
    return n == "0" && 1 / r == -1 / 0 ? "-0" : n;
  }
  return Xn = t, Xn;
}
var Yn, nc;
function fv() {
  if (nc) return Yn;
  nc = 1;
  var e = dv(), t = xt();
  function r(n, a) {
    a = e(a, n);
    for (var i = 0, s = a.length; n != null && i < s; )
      n = n[t(a[i++])];
    return i && i == s ? n : void 0;
  }
  return Yn = r, Yn;
}
var Jn, ac;
function hv() {
  if (ac) return Jn;
  ac = 1;
  var e = fv();
  function t(r, n, a) {
    var i = r == null ? void 0 : e(r, n);
    return i === void 0 ? a : i;
  }
  return Jn = t, Jn;
}
var Zn, ic;
function x_() {
  if (ic) return Zn;
  ic = 1;
  function e(t, r) {
    return t != null && r in Object(t);
  }
  return Zn = e, Zn;
}
var Qn, sc;
function P_() {
  if (sc) return Qn;
  sc = 1;
  var e = dv(), t = wt(), r = de(), n = Wh(), a = $o(), i = xt();
  function s(o, u, l) {
    u = e(u, o);
    for (var d = -1, c = u.length, f = !1; ++d < c; ) {
      var h = i(u[d]);
      if (!(f = o != null && l(o, h)))
        break;
      o = o[h];
    }
    return f || ++d != c ? f : (c = o == null ? 0 : o.length, !!c && a(c) && n(h, c) && (r(o) || t(o)));
  }
  return Qn = s, Qn;
}
var ea, oc;
function O_() {
  if (oc) return ea;
  oc = 1;
  var e = x_(), t = P_();
  function r(n, a) {
    return n != null && t(n, a, e);
  }
  return ea = r, ea;
}
var ta, uc;
function E_() {
  if (uc) return ta;
  uc = 1;
  var e = sv(), t = hv(), r = O_(), n = ko(), a = ov(), i = uv(), s = xt(), o = 1, u = 2;
  function l(d, c) {
    return n(d) && a(c) ? i(s(d), c) : function(f) {
      var h = t(f, d);
      return h === void 0 && h === c ? r(f, d) : e(c, h, o | u);
    };
  }
  return ta = l, ta;
}
var ra, lc;
function xo() {
  if (lc) return ra;
  lc = 1;
  function e(t) {
    return t;
  }
  return ra = e, ra;
}
var na, cc;
function L_() {
  if (cc) return na;
  cc = 1;
  function e(t) {
    return function(r) {
      return r == null ? void 0 : r[t];
    };
  }
  return na = e, na;
}
var aa, dc;
function M_() {
  if (dc) return aa;
  dc = 1;
  var e = fv();
  function t(r) {
    return function(n) {
      return e(n, r);
    };
  }
  return aa = t, aa;
}
var ia, fc;
function D_() {
  if (fc) return ia;
  fc = 1;
  var e = L_(), t = M_(), r = ko(), n = xt();
  function a(i) {
    return r(i) ? e(n(i)) : t(i);
  }
  return ia = a, ia;
}
var sa, hc;
function vv() {
  if (hc) return sa;
  hc = 1;
  var e = R_(), t = E_(), r = xo(), n = de(), a = D_();
  function i(s) {
    return typeof s == "function" ? s : s == null ? r : typeof s == "object" ? n(s) ? t(s[0], s[1]) : e(s) : a(s);
  }
  return sa = i, sa;
}
var oa, vc;
function j_() {
  if (vc) return oa;
  vc = 1;
  var e = Vh(), t = Lg(), r = vv(), n = de();
  function a(i, s) {
    var o = n(i) ? e : t;
    return o(i, r(s, 3));
  }
  return oa = a, oa;
}
var B_ = j_();
const F_ = /* @__PURE__ */ ce(B_);
var N_ = hv();
const pt = /* @__PURE__ */ ce(N_);
var U_ = $t();
const H_ = /* @__PURE__ */ ce(U_);
var ua, pc;
function G_() {
  if (pc) return ua;
  pc = 1;
  var e = Jh(), t = nt();
  function r(n, a) {
    var i = -1, s = t(n) ? Array(n.length) : [];
    return e(n, function(o, u, l) {
      s[++i] = a(o, u, l);
    }), s;
  }
  return ua = r, ua;
}
var la, gc;
function z_() {
  if (gc) return la;
  gc = 1;
  var e = Io(), t = vv(), r = G_(), n = de();
  function a(i, s) {
    var o = n(i) ? e : r;
    return o(i, t(s, 3));
  }
  return la = a, la;
}
var V_ = z_();
const W_ = /* @__PURE__ */ ce(V_);
var ca, _c;
function K_() {
  if (_c) return ca;
  _c = 1;
  var e = Yh(), t = iv(), r = wt(), n = de(), a = nt(), i = wo(), s = Xh(), o = To(), u = "[object Map]", l = "[object Set]", d = Object.prototype, c = d.hasOwnProperty;
  function f(h) {
    if (h == null)
      return !0;
    if (a(h) && (n(h) || typeof h == "string" || typeof h.splice == "function" || i(h) || o(h) || r(h)))
      return !h.length;
    var g = t(h);
    if (g == u || g == l)
      return !h.size;
    if (s(h))
      return !e(h).length;
    for (var p in h)
      if (c.call(h, p))
        return !1;
    return !0;
  }
  return ca = f, ca;
}
var X_ = K_();
const Y_ = /* @__PURE__ */ ce(X_);
var da, mc;
function J_() {
  if (mc) return da;
  mc = 1;
  var e = Ae(), t = de(), r = we(), n = "[object String]";
  function a(i) {
    return typeof i == "string" || !t(i) && r(i) && e(i) == n;
  }
  return da = a, da;
}
var Z_ = J_();
const Q_ = /* @__PURE__ */ ce(Z_);
var fa, yc;
function e1() {
  if (yc) return fa;
  yc = 1;
  var e = "Expected a function";
  function t(r, n, a) {
    if (typeof r != "function")
      throw new TypeError(e);
    return setTimeout(function() {
      r.apply(void 0, a);
    }, n);
  }
  return fa = t, fa;
}
var ha, bc;
function t1() {
  if (bc) return ha;
  bc = 1;
  function e(t, r, n) {
    switch (n.length) {
      case 0:
        return t.call(r);
      case 1:
        return t.call(r, n[0]);
      case 2:
        return t.call(r, n[0], n[1]);
      case 3:
        return t.call(r, n[0], n[1], n[2]);
    }
    return t.apply(r, n);
  }
  return ha = e, ha;
}
var va, Cc;
function r1() {
  if (Cc) return va;
  Cc = 1;
  var e = t1(), t = Math.max;
  function r(n, a, i) {
    return a = t(a === void 0 ? n.length - 1 : a, 0), function() {
      for (var s = arguments, o = -1, u = t(s.length - a, 0), l = Array(u); ++o < u; )
        l[o] = s[a + o];
      o = -1;
      for (var d = Array(a + 1); ++o < a; )
        d[o] = s[o];
      return d[a] = i(l), e(n, this, d);
    };
  }
  return va = r, va;
}
var pa, Sc;
function n1() {
  if (Sc) return pa;
  Sc = 1;
  function e(t) {
    return function() {
      return t;
    };
  }
  return pa = e, pa;
}
var ga, qc;
function a1() {
  if (qc) return ga;
  qc = 1;
  var e = ke(), t = function() {
    try {
      var r = e(Object, "defineProperty");
      return r({}, "", {}), r;
    } catch {
    }
  }();
  return ga = t, ga;
}
var _a, wc;
function i1() {
  if (wc) return _a;
  wc = 1;
  var e = n1(), t = a1(), r = xo(), n = t ? function(a, i) {
    return t(a, "toString", {
      configurable: !0,
      enumerable: !1,
      value: e(i),
      writable: !0
    });
  } : r;
  return _a = n, _a;
}
var ma, $c;
function s1() {
  if ($c) return ma;
  $c = 1;
  var e = 800, t = 16, r = Date.now;
  function n(a) {
    var i = 0, s = 0;
    return function() {
      var o = r(), u = t - (o - s);
      if (s = o, u > 0) {
        if (++i >= e)
          return arguments[0];
      } else
        i = 0;
      return a.apply(void 0, arguments);
    };
  }
  return ma = n, ma;
}
var ya, Tc;
function o1() {
  if (Tc) return ya;
  Tc = 1;
  var e = i1(), t = s1(), r = t(e);
  return ya = r, ya;
}
var ba, Rc;
function pv() {
  if (Rc) return ba;
  Rc = 1;
  var e = xo(), t = r1(), r = o1();
  function n(a, i) {
    return r(t(a, i, e), a + "");
  }
  return ba = n, ba;
}
var Ca, Ac;
function u1() {
  if (Ac) return Ca;
  Ac = 1;
  var e = /\s/;
  function t(r) {
    for (var n = r.length; n-- && e.test(r.charAt(n)); )
      ;
    return n;
  }
  return Ca = t, Ca;
}
var Sa, kc;
function l1() {
  if (kc) return Sa;
  kc = 1;
  var e = u1(), t = /^\s+/;
  function r(n) {
    return n && n.slice(0, e(n) + 1).replace(t, "");
  }
  return Sa = r, Sa;
}
var qa, Ic;
function gv() {
  if (Ic) return qa;
  Ic = 1;
  var e = l1(), t = rt(), r = It(), n = NaN, a = /^[-+]0x[0-9a-f]+$/i, i = /^0b[01]+$/i, s = /^0o[0-7]+$/i, o = parseInt;
  function u(l) {
    if (typeof l == "number")
      return l;
    if (r(l))
      return n;
    if (t(l)) {
      var d = typeof l.valueOf == "function" ? l.valueOf() : l;
      l = t(d) ? d + "" : d;
    }
    if (typeof l != "string")
      return l === 0 ? l : +l;
    l = e(l);
    var c = i.test(l);
    return c || s.test(l) ? o(l.slice(2), c ? 2 : 8) : a.test(l) ? n : +l;
  }
  return qa = u, qa;
}
var wa, xc;
function c1() {
  if (xc) return wa;
  xc = 1;
  var e = e1(), t = pv(), r = gv(), n = t(function(a, i, s) {
    return e(a, r(i) || 0, s);
  });
  return wa = n, wa;
}
var d1 = c1();
const f1 = /* @__PURE__ */ ce(d1);
var $a, Pc;
function h1() {
  if (Pc) return $a;
  Pc = 1;
  function e(t, r, n, a) {
    for (var i = t.length, s = n + (a ? 1 : -1); a ? s-- : ++s < i; )
      if (r(t[s], s, t))
        return s;
    return -1;
  }
  return $a = e, $a;
}
var Ta, Oc;
function v1() {
  if (Oc) return Ta;
  Oc = 1;
  function e(t) {
    return t !== t;
  }
  return Ta = e, Ta;
}
var Ra, Ec;
function p1() {
  if (Ec) return Ra;
  Ec = 1;
  function e(t, r, n) {
    for (var a = n - 1, i = t.length; ++a < i; )
      if (t[a] === r)
        return a;
    return -1;
  }
  return Ra = e, Ra;
}
var Aa, Lc;
function g1() {
  if (Lc) return Aa;
  Lc = 1;
  var e = h1(), t = v1(), r = p1();
  function n(a, i, s) {
    return i === i ? r(a, i, s) : e(a, t, s);
  }
  return Aa = n, Aa;
}
var ka, Mc;
function _1() {
  if (Mc) return ka;
  Mc = 1;
  var e = g1();
  function t(r, n) {
    var a = r == null ? 0 : r.length;
    return !!a && e(r, n, 0) > -1;
  }
  return ka = t, ka;
}
var Ia, Dc;
function m1() {
  if (Dc) return Ia;
  Dc = 1;
  function e(t, r, n) {
    for (var a = -1, i = t == null ? 0 : t.length; ++a < i; )
      if (n(r, t[a]))
        return !0;
    return !1;
  }
  return Ia = e, Ia;
}
var xa, jc;
function y1() {
  if (jc) return xa;
  jc = 1;
  var e = tv(), t = _1(), r = m1(), n = Io(), a = Kh(), i = rv(), s = 200;
  function o(u, l, d, c) {
    var f = -1, h = t, g = !0, p = u.length, m = [], C = l.length;
    if (!p)
      return m;
    d && (l = n(l, a(d))), c ? (h = r, g = !1) : l.length >= s && (h = i, g = !1, l = new e(l));
    e:
      for (; ++f < p; ) {
        var y = u[f], A = d == null ? y : d(y);
        if (y = c || y !== 0 ? y : 0, g && A === A) {
          for (var S = C; S--; )
            if (l[S] === A)
              continue e;
          m.push(y);
        } else h(l, A, c) || m.push(y);
      }
    return m;
  }
  return xa = o, xa;
}
var Pa, Bc;
function b1() {
  if (Bc) return Pa;
  Bc = 1;
  var e = tt(), t = wt(), r = de(), n = e ? e.isConcatSpreadable : void 0;
  function a(i) {
    return r(i) || t(i) || !!(n && i && i[n]);
  }
  return Pa = a, Pa;
}
var Oa, Fc;
function C1() {
  if (Fc) return Oa;
  Fc = 1;
  var e = av(), t = b1();
  function r(n, a, i, s, o) {
    var u = -1, l = n.length;
    for (i || (i = t), o || (o = []); ++u < l; ) {
      var d = n[u];
      a > 0 && i(d) ? a > 1 ? r(d, a - 1, i, s, o) : e(o, d) : s || (o[o.length] = d);
    }
    return o;
  }
  return Oa = r, Oa;
}
var Ea, Nc;
function S1() {
  if (Nc) return Ea;
  Nc = 1;
  var e = nt(), t = we();
  function r(n) {
    return t(n) && e(n);
  }
  return Ea = r, Ea;
}
var La, Uc;
function q1() {
  if (Uc) return La;
  Uc = 1;
  var e = y1(), t = C1(), r = pv(), n = S1(), a = r(function(i, s) {
    return n(i) ? e(i, t(s, 1, n, !0)) : [];
  });
  return La = a, La;
}
q1();
var Ma, Hc;
function w1() {
  if (Hc) return Ma;
  Hc = 1;
  function e(t, r, n) {
    return t === t && (n !== void 0 && (t = t <= n ? t : n), r !== void 0 && (t = t >= r ? t : r)), t;
  }
  return Ma = e, Ma;
}
var Da, Gc;
function $1() {
  if (Gc) return Da;
  Gc = 1;
  var e = gv(), t = 1 / 0, r = 17976931348623157e292;
  function n(a) {
    if (!a)
      return a === 0 ? a : 0;
    if (a = e(a), a === t || a === -1 / 0) {
      var i = a < 0 ? -1 : 1;
      return i * r;
    }
    return a === a ? a : 0;
  }
  return Da = n, Da;
}
var ja, zc;
function T1() {
  if (zc) return ja;
  zc = 1;
  var e = $1();
  function t(r) {
    var n = e(r), a = n % 1;
    return n === n ? a ? n - a : n : 0;
  }
  return ja = t, ja;
}
var Ba, Vc;
function R1() {
  if (Vc) return Ba;
  Vc = 1;
  var e = w1(), t = lv(), r = T1(), n = cv();
  function a(i, s, o) {
    i = n(i), s = t(s);
    var u = i.length;
    o = o === void 0 ? u : e(r(o), 0, u);
    var l = o;
    return o -= s.length, o >= 0 && i.slice(o, l) == s;
  }
  return Ba = a, Ba;
}
var A1 = R1();
const k1 = /* @__PURE__ */ ce(A1), pe = {
  SetSection: "SetSection",
  ClearSections: "ClearSections",
  // For go-back on reg sidebars; LLM code
  TrackScrollOrigin: "TrackScrollOrigin"
}, uo = {
  external: "Public",
  federal_register_link: "Public",
  public_link: "Public",
  reg_text: "Public",
  internal: "Internal",
  internal_file: "Internal",
  internal_link: "Internal",
  regulations: "Regulations"
}, I1 = (e) => {
  if (typeof e != "string" || !e.includes(".") || k1(e, "."))
    return null;
  const t = e.split(".").pop();
  return t.length > 4 || t.length < 2 || t.includes("pdf") ? null : t;
}, x1 = ({ fileName: e, uid: t }) => {
  const r = I1(e);
  let n;
  return e && r && (n = `<span data-testid='download-chip-${t}' class='result__link--file-type'>Download ${r.toUpperCase()}</span>`), `${n ?? ""}`;
}, ut = (e) => {
  console.info(e);
  const r = e.errors ? e.errors[Object.keys(e.errors)[0]][0] : e.message;
  try {
    const n = Object.keys(e.errors)[0], a = pt(e, "status"), i = pt(e, "requestId"), s = new Error(r);
    return s.code = n, s.requestId = i, s.root = e, s.status = a, s;
  } catch {
    return e.detail ? e : new Error(r);
  }
}, Wc = (e) => new Promise((t) => {
  f1(t, e * 1e3);
}), P1 = (e) => {
  if (zh(e) || Q_(e) && Y_(e)) return "N/A";
  const t = /* @__PURE__ */ new Date(`${e}T12:00:00.000-05:00`), r = t.toLocaleString("default", { month: "short" }), n = t.getDate(), a = t.getFullYear();
  return `${r} ${n}, ${a}`;
}, lo = ({
  resources: e = [],
  categories: t = [],
  apiUrl: r
}) => {
  const n = [...t];
  e.forEach((i) => {
    var s, o;
    if (i.type === "internal_file" && (i.url = `${r}resources/internal/files/${i.uid}`), ((s = i.category) == null ? void 0 : s.type) === "public_category" || ((o = i.category) == null ? void 0 : o.type) === "internal_category") {
      const u = n.find(
        (l) => l.name === i.category.name
      );
      if (u)
        u.supplemental_content || (u.supplemental_content = []), u.supplemental_content.push(i);
      else {
        const l = JSON.parse(
          JSON.stringify(i.category)
        );
        l.supplemental_content = [i], l.subcategories = [], n.push(l);
      }
    }
  }), e.forEach((i) => {
    var s, o;
    (((s = i.category) == null ? void 0 : s.type) === "public_subcategory" || ((o = i.category) == null ? void 0 : o.type) === "internal_subcategory") && n.forEach((u) => {
      u.subcategories && u.subcategories.forEach((l) => {
        l.name === i.category.name && (l.supplemental_content || (l.supplemental_content = []), l.supplemental_content.push(i));
      });
    });
  });
  const a = n.filter((i) => !!(i.supplemental_content || i.show_if_empty || i.subcategories && i.subcategories.some(
    (o) => o.supplemental_content
  ))).sort((i, s) => i.order - s.order);
  return a.forEach((i) => {
    i.subcategories.sort((s, o) => s.order - o.order);
  }), a;
}, O1 = (e) => {
  if (!e)
    return "Invalid Date";
  const t = new Date(e);
  if (t.toString() === "Invalid Date")
    return t.toString();
  const r = {
    year: "numeric",
    month: "long",
    day: "numeric",
    timeZone: "UTC"
  }, a = new Intl.DateTimeFormat("en-US", r).format(t), i = a.split(" ");
  if (i[0] && i[0].length > 4) {
    const o = i[0].slice(0, 3);
    return i[0] = o, i.join(" ");
  }
  return a;
}, E1 = (e) => {
  const t = e.flat(1).reduce(
    (r, n) => ({
      ...r,
      [n.name]: n
    }),
    {}
  );
  return Object.fromEntries(
    Object.entries(t).map((r) => [r[1].name, r[1].date])
  );
}, L1 = (e) => e.substring(1).split("-").slice(0, 2).join("-"), _v = (e) => e.flatMap((t) => t.type !== "section" ? _v(t.children) : t.identifier[1]), M1 = (e) => {
  var t;
  return e != null && e.withdrawal ? "WD" : e != null && e.correction ? "CORR" : (e == null ? void 0 : e.action_type) || ((t = e == null ? void 0 : e.category) == null ? void 0 : t.name) || (e == null ? void 0 : e.type);
};
let Fa = {
  fetchMode: "cors",
  maxRetryCount: 2
};
const co = ({
  url: e,
  options: t = {},
  retryCount: r = 0
}) => {
  let n = !1, a;
  const i = {
    Accept: "application/json",
    "Content-Type": "application/json"
  }, s = {}, o = {
    method: "GET",
    cache: "no-cache",
    mode: Fa.fetchMode,
    redirect: "follow",
    body: s,
    ...t,
    headers: { ...i, ...t.headers }
  };
  if (o.method === "GET" && delete o.body, o.params) {
    const u = H_(o.params), l = F_(
      u,
      (c) => !zh(pt(o.params, c))
    ), d = W_(
      l,
      (c) => `${encodeURIComponent(c)}=${encodeURIComponent(
        pt(o.params, c)
      )}`
    ).join("&");
    e = d ? `${e}?${d}` : e;
  }
  return Promise.resolve().then(() => fetch(e, o)).catch((u) => {
    if (r < Fa.maxRetryCount) {
      let l = r * r;
      return l < 1 && (l = 1), Promise.resolve().then(
        () => console.info(
          `Retrying count = ${r}, Backoff = ${l}`
        )
      ).then(() => Wc(l)).then(
        () => co({ url: e, options: t, retryCount: r + 1 })
      );
    }
    throw ut(u);
  }).then((u) => (n = u.ok, a = u.status, u)).then((u) => mg(u.text) ? u.text() : u).then((u) => {
    let l;
    try {
      Sg(u) ? l = u : l = JSON.parse(u);
    } catch {
      if (a >= 400) {
        if (a >= 501 && r < Fa.maxRetryCount) {
          let d = r * r;
          return d < 1 && (d = 1), Promise.resolve().then(
            () => console.info(
              `Retrying count = ${r}, Backoff = ${d}`
            )
          ).then(() => Wc(d)).then(
            () => co({
              url: e,
              options: t,
              retryCount: r + 1
            })
          );
        }
        throw ut({
          message: u,
          status: a
        });
      } else
        throw ut(
          new Error("The server did not return a json response.")
        );
    }
    return l;
  }).then((u) => {
    if (gg(n) && !n)
      throw ut({ ...u, status: a });
    return u;
  });
}, le = (e, { params: t } = {}) => co({
  url: `${e}`,
  options: {
    method: "GET",
    params: t
  },
  retryCount: 0
  // retryCount, default
}), D1 = async ({ apiUrl: e, title: t = "42" }) => {
  const r = await le(`${e}ecfr_parser_result/${t}`);
  return r.end ? P1(r.end.split("T")[0]) : "N/A";
}, j1 = async ({ title: e, apiUrl: t }) => le(e ? `${t}title/${e}/toc` : `${t}toc`), B1 = async ({ apiUrl: e, title: t, part: r, subPart: n }) => le(
  `${e}title/${t}/part/${r}/version/latest/subpart/${n}/toc`
), F1 = async ({ apiUrl: e, titles: t = ["42"] }) => {
  const r = await Promise.all(
    t.map((n) => le(`${e}title/${n}/parts`))
  );
  return E1(r);
}, N1 = async (e, { page: t = 1, pageSize: r = 3, type: n = "rules", categories: a }) => n !== "rules" ? le(
  `${e}resources/public/links?page=${t}&page_size=${r}${a}`,
  {}
  // params, default
) : le(
  `${e}resources/public/federal_register_links?page=${t}&page_size=${r}`,
  {}
  // params, default
), Na = async ({
  apiUrl: e = "",
  partDict: t,
  title: r,
  q: n = "",
  page: a = 1,
  pageSize: i = 100,
  sortMethod: s = "newest",
  builtCitationString: o = ""
}) => {
  const u = n ? `&q=${encodeURIComponent(n)}` : "";
  let l = "";
  return t === "all" ? l = r ? `${l}&citations=${r}` : "" : o !== "" ? l = `${l}&${o}` : Object.keys(t).forEach((d) => {
    const c = t[d];
    c.subparts.forEach((f) => {
      l = `${l}&citations=${c.title}.${d}.${f}`;
    }), c.sections.forEach((f) => {
      l = `${l}&citations=${c.title}.${d}.${f}`;
    }), c.sections.length === 0 && c.subparts.length === 0 && (l = `${l}&citations=${c.title}.${d}`);
  }), l = `${l}${u}&sort=${s}&page_size=${i}&page=${a}`, await le(`${e}resources/public?${l}`);
}, Po = async ({ apiUrl: e }) => le(`${e}titles`), U1 = async ({ apiUrl: e, filterParams: t = {} }) => await le(
  `${e}title/${t.title}/part/${t.part}/history/${Object.keys(t)[2]}/${Object.values(t)[2]}`
), H1 = async ({ title: e, apiUrl: t }) => le(`${t}title/${e}/parts`), G1 = async ({
  apiUrl: e
}) => le(
  `${e}resources/internal/categories?page_size=1000`,
  {}
), mv = async ({
  apiUrl: e
}) => le(
  `${e}resources/public/categories?page_size=1000`,
  {}
), z1 = async ({
  apiUrl: e,
  requestParams: t = ""
}) => le(
  `${e}resources/internal${t ? `?${t}` : ""}`,
  {}
), V1 = ["xs", "small", "medium", "large"], W1 = {
  name: "SimpleSpinner",
  props: {
    size: {
      validator: (e) => V1.includes(e),
      default: "medium"
    },
    filled: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    spinnerClasses() {
      return {
        "ds-c-spinner--filled": this.filled,
        "ds-c-spinner--small": this.size === "xs" || this.size === "small",
        "ds-c-spinner--big": this.size === "large"
      };
    },
    spinnerStyles() {
      switch (this.size) {
        case "xs":
          return "margin: 0px";
        case "small":
          return "margin: 4px";
        default:
          return "margin: 8px";
      }
    }
  }
}, K1 = { class: "ds-u-display--flex ds-u-justify-content--center ds-u-align-items--center loading-spinner" };
function X1(e, t, r, n, a, i) {
  return v(), _("div", K1, [
    b("span", {
      class: G(["ds-c-spinner", i.spinnerClasses]),
      style: ht(i.spinnerStyles),
      role: "status"
    }, t[0] || (t[0] = [
      b("span", { class: "ds-u-visibility--screen-reader" }, "Loading", -1)
    ]), 6)
  ]);
}
const Fe = /* @__PURE__ */ z(W1, [["render", X1]]), yv = (e) => {
  if (e.type !== "Final")
    return {
      "secondary-indicator": e.type !== "WD",
      "tertiary-indicator": e.type === "WD"
    };
}, Y1 = {
  getIndicatorClasses: yv
}, J1 = /* @__PURE__ */ Object.assign(Y1, {
  __name: "IndicatorLabel",
  props: {
    type: {
      type: String,
      required: !0
    }
  },
  setup(e) {
    const t = e, r = w(() => yv(t));
    return (n, a) => (v(), _("span", {
      class: G(["recent-flag indicator", r.value])
    }, I(e.type), 3));
  }
}), Z1 = {
  name: "RelatedRule",
  components: {
    IndicatorLabel: J1
  },
  inject: {
    itemTitleLineLimit: { default: 9 }
  },
  methods: {
    formatPubDate(e) {
      return O1(e);
    }
  },
  props: {
    title: {
      type: String,
      required: !0
    },
    type: {
      type: String,
      required: !0
    },
    grouped: {
      type: Boolean,
      required: !1,
      default: !1
    },
    citation: {
      type: String,
      required: !0
    },
    publication_date: {
      type: String,
      default: void 0
    },
    document_number: {
      type: String,
      required: !0
    },
    html_url: {
      type: String,
      required: !0
    },
    action: {
      type: String,
      default: void 0
    }
  },
  computed: {
    ruleClasses() {
      return {
        grouped: this.grouped,
        ungrouped: !this.grouped
      };
    },
    citationClasses() {
      return {
        grouped: this.grouped
      };
    },
    recentTitleClass() {
      return `line-clamp-${this.itemTitleLineLimit}`;
    }
  }
}, Q1 = ["href"], em = { class: "link-heading" }, tm = {
  key: 1,
  class: "recent-date"
};
function rm(e, t, r, n, a, i) {
  const s = B("IndicatorLabel");
  return v(), _("div", {
    class: G(["related-rule recent-change", i.ruleClasses])
  }, [
    b("a", {
      class: "related-rule-title",
      href: r.html_url,
      target: "_blank",
      rel: "noopener noreferrer"
    }, [
      b("span", em, [
        r.type ? (v(), D(s, {
          key: 0,
          type: r.type
        }, null, 8, ["type"])) : O("", !0),
        r.publication_date ? (v(), _("span", tm, I(i.formatPubDate(r.publication_date)), 1)) : O("", !0),
        t[0] || (t[0] = L(" | ")),
        b("span", {
          class: G(["recent-fr-citation", i.citationClasses])
        }, I(r.citation), 3)
      ]),
      r.grouped ? O("", !0) : (v(), _("div", {
        key: 0,
        class: G(["recent-title", i.recentTitleClass])
      }, I(r.title), 3))
    ], 8, Q1)
  ], 2);
}
const nm = /* @__PURE__ */ z(Z1, [["render", rm]]), am = {
  name: "ShowMoreButton",
  props: {
    count: {
      type: Number,
      default: 1
    },
    buttonText: {
      type: String,
      required: !0
    }
  }
}, im = { class: "show-more-button" };
function sm(e, t, r, n, a, i) {
  return v(), _("div", im, [
    b("b", null, I(r.buttonText), 1),
    L(" (" + I(r.count) + ") ", 1)
  ]);
}
const bv = /* @__PURE__ */ z(am, [["render", sm]]), om = {
  name: "RelatedRuleList",
  components: {
    RelatedRule: nm,
    ShowMoreButton: bv,
    CollapseButton: Qe,
    Collapsible: et
  },
  props: {
    rules: {
      type: Array,
      default: () => []
    },
    limit: {
      type: Number,
      default: 5
    },
    title: {
      type: String,
      default: "results"
    }
  },
  data() {
    return {
      limitedList: !0,
      innerName: "RelatedRuleCollapsible"
    };
  },
  computed: {
    limitedRules() {
      return this.rules.slice(0, this.limit);
    },
    additionalRules() {
      return this.rules.slice(this.limit);
    },
    rulesCount() {
      return this.rules.length;
    },
    showMoreNeeded() {
      return this.rulesCount > this.limit;
    }
  },
  methods: {
    showMore() {
      this.limitedList = !this.limitedList;
    },
    ruleTitle(e) {
      return e.title || e.description;
    },
    type(e) {
      return M1(e);
    },
    citation(e) {
      return e.citation || e.document_id;
    },
    html_url(e) {
      return e.html_url || e.url;
    },
    publication_date(e) {
      return e.publication_date || e.date;
    }
  }
}, um = {
  key: 0,
  class: "related-rule-list"
}, lm = {
  key: 1,
  class: "show-more-inactive"
};
function cm(e, t, r, n, a, i) {
  const s = B("related-rule"), o = B("show-more-button"), u = B("collapse-button"), l = B("collapsible");
  return r.rules.length ? (v(), _("div", um, [
    (v(!0), _(E, null, X(i.limitedRules, (d, c) => (v(), _(E, { key: c }, [
      q(s, {
        title: i.ruleTitle(d),
        type: i.type(d),
        citation: i.citation(d),
        publication_date: i.publication_date(d),
        document_number: d.document_number,
        html_url: i.html_url(d),
        action: d.action
      }, null, 8, ["title", "type", "citation", "publication_date", "document_number", "html_url", "action"]),
      d.related_resources && d.related_resources.length > 0 ? (v(!0), _(E, { key: 0 }, X(d.related_resources, (f, h) => (v(), D(s, {
        key: h + "grouped" + f.document_number,
        title: i.ruleTitle(f),
        type: i.type(f),
        citation: i.citation(f),
        publication_date: i.publication_date(f),
        document_number: f.document_number,
        html_url: i.html_url(f),
        action: f.action,
        grouped: ""
      }, null, 8, ["title", "type", "citation", "publication_date", "document_number", "html_url", "action"]))), 128)) : O("", !0)
    ], 64))), 128)),
    i.showMoreNeeded ? (v(), D(u, {
      key: 0,
      name: a.innerName,
      state: "collapsed",
      class: "category-title"
    }, {
      expanded: N(() => [
        q(o, {
          "button-text": "- Show Less",
          count: r.rules.length
        }, null, 8, ["count"])
      ]),
      collapsed: N(() => [
        q(o, {
          "button-text": "+ Show More",
          count: r.rules.length
        }, null, 8, ["count"])
      ]),
      _: 1
    }, 8, ["name"])) : O("", !0),
    q(l, {
      name: a.innerName,
      state: "collapsed",
      class: "collapse-content additional-rules",
      overflow: ""
    }, {
      default: N(() => [
        (v(!0), _(E, null, X(i.additionalRules, (d, c) => (v(), _(E, { key: c }, [
          q(s, {
            title: i.ruleTitle(d),
            type: i.type(d),
            citation: i.citation(d),
            publication_date: i.publication_date(d),
            document_number: d.document_number,
            html_url: i.html_url(d),
            action: d.action
          }, null, 8, ["title", "type", "citation", "publication_date", "document_number", "html_url", "action"]),
          d.related_resources && d.related_resources.length > 0 ? (v(!0), _(E, { key: 0 }, X(d.related_resources, (f, h) => (v(), D(s, {
            key: h + "grouped" + f.document_number,
            title: i.ruleTitle(f),
            type: i.type(f),
            citation: i.citation(f),
            publication_date: i.publication_date(f),
            document_number: f.document_number,
            html_url: i.html_url(f),
            action: f.action,
            grouped: ""
          }, null, 8, ["title", "type", "citation", "publication_date", "document_number", "html_url", "action"]))), 128)) : O("", !0)
        ], 64))), 128)),
        i.showMoreNeeded && i.rulesCount > 10 ? (v(), D(u, {
          key: 0,
          name: a.innerName,
          state: "collapsed",
          class: "category-title"
        }, {
          expanded: N(() => [
            q(o, {
              "button-text": "- Show Less",
              count: r.rules.length
            }, null, 8, ["count"])
          ]),
          collapsed: N(() => [
            q(o, {
              "button-text": "+ Show More",
              count: r.rules.length
            }, null, 8, ["count"])
          ]),
          _: 1
        }, 8, ["name"])) : O("", !0)
      ]),
      _: 1
    }, 8, ["name"])
  ])) : (v(), _("div", lm, " No " + I(r.title) + " found in the Federal Register from 1994 to present. ", 1));
}
const Oo = /* @__PURE__ */ z(om, [["render", cm]]), dm = ({ type: e, part: t, section_id: r, subpart_id: n }) => !e || typeof e != "string" ? "Invalid Location" : (e == null ? void 0 : e.toLowerCase()) === "section" ? `${t}.${r}` : `${t} Subpart ${n}`, fm = ({ title: e, type: t, part: r, section_id: n, subpart_id: a }, i) => t.toLowerCase() === "subpart" ? `${i}${e}/${r}/Subpart-${a}/` : `${i}${e}/${r}/${n}#${r}-${n}`, fo = (e) => (e == null ? void 0 : e.short_name) || (e == null ? void 0 : e.abbreviation) || (e == null ? void 0 : e.full_name), hm = (e, t) => {
  const r = fo(e).toLowerCase(), n = fo(t).toLowerCase();
  return r < n ? -1 : r > n ? 1 : 0;
}, vm = ["title", "data-testid", "href"], pm = {
  __name: "SubjectChip",
  props: {
    subjectId: {
      type: Number,
      required: !0
    },
    subjectName: {
      type: String,
      required: !0
    },
    title: {
      type: String,
      required: !0
    }
  },
  setup(e) {
    const t = se("homeUrl") ?? "/", r = se("currentRouteName") ?? "subjects";
    return (n, a) => {
      const i = B("router-link");
      return K(r) !== "subjects" ? (v(), _("a", {
        key: 0,
        class: "subject__chip",
        title: e.title,
        "data-testid": `add-subject-chip-${e.subjectId}`,
        href: `${K(t)}subjects/?subjects=${e.subjectId}`
      }, I(e.subjectName), 9, vm)) : (v(), D(i, {
        key: 1,
        class: "subject__chip",
        title: e.title,
        "data-testid": `add-subject-chip-${e.subjectId}`,
        to: {
          name: "subjects",
          query: {
            subjects: e.subjectId.toString(),
            type: ["all"]
          },
          params: { subjectName: e.subjectName }
        }
      }, {
        default: N(() => [
          L(I(e.subjectName), 1)
        ]),
        _: 1
      }, 8, ["title", "data-testid", "to"]));
    };
  }
}, gm = { class: "document__subjects" }, Cv = {
  __name: "SubjectChips",
  props: {
    subjects: {
      type: Array,
      required: !0
    }
  },
  setup(e) {
    const t = e, r = w(
      () => (t.subjects || []).sort(hm)
    );
    return (n, a) => (v(), _("div", gm, [
      (v(!0), _(E, null, X(r.value, (i, s) => (v(), D(pm, {
        key: i.id + "x" + s,
        "subject-id": i.id,
        "subject-name": K(fo)(i),
        title: i.full_name
      }, null, 8, ["subject-id", "subject-name", "title"]))), 128))
    ]));
  }
}, _m = {
  name: "SupplementalContentObject",
  components: {
    //DivisionLabel,
    SubjectChips: Cv
  },
  setup() {
    ye("currentRouteName", "regulations");
  },
  props: {
    name: {
      type: String,
      required: !1,
      default: void 0
    },
    description: {
      type: String,
      required: !1,
      default: void 0
    },
    date: {
      type: String,
      required: !1,
      default: void 0
    },
    division: {
      type: Object,
      required: !1,
      default: null
    },
    uid: {
      type: String,
      required: !1,
      default: void 0
    },
    url: {
      type: String,
      default: void 0
    },
    docType: {
      type: String,
      required: !1,
      default: "public_link"
    },
    fileName: {
      type: String,
      required: !1,
      default: void 0
    },
    subjects: {
      type: Array,
      required: !1,
      default: () => []
    }
  },
  methods: {
    isBlank(e) {
      return !e || /^\s*$/.test(e);
    },
    addFileTypeButton({ fileName: e, uid: t, docType: r }) {
      return uo[r] !== "Internal" ? "" : x1({
        fileName: e,
        uid: t
      });
    },
    formatDate(e) {
      const t = new Date(e), r = { year: "numeric", timeZone: "UTC" }, n = e.split("-");
      return n.length > 1 && (r.month = "long"), n.length > 2 && (r.day = "numeric"), new Intl.DateTimeFormat("en-US", r).format(t);
    },
    getLinkClasses(e, t) {
      return {
        "supplemental-content-external-link": (uo[e] === "Public" || e === "internal_link") && this.isBlank(t)
      };
    }
  }
}, mm = { class: "supplemental-content" }, ym = ["href"];
function bm(e, t, r, n, a, i) {
  const s = B("subject-chips"), o = Be("sanitize-html");
  return v(), _("div", mm, [
    b("a", {
      class: "supplemental-content-link",
      href: r.url,
      target: "_blank",
      rel: "noopener noreferrer"
    }, [
      r.date ? (v(), _("span", {
        key: 0,
        class: G(["supplemental-content-date", {
          "supplemental-content-mid-bar": !i.isBlank(r.name)
        }])
      }, I(i.formatDate(r.date)), 3)) : O("", !0),
      i.isBlank(r.name) ? O("", !0) : (v(), _("span", {
        key: 1,
        class: G(["supplemental-content-title", i.getLinkClasses(r.docType, r.description)])
      }, I(r.name), 3)),
      i.isBlank(r.description) ? O("", !0) : (v(), _("div", {
        key: 2,
        class: G(["supplemental-content-description", i.getLinkClasses(r.docType)])
      }, [
        te(b("span", null, null, 512), [
          [
            o,
            r.description + i.addFileTypeButton({
              fileName: r.fileName,
              uid: r.uid,
              docType: r.docType
            })
          ]
        ])
      ], 2))
    ], 8, ym),
    r.subjects && r.subjects.length > 0 ? (v(), D(s, {
      key: 0,
      subjects: r.subjects
    }, null, 8, ["subjects"])) : O("", !0)
  ]);
}
const Sv = /* @__PURE__ */ z(_m, [["render", bm]]), Cm = {
  name: "SupplementalContentList",
  components: {
    SupplementalContentObject: Sv,
    ShowMoreButton: bv,
    CollapseButton: Qe,
    Collapsible: et
  },
  props: {
    supplemental_content: {
      type: Array,
      required: !0
    },
    hasSubcategories: {
      type: Number,
      required: !0
    },
    limit: {
      type: Number,
      required: !1,
      default: 5
    }
  },
  data() {
    return {
      subcategory: "",
      innerName: "SupplementalContentCollapsible"
    };
  },
  computed: {
    limitedContent() {
      return this.supplemental_content.slice(0, this.limit);
    },
    additionalContent() {
      return this.supplemental_content.slice(this.limit);
    },
    contentCount() {
      return this.supplemental_content.length;
    },
    showMoreNeeded() {
      return this.contentCount > this.limit;
    }
  }
}, Sm = { class: "supplemental-content-list" };
function qm(e, t, r, n, a, i) {
  const s = B("supplemental-content-object"), o = B("show-more-button"), u = B("collapse-button"), l = B("collapsible");
  return v(), _("div", Sm, [
    (v(!0), _(E, null, X(i.limitedContent, (d, c) => (v(), D(s, {
      key: c,
      name: d.document_id,
      description: d.title || d.doc_name_string,
      date: d.date || d.date_string,
      division: d.division,
      uid: d.uid,
      url: d.url,
      "doc-type": d.type ?? "external",
      "file-name": d.file_name,
      subjects: d.subjects
    }, null, 8, ["name", "description", "date", "division", "uid", "url", "doc-type", "file-name", "subjects"]))), 128)),
    i.showMoreNeeded ? (v(), D(u, {
      key: 0,
      class: G([{ subcategory: a.subcategory }, "category-title show-more"]),
      name: a.innerName,
      state: "collapsed"
    }, {
      expanded: N(() => [
        q(o, {
          "button-text": "- Show Less",
          count: i.contentCount
        }, null, 8, ["count"])
      ]),
      collapsed: N(() => [
        q(o, {
          "button-text": "+ Show More",
          count: i.contentCount
        }, null, 8, ["count"])
      ]),
      _: 1
    }, 8, ["class", "name"])) : O("", !0),
    q(l, {
      name: a.innerName,
      state: "collapsed",
      class: "collapse-content show-more-content"
    }, {
      default: N(() => [
        (v(!0), _(E, null, X(i.additionalContent, (d, c) => (v(), D(s, {
          key: c,
          name: d.document_id,
          description: d.title || d.doc_name_string,
          date: d.date || d.date_string,
          uid: d.uid,
          url: d.url,
          "doc-type": d.type ?? "external",
          subjects: d.subjects
        }, null, 8, ["name", "description", "date", "uid", "url", "doc-type", "subjects"]))), 128)),
        i.showMoreNeeded && i.contentCount > 10 ? (v(), D(u, {
          key: 0,
          class: G([{ subcategory: a.subcategory }, "category-title show-more"]),
          name: a.innerName,
          state: "collapsed"
        }, {
          expanded: N(() => [
            q(o, {
              "button-text": "- Show Less",
              count: i.contentCount
            }, null, 8, ["count"])
          ]),
          collapsed: N(() => [
            q(o, {
              "button-text": "+ Show More",
              count: i.contentCount
            }, null, 8, ["count"])
          ]),
          _: 1
        }, 8, ["class", "name"])) : O("", !0)
      ]),
      _: 1
    }, 8, ["name"])
  ]);
}
const wm = /* @__PURE__ */ z(Cm, [["render", qm]]), $m = {
  name: "SupplementalContentCategory",
  components: {
    RelatedRuleList: Oo,
    SupplementalContentList: wm,
    CollapseButton: Qe,
    Collapsible: et
  },
  props: {
    subcategory: {
      type: Boolean,
      required: !1,
      default: !1
    },
    isFetching: {
      type: Boolean,
      required: !1,
      default: !0
    },
    name: {
      type: String,
      required: !0
    },
    description: {
      type: String,
      required: !0
    },
    showIfEmpty: {
      type: Boolean,
      required: !1,
      default: !1
    },
    supplemental_content: {
      type: Array,
      required: !1,
      default: void 0
    },
    subcategories: {
      type: Array,
      required: !1,
      default: void 0
    },
    isFrLinkCategory: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  computed: {
    showDescription() {
      return this.description && !/^\s*$/.test(this.description);
    },
    hasSubcategories() {
      var e;
      return ((e = this == null ? void 0 : this.subcategories) == null ? void 0 : e.length) ?? 0;
    },
    hasChildren() {
      var e;
      return !!((e = this.supplemental_content) != null && e.length || this.subcategories && this.subcategories.some(
        (t) => t.supplemental_content
      ));
    },
    collapseButtonClasses() {
      return {
        subcategory: this.subcategory,
        "is-fr-link-btn": this.isFrLinkCategory
      };
    }
  }
}, Tm = {
  key: 0,
  class: "supplemental-content-category"
}, Rm = { class: "category" }, Am = {
  key: 0,
  class: "fa fa-chevron-up"
}, km = {
  key: 0,
  class: "fa fa-chevron-down"
}, Im = {
  key: 1,
  class: "category-title childless collapsible-title"
}, xm = { key: 2 }, Pm = {
  key: 3,
  class: "childless category-description"
}, Om = {
  key: 4,
  class: "category-description"
};
function Em(e, t, r, n, a, i) {
  const s = B("collapse-button"), o = B("supplemental-content-category", !0), u = B("related-rule-list"), l = B("supplemental-content-list"), d = B("collapsible");
  return i.hasChildren || !i.hasChildren && r.showIfEmpty ? (v(), _("div", Tm, [
    b("div", Rm, [
      i.hasChildren ? (v(), D(s, {
        key: 0,
        class: G([i.collapseButtonClasses, "category-title"]),
        name: r.name,
        state: "collapsed"
      }, {
        expanded: N(() => [
          L(I(r.name) + " ", 1),
          i.hasChildren ? (v(), _("i", Am)) : O("", !0)
        ]),
        collapsed: N(() => [
          L(I(r.name) + " ", 1),
          i.hasChildren ? (v(), _("i", km)) : O("", !0)
        ]),
        _: 1
      }, 8, ["class", "name"])) : (v(), _("div", Im, I(r.name), 1)),
      r.isFetching ? (v(), _("span", xm)) : i.hasChildren ? i.showDescription ? (v(), _("span", Om, I(r.description), 1)) : O("", !0) : (v(), _("span", Pm, "None")),
      q(d, {
        name: r.name,
        state: "collapsed",
        class: "collapse-content",
        overflow: ""
      }, {
        default: N(() => [
          (v(!0), _(E, null, X(r.subcategories, (c) => (v(), D(o, {
            key: c.name,
            subcategory: !0,
            name: c.name,
            description: c.description,
            supplemental_content: c.supplemental_content,
            sub_categories: c.subcategories,
            "is-fetching": r.isFetching
          }, null, 8, ["name", "description", "supplemental_content", "sub_categories", "is-fetching"]))), 128)),
          r.isFrLinkCategory ? (v(), _(E, { key: 0 }, [
            r.supplemental_content ? (v(), D(u, {
              key: 0,
              rules: r.supplemental_content
            }, null, 8, ["rules"])) : O("", !0)
          ], 64)) : (v(), _(E, { key: 1 }, [
            r.supplemental_content ? (v(), D(l, {
              key: 0,
              supplemental_content: r.supplemental_content,
              "has-subcategories": i.hasSubcategories
            }, null, 8, ["supplemental_content", "has-subcategories"])) : O("", !0)
          ], 64))
        ]),
        _: 1
      }, 8, ["name"])
    ])
  ])) : O("", !0);
}
const qv = /* @__PURE__ */ z($m, [["render", Em]]), Lm = { class: "internal-docs__container" }, Jq = {
  __name: "InternalDocsContainer",
  props: {
    apiUrl: {
      type: String,
      required: !0
    },
    title: {
      type: String,
      required: !0
    },
    part: {
      type: String,
      required: !0
    }
  },
  setup(e) {
    const t = e, r = (d) => {
      const c = L1(d);
      return c ? c.split("-")[1] : void 0;
    }, n = J(r(window.location.hash)), a = async () => {
      let d = [];
      try {
        d = await G1({
          apiUrl: t.apiUrl
        });
      } catch (c) {
        console.error(c);
      }
      return d;
    }, i = J({
      results: [],
      loading: !0
    }), s = async ({ section: d }) => {
      i.value.loading = !0;
      const c = JSON.parse(
        document.getElementById("node_list").textContent
      );
      let f;
      d ? f = `citations=${t.title}.${t.part}.${d}` : f = [...c.sections].reduce(
        (g, p) => `${g}&citations=${t.title}.${t.part}.${p}`,
        `citations=${t.title}.${t.part}.${c.subparts[0]}`
      );
      try {
        const h = await Promise.all([
          a(),
          z1({
            apiUrl: t.apiUrl,
            requestParams: `${f}`
          })
        ]), g = h[0], p = h[1];
        i.value.results = lo({
          categories: g.results,
          resources: p.results,
          apiUrl: t.apiUrl
        });
      } catch (h) {
        console.error(h), i.value.results = [];
      } finally {
        i.value.loading = !1;
      }
    }, o = () => {
      n.value = r(window.location.hash);
    }, u = (d) => {
      const c = d.section.split(" ")[1].split(".")[1];
      n.value = c;
    }, l = () => {
      n.value = void 0;
    };
    return Le(() => {
      window.addEventListener("hashchange", o), ae.on(pe.SetSection, u), ae.on(pe.ClearSections, l), a(), s({ section: n.value });
    }), mo(() => {
      window.removeEventListener("hashchange", o), ae.off(pe.SetSection, u), ae.off(pe.ClearSections, l);
    }), he(n, (d) => {
      s({ section: d });
    }), (d, c) => (v(), _("div", Lm, [
      i.value.loading ? (v(), D(Fe, { key: 0 })) : (v(!0), _(E, { key: 1 }, X(i.value.results, (f) => (v(), D(qv, {
        key: f.name,
        "is-fetching": i.value.loading,
        name: f.name,
        description: f.description,
        supplemental_content: f.supplemental_content,
        subcategories: f.subcategories,
        "show-if-empty": f.show_if_empty
      }, null, 8, ["is-fetching", "name", "description", "supplemental_content", "subcategories", "show-if-empty"]))), 128))
    ]));
  }
}, Mm = {
  name: "LastParserSuccessDate",
  components: {
    SimpleSpinner: Fe
  },
  props: {
    apiUrl: {
      type: String,
      required: !0
    }
  },
  created() {
    D1({ apiUrl: this.apiUrl }).then((e) => {
      this.lastParserSuccess = e;
    }).catch(() => {
      this.lastParserSuccess = "N/A";
    });
  },
  data() {
    return {
      lastParserSuccess: ""
    };
  }
}, Dm = {
  key: 1,
  class: "spinner-span"
};
function jm(e, t, r, n, a, i) {
  const s = B("SimpleSpinner");
  return v(), _("span", null, [
    a.lastParserSuccess ? (v(), _(E, { key: 0 }, [
      L(I(a.lastParserSuccess), 1)
    ], 64)) : (v(), _("span", Dm, [
      q(s, { size: "xs" })
    ]))
  ]);
}
const Zq = /* @__PURE__ */ z(Mm, [["render", jm]]), Bm = {
  name: "PartButton",
  props: {
    toggle: { type: Function, default: () => {
    } },
    away: { type: Function, default: () => {
    } }
  }
};
function Fm(e, t, r, n, a, i) {
  return v(), _("button", {
    class: "dropdown-part-button",
    onClick: t[0] || (t[0] = (...s) => r.toggle && r.toggle(...s))
  }, t[1] || (t[1] = [
    L(" Part "),
    b("i", { class: "fas fa-chevron-down" }, null, -1)
  ]));
}
const Qq = /* @__PURE__ */ z(Bm, [["render", Fm]]), Nm = {
  __name: "CategoryLabel",
  props: {
    name: {
      type: String,
      required: !0
    },
    type: {
      type: String,
      default: "category"
    }
  },
  setup(e) {
    const t = e, r = w(() => `${t.type}-label`);
    return (n, a) => (v(), _("div", {
      class: G(["result-label", r.value])
    }, I(e.name), 3));
  }
};
var Ua, Kc;
function wv() {
  if (Kc) return Ua;
  Kc = 1;
  var e = typeof qe == "object" && qe && qe.Object === Object && qe;
  return Ua = e, Ua;
}
var Ha, Xc;
function Ce() {
  if (Xc) return Ha;
  Xc = 1;
  var e = wv(), t = typeof self == "object" && self && self.Object === Object && self, r = e || t || Function("return this")();
  return Ha = r, Ha;
}
var Ga, Yc;
function Pt() {
  if (Yc) return Ga;
  Yc = 1;
  var e = Ce(), t = e.Symbol;
  return Ga = t, Ga;
}
var za, Jc;
function Um() {
  if (Jc) return za;
  Jc = 1;
  var e = Pt(), t = Object.prototype, r = t.hasOwnProperty, n = t.toString, a = e ? e.toStringTag : void 0;
  function i(s) {
    var o = r.call(s, a), u = s[a];
    try {
      s[a] = void 0;
      var l = !0;
    } catch {
    }
    var d = n.call(s);
    return l && (o ? s[a] = u : delete s[a]), d;
  }
  return za = i, za;
}
var Va, Zc;
function Hm() {
  if (Zc) return Va;
  Zc = 1;
  var e = Object.prototype, t = e.toString;
  function r(n) {
    return t.call(n);
  }
  return Va = r, Va;
}
var Wa, Qc;
function at() {
  if (Qc) return Wa;
  Qc = 1;
  var e = Pt(), t = Um(), r = Hm(), n = "[object Null]", a = "[object Undefined]", i = e ? e.toStringTag : void 0;
  function s(o) {
    return o == null ? o === void 0 ? a : n : i && i in Object(o) ? t(o) : r(o);
  }
  return Wa = s, Wa;
}
var Ka, ed;
function Eo() {
  if (ed) return Ka;
  ed = 1;
  function e(t) {
    var r = typeof t;
    return t != null && (r == "object" || r == "function");
  }
  return Ka = e, Ka;
}
var Xa, td;
function $v() {
  if (td) return Xa;
  td = 1;
  var e = at(), t = Eo(), r = "[object AsyncFunction]", n = "[object Function]", a = "[object GeneratorFunction]", i = "[object Proxy]";
  function s(o) {
    if (!t(o))
      return !1;
    var u = e(o);
    return u == n || u == a || u == r || u == i;
  }
  return Xa = s, Xa;
}
var Ya, rd;
function Gm() {
  if (rd) return Ya;
  rd = 1;
  var e = Ce(), t = e["__core-js_shared__"];
  return Ya = t, Ya;
}
var Ja, nd;
function zm() {
  if (nd) return Ja;
  nd = 1;
  var e = Gm(), t = function() {
    var n = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
    return n ? "Symbol(src)_1." + n : "";
  }();
  function r(n) {
    return !!t && t in n;
  }
  return Ja = r, Ja;
}
var Za, ad;
function Tv() {
  if (ad) return Za;
  ad = 1;
  var e = Function.prototype, t = e.toString;
  function r(n) {
    if (n != null) {
      try {
        return t.call(n);
      } catch {
      }
      try {
        return n + "";
      } catch {
      }
    }
    return "";
  }
  return Za = r, Za;
}
var Qa, id;
function Vm() {
  if (id) return Qa;
  id = 1;
  var e = $v(), t = zm(), r = Eo(), n = Tv(), a = /[\\^$.*+?()[\]{}|]/g, i = /^\[object .+?Constructor\]$/, s = Function.prototype, o = Object.prototype, u = s.toString, l = o.hasOwnProperty, d = RegExp(
    "^" + u.call(l).replace(a, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function c(f) {
    if (!r(f) || t(f))
      return !1;
    var h = e(f) ? d : i;
    return h.test(n(f));
  }
  return Qa = c, Qa;
}
var ei, sd;
function Wm() {
  if (sd) return ei;
  sd = 1;
  function e(t, r) {
    return t == null ? void 0 : t[r];
  }
  return ei = e, ei;
}
var ti, od;
function Ie() {
  if (od) return ti;
  od = 1;
  var e = Vm(), t = Wm();
  function r(n, a) {
    var i = t(n, a);
    return e(i) ? i : void 0;
  }
  return ti = r, ti;
}
var ri, ud;
function Km() {
  if (ud) return ri;
  ud = 1;
  var e = Ie(), t = function() {
    try {
      var r = e(Object, "defineProperty");
      return r({}, "", {}), r;
    } catch {
    }
  }();
  return ri = t, ri;
}
var ni, ld;
function Xm() {
  if (ld) return ni;
  ld = 1;
  var e = Km();
  function t(r, n, a) {
    n == "__proto__" && e ? e(r, n, {
      configurable: !0,
      enumerable: !0,
      value: a,
      writable: !0
    }) : r[n] = a;
  }
  return ni = t, ni;
}
var ai, cd;
function Ym() {
  if (cd) return ai;
  cd = 1;
  function e(t, r, n, a) {
    for (var i = -1, s = t == null ? 0 : t.length; ++i < s; ) {
      var o = t[i];
      r(a, o, n(o), t);
    }
    return a;
  }
  return ai = e, ai;
}
var ii, dd;
function Jm() {
  if (dd) return ii;
  dd = 1;
  function e(t) {
    return function(r, n, a) {
      for (var i = -1, s = Object(r), o = a(r), u = o.length; u--; ) {
        var l = o[t ? u : ++i];
        if (n(s[l], l, s) === !1)
          break;
      }
      return r;
    };
  }
  return ii = e, ii;
}
var si, fd;
function Zm() {
  if (fd) return si;
  fd = 1;
  var e = Jm(), t = e();
  return si = t, si;
}
var oi, hd;
function Qm() {
  if (hd) return oi;
  hd = 1;
  function e(t, r) {
    for (var n = -1, a = Array(t); ++n < t; )
      a[n] = r(n);
    return a;
  }
  return oi = e, oi;
}
var ui, vd;
function it() {
  if (vd) return ui;
  vd = 1;
  function e(t) {
    return t != null && typeof t == "object";
  }
  return ui = e, ui;
}
var li, pd;
function ey() {
  if (pd) return li;
  pd = 1;
  var e = at(), t = it(), r = "[object Arguments]";
  function n(a) {
    return t(a) && e(a) == r;
  }
  return li = n, li;
}
var ci, gd;
function Rv() {
  if (gd) return ci;
  gd = 1;
  var e = ey(), t = it(), r = Object.prototype, n = r.hasOwnProperty, a = r.propertyIsEnumerable, i = e(/* @__PURE__ */ function() {
    return arguments;
  }()) ? e : function(s) {
    return t(s) && n.call(s, "callee") && !a.call(s, "callee");
  };
  return ci = i, ci;
}
var di, _d;
function Se() {
  if (_d) return di;
  _d = 1;
  var e = Array.isArray;
  return di = e, di;
}
var He = { exports: {} }, fi, md;
function ty() {
  if (md) return fi;
  md = 1;
  function e() {
    return !1;
  }
  return fi = e, fi;
}
He.exports;
var yd;
function Av() {
  return yd || (yd = 1, function(e, t) {
    var r = Ce(), n = ty(), a = t && !t.nodeType && t, i = a && !0 && e && !e.nodeType && e, s = i && i.exports === a, o = s ? r.Buffer : void 0, u = o ? o.isBuffer : void 0, l = u || n;
    e.exports = l;
  }(He, He.exports)), He.exports;
}
var hi, bd;
function kv() {
  if (bd) return hi;
  bd = 1;
  var e = 9007199254740991, t = /^(?:0|[1-9]\d*)$/;
  function r(n, a) {
    var i = typeof n;
    return a = a ?? e, !!a && (i == "number" || i != "symbol" && t.test(n)) && n > -1 && n % 1 == 0 && n < a;
  }
  return hi = r, hi;
}
var vi, Cd;
function Lo() {
  if (Cd) return vi;
  Cd = 1;
  var e = 9007199254740991;
  function t(r) {
    return typeof r == "number" && r > -1 && r % 1 == 0 && r <= e;
  }
  return vi = t, vi;
}
var pi, Sd;
function ry() {
  if (Sd) return pi;
  Sd = 1;
  var e = at(), t = Lo(), r = it(), n = "[object Arguments]", a = "[object Array]", i = "[object Boolean]", s = "[object Date]", o = "[object Error]", u = "[object Function]", l = "[object Map]", d = "[object Number]", c = "[object Object]", f = "[object RegExp]", h = "[object Set]", g = "[object String]", p = "[object WeakMap]", m = "[object ArrayBuffer]", C = "[object DataView]", y = "[object Float32Array]", A = "[object Float64Array]", S = "[object Int8Array]", k = "[object Int16Array]", T = "[object Int32Array]", $ = "[object Uint8Array]", M = "[object Uint8ClampedArray]", j = "[object Uint16Array]", F = "[object Uint32Array]", R = {};
  R[y] = R[A] = R[S] = R[k] = R[T] = R[$] = R[M] = R[j] = R[F] = !0, R[n] = R[a] = R[m] = R[i] = R[C] = R[s] = R[o] = R[u] = R[l] = R[d] = R[c] = R[f] = R[h] = R[g] = R[p] = !1;
  function V(H) {
    return r(H) && t(H.length) && !!R[e(H)];
  }
  return pi = V, pi;
}
var gi, qd;
function ny() {
  if (qd) return gi;
  qd = 1;
  function e(t) {
    return function(r) {
      return t(r);
    };
  }
  return gi = e, gi;
}
var Ge = { exports: {} };
Ge.exports;
var wd;
function ay() {
  return wd || (wd = 1, function(e, t) {
    var r = wv(), n = t && !t.nodeType && t, a = n && !0 && e && !e.nodeType && e, i = a && a.exports === n, s = i && r.process, o = function() {
      try {
        var u = a && a.require && a.require("util").types;
        return u || s && s.binding && s.binding("util");
      } catch {
      }
    }();
    e.exports = o;
  }(Ge, Ge.exports)), Ge.exports;
}
var _i, $d;
function Iv() {
  if ($d) return _i;
  $d = 1;
  var e = ry(), t = ny(), r = ay(), n = r && r.isTypedArray, a = n ? t(n) : e;
  return _i = a, _i;
}
var mi, Td;
function iy() {
  if (Td) return mi;
  Td = 1;
  var e = Qm(), t = Rv(), r = Se(), n = Av(), a = kv(), i = Iv(), s = Object.prototype, o = s.hasOwnProperty;
  function u(l, d) {
    var c = r(l), f = !c && t(l), h = !c && !f && n(l), g = !c && !f && !h && i(l), p = c || f || h || g, m = p ? e(l.length, String) : [], C = m.length;
    for (var y in l)
      (d || o.call(l, y)) && !(p && // Safari 9 has enumerable `arguments.length` in strict mode.
      (y == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      h && (y == "offset" || y == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      g && (y == "buffer" || y == "byteLength" || y == "byteOffset") || // Skip index properties.
      a(y, C))) && m.push(y);
    return m;
  }
  return mi = u, mi;
}
var yi, Rd;
function sy() {
  if (Rd) return yi;
  Rd = 1;
  var e = Object.prototype;
  function t(r) {
    var n = r && r.constructor, a = typeof n == "function" && n.prototype || e;
    return r === a;
  }
  return yi = t, yi;
}
var bi, Ad;
function oy() {
  if (Ad) return bi;
  Ad = 1;
  function e(t, r) {
    return function(n) {
      return t(r(n));
    };
  }
  return bi = e, bi;
}
var Ci, kd;
function uy() {
  if (kd) return Ci;
  kd = 1;
  var e = oy(), t = e(Object.keys, Object);
  return Ci = t, Ci;
}
var Si, Id;
function ly() {
  if (Id) return Si;
  Id = 1;
  var e = sy(), t = uy(), r = Object.prototype, n = r.hasOwnProperty;
  function a(i) {
    if (!e(i))
      return t(i);
    var s = [];
    for (var o in Object(i))
      n.call(i, o) && o != "constructor" && s.push(o);
    return s;
  }
  return Si = a, Si;
}
var qi, xd;
function xv() {
  if (xd) return qi;
  xd = 1;
  var e = $v(), t = Lo();
  function r(n) {
    return n != null && t(n.length) && !e(n);
  }
  return qi = r, qi;
}
var wi, Pd;
function Mo() {
  if (Pd) return wi;
  Pd = 1;
  var e = iy(), t = ly(), r = xv();
  function n(a) {
    return r(a) ? e(a) : t(a);
  }
  return wi = n, wi;
}
var $i, Od;
function cy() {
  if (Od) return $i;
  Od = 1;
  var e = Zm(), t = Mo();
  function r(n, a) {
    return n && e(n, a, t);
  }
  return $i = r, $i;
}
var Ti, Ed;
function dy() {
  if (Ed) return Ti;
  Ed = 1;
  var e = xv();
  function t(r, n) {
    return function(a, i) {
      if (a == null)
        return a;
      if (!e(a))
        return r(a, i);
      for (var s = a.length, o = n ? s : -1, u = Object(a); (n ? o-- : ++o < s) && i(u[o], o, u) !== !1; )
        ;
      return a;
    };
  }
  return Ti = t, Ti;
}
var Ri, Ld;
function fy() {
  if (Ld) return Ri;
  Ld = 1;
  var e = cy(), t = dy(), r = t(e);
  return Ri = r, Ri;
}
var Ai, Md;
function hy() {
  if (Md) return Ai;
  Md = 1;
  var e = fy();
  function t(r, n, a, i) {
    return e(r, function(s, o, u) {
      n(i, s, a(s), u);
    }), i;
  }
  return Ai = t, Ai;
}
var ki, Dd;
function vy() {
  if (Dd) return ki;
  Dd = 1;
  function e() {
    this.__data__ = [], this.size = 0;
  }
  return ki = e, ki;
}
var Ii, jd;
function Pv() {
  if (jd) return Ii;
  jd = 1;
  function e(t, r) {
    return t === r || t !== t && r !== r;
  }
  return Ii = e, Ii;
}
var xi, Bd;
function Ot() {
  if (Bd) return xi;
  Bd = 1;
  var e = Pv();
  function t(r, n) {
    for (var a = r.length; a--; )
      if (e(r[a][0], n))
        return a;
    return -1;
  }
  return xi = t, xi;
}
var Pi, Fd;
function py() {
  if (Fd) return Pi;
  Fd = 1;
  var e = Ot(), t = Array.prototype, r = t.splice;
  function n(a) {
    var i = this.__data__, s = e(i, a);
    if (s < 0)
      return !1;
    var o = i.length - 1;
    return s == o ? i.pop() : r.call(i, s, 1), --this.size, !0;
  }
  return Pi = n, Pi;
}
var Oi, Nd;
function gy() {
  if (Nd) return Oi;
  Nd = 1;
  var e = Ot();
  function t(r) {
    var n = this.__data__, a = e(n, r);
    return a < 0 ? void 0 : n[a][1];
  }
  return Oi = t, Oi;
}
var Ei, Ud;
function _y() {
  if (Ud) return Ei;
  Ud = 1;
  var e = Ot();
  function t(r) {
    return e(this.__data__, r) > -1;
  }
  return Ei = t, Ei;
}
var Li, Hd;
function my() {
  if (Hd) return Li;
  Hd = 1;
  var e = Ot();
  function t(r, n) {
    var a = this.__data__, i = e(a, r);
    return i < 0 ? (++this.size, a.push([r, n])) : a[i][1] = n, this;
  }
  return Li = t, Li;
}
var Mi, Gd;
function Et() {
  if (Gd) return Mi;
  Gd = 1;
  var e = vy(), t = py(), r = gy(), n = _y(), a = my();
  function i(s) {
    var o = -1, u = s == null ? 0 : s.length;
    for (this.clear(); ++o < u; ) {
      var l = s[o];
      this.set(l[0], l[1]);
    }
  }
  return i.prototype.clear = e, i.prototype.delete = t, i.prototype.get = r, i.prototype.has = n, i.prototype.set = a, Mi = i, Mi;
}
var Di, zd;
function yy() {
  if (zd) return Di;
  zd = 1;
  var e = Et();
  function t() {
    this.__data__ = new e(), this.size = 0;
  }
  return Di = t, Di;
}
var ji, Vd;
function by() {
  if (Vd) return ji;
  Vd = 1;
  function e(t) {
    var r = this.__data__, n = r.delete(t);
    return this.size = r.size, n;
  }
  return ji = e, ji;
}
var Bi, Wd;
function Cy() {
  if (Wd) return Bi;
  Wd = 1;
  function e(t) {
    return this.__data__.get(t);
  }
  return Bi = e, Bi;
}
var Fi, Kd;
function Sy() {
  if (Kd) return Fi;
  Kd = 1;
  function e(t) {
    return this.__data__.has(t);
  }
  return Fi = e, Fi;
}
var Ni, Xd;
function Do() {
  if (Xd) return Ni;
  Xd = 1;
  var e = Ie(), t = Ce(), r = e(t, "Map");
  return Ni = r, Ni;
}
var Ui, Yd;
function Lt() {
  if (Yd) return Ui;
  Yd = 1;
  var e = Ie(), t = e(Object, "create");
  return Ui = t, Ui;
}
var Hi, Jd;
function qy() {
  if (Jd) return Hi;
  Jd = 1;
  var e = Lt();
  function t() {
    this.__data__ = e ? e(null) : {}, this.size = 0;
  }
  return Hi = t, Hi;
}
var Gi, Zd;
function wy() {
  if (Zd) return Gi;
  Zd = 1;
  function e(t) {
    var r = this.has(t) && delete this.__data__[t];
    return this.size -= r ? 1 : 0, r;
  }
  return Gi = e, Gi;
}
var zi, Qd;
function $y() {
  if (Qd) return zi;
  Qd = 1;
  var e = Lt(), t = "__lodash_hash_undefined__", r = Object.prototype, n = r.hasOwnProperty;
  function a(i) {
    var s = this.__data__;
    if (e) {
      var o = s[i];
      return o === t ? void 0 : o;
    }
    return n.call(s, i) ? s[i] : void 0;
  }
  return zi = a, zi;
}
var Vi, ef;
function Ty() {
  if (ef) return Vi;
  ef = 1;
  var e = Lt(), t = Object.prototype, r = t.hasOwnProperty;
  function n(a) {
    var i = this.__data__;
    return e ? i[a] !== void 0 : r.call(i, a);
  }
  return Vi = n, Vi;
}
var Wi, tf;
function Ry() {
  if (tf) return Wi;
  tf = 1;
  var e = Lt(), t = "__lodash_hash_undefined__";
  function r(n, a) {
    var i = this.__data__;
    return this.size += this.has(n) ? 0 : 1, i[n] = e && a === void 0 ? t : a, this;
  }
  return Wi = r, Wi;
}
var Ki, rf;
function Ay() {
  if (rf) return Ki;
  rf = 1;
  var e = qy(), t = wy(), r = $y(), n = Ty(), a = Ry();
  function i(s) {
    var o = -1, u = s == null ? 0 : s.length;
    for (this.clear(); ++o < u; ) {
      var l = s[o];
      this.set(l[0], l[1]);
    }
  }
  return i.prototype.clear = e, i.prototype.delete = t, i.prototype.get = r, i.prototype.has = n, i.prototype.set = a, Ki = i, Ki;
}
var Xi, nf;
function ky() {
  if (nf) return Xi;
  nf = 1;
  var e = Ay(), t = Et(), r = Do();
  function n() {
    this.size = 0, this.__data__ = {
      hash: new e(),
      map: new (r || t)(),
      string: new e()
    };
  }
  return Xi = n, Xi;
}
var Yi, af;
function Iy() {
  if (af) return Yi;
  af = 1;
  function e(t) {
    var r = typeof t;
    return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? t !== "__proto__" : t === null;
  }
  return Yi = e, Yi;
}
var Ji, sf;
function Mt() {
  if (sf) return Ji;
  sf = 1;
  var e = Iy();
  function t(r, n) {
    var a = r.__data__;
    return e(n) ? a[typeof n == "string" ? "string" : "hash"] : a.map;
  }
  return Ji = t, Ji;
}
var Zi, of;
function xy() {
  if (of) return Zi;
  of = 1;
  var e = Mt();
  function t(r) {
    var n = e(this, r).delete(r);
    return this.size -= n ? 1 : 0, n;
  }
  return Zi = t, Zi;
}
var Qi, uf;
function Py() {
  if (uf) return Qi;
  uf = 1;
  var e = Mt();
  function t(r) {
    return e(this, r).get(r);
  }
  return Qi = t, Qi;
}
var es, lf;
function Oy() {
  if (lf) return es;
  lf = 1;
  var e = Mt();
  function t(r) {
    return e(this, r).has(r);
  }
  return es = t, es;
}
var ts, cf;
function Ey() {
  if (cf) return ts;
  cf = 1;
  var e = Mt();
  function t(r, n) {
    var a = e(this, r), i = a.size;
    return a.set(r, n), this.size += a.size == i ? 0 : 1, this;
  }
  return ts = t, ts;
}
var rs, df;
function jo() {
  if (df) return rs;
  df = 1;
  var e = ky(), t = xy(), r = Py(), n = Oy(), a = Ey();
  function i(s) {
    var o = -1, u = s == null ? 0 : s.length;
    for (this.clear(); ++o < u; ) {
      var l = s[o];
      this.set(l[0], l[1]);
    }
  }
  return i.prototype.clear = e, i.prototype.delete = t, i.prototype.get = r, i.prototype.has = n, i.prototype.set = a, rs = i, rs;
}
var ns, ff;
function Ly() {
  if (ff) return ns;
  ff = 1;
  var e = Et(), t = Do(), r = jo(), n = 200;
  function a(i, s) {
    var o = this.__data__;
    if (o instanceof e) {
      var u = o.__data__;
      if (!t || u.length < n - 1)
        return u.push([i, s]), this.size = ++o.size, this;
      o = this.__data__ = new r(u);
    }
    return o.set(i, s), this.size = o.size, this;
  }
  return ns = a, ns;
}
var as, hf;
function Ov() {
  if (hf) return as;
  hf = 1;
  var e = Et(), t = yy(), r = by(), n = Cy(), a = Sy(), i = Ly();
  function s(o) {
    var u = this.__data__ = new e(o);
    this.size = u.size;
  }
  return s.prototype.clear = t, s.prototype.delete = r, s.prototype.get = n, s.prototype.has = a, s.prototype.set = i, as = s, as;
}
var is, vf;
function My() {
  if (vf) return is;
  vf = 1;
  var e = "__lodash_hash_undefined__";
  function t(r) {
    return this.__data__.set(r, e), this;
  }
  return is = t, is;
}
var ss, pf;
function Dy() {
  if (pf) return ss;
  pf = 1;
  function e(t) {
    return this.__data__.has(t);
  }
  return ss = e, ss;
}
var os, gf;
function jy() {
  if (gf) return os;
  gf = 1;
  var e = jo(), t = My(), r = Dy();
  function n(a) {
    var i = -1, s = a == null ? 0 : a.length;
    for (this.__data__ = new e(); ++i < s; )
      this.add(a[i]);
  }
  return n.prototype.add = n.prototype.push = t, n.prototype.has = r, os = n, os;
}
var us, _f;
function By() {
  if (_f) return us;
  _f = 1;
  function e(t, r) {
    for (var n = -1, a = t == null ? 0 : t.length; ++n < a; )
      if (r(t[n], n, t))
        return !0;
    return !1;
  }
  return us = e, us;
}
var ls, mf;
function Fy() {
  if (mf) return ls;
  mf = 1;
  function e(t, r) {
    return t.has(r);
  }
  return ls = e, ls;
}
var cs, yf;
function Ev() {
  if (yf) return cs;
  yf = 1;
  var e = jy(), t = By(), r = Fy(), n = 1, a = 2;
  function i(s, o, u, l, d, c) {
    var f = u & n, h = s.length, g = o.length;
    if (h != g && !(f && g > h))
      return !1;
    var p = c.get(s), m = c.get(o);
    if (p && m)
      return p == o && m == s;
    var C = -1, y = !0, A = u & a ? new e() : void 0;
    for (c.set(s, o), c.set(o, s); ++C < h; ) {
      var S = s[C], k = o[C];
      if (l)
        var T = f ? l(k, S, C, o, s, c) : l(S, k, C, s, o, c);
      if (T !== void 0) {
        if (T)
          continue;
        y = !1;
        break;
      }
      if (A) {
        if (!t(o, function($, M) {
          if (!r(A, M) && (S === $ || d(S, $, u, l, c)))
            return A.push(M);
        })) {
          y = !1;
          break;
        }
      } else if (!(S === k || d(S, k, u, l, c))) {
        y = !1;
        break;
      }
    }
    return c.delete(s), c.delete(o), y;
  }
  return cs = i, cs;
}
var ds, bf;
function Ny() {
  if (bf) return ds;
  bf = 1;
  var e = Ce(), t = e.Uint8Array;
  return ds = t, ds;
}
var fs, Cf;
function Uy() {
  if (Cf) return fs;
  Cf = 1;
  function e(t) {
    var r = -1, n = Array(t.size);
    return t.forEach(function(a, i) {
      n[++r] = [i, a];
    }), n;
  }
  return fs = e, fs;
}
var hs, Sf;
function Hy() {
  if (Sf) return hs;
  Sf = 1;
  function e(t) {
    var r = -1, n = Array(t.size);
    return t.forEach(function(a) {
      n[++r] = a;
    }), n;
  }
  return hs = e, hs;
}
var vs, qf;
function Gy() {
  if (qf) return vs;
  qf = 1;
  var e = Pt(), t = Ny(), r = Pv(), n = Ev(), a = Uy(), i = Hy(), s = 1, o = 2, u = "[object Boolean]", l = "[object Date]", d = "[object Error]", c = "[object Map]", f = "[object Number]", h = "[object RegExp]", g = "[object Set]", p = "[object String]", m = "[object Symbol]", C = "[object ArrayBuffer]", y = "[object DataView]", A = e ? e.prototype : void 0, S = A ? A.valueOf : void 0;
  function k(T, $, M, j, F, R, V) {
    switch (M) {
      case y:
        if (T.byteLength != $.byteLength || T.byteOffset != $.byteOffset)
          return !1;
        T = T.buffer, $ = $.buffer;
      case C:
        return !(T.byteLength != $.byteLength || !R(new t(T), new t($)));
      case u:
      case l:
      case f:
        return r(+T, +$);
      case d:
        return T.name == $.name && T.message == $.message;
      case h:
      case p:
        return T == $ + "";
      case c:
        var H = a;
      case g:
        var ee = j & s;
        if (H || (H = i), T.size != $.size && !ee)
          return !1;
        var Z = V.get(T);
        if (Z)
          return Z == $;
        j |= o, V.set(T, $);
        var _e = n(H(T), H($), j, F, R, V);
        return V.delete(T), _e;
      case m:
        if (S)
          return S.call(T) == S.call($);
    }
    return !1;
  }
  return vs = k, vs;
}
var ps, wf;
function zy() {
  if (wf) return ps;
  wf = 1;
  function e(t, r) {
    for (var n = -1, a = r.length, i = t.length; ++n < a; )
      t[i + n] = r[n];
    return t;
  }
  return ps = e, ps;
}
var gs, $f;
function Vy() {
  if ($f) return gs;
  $f = 1;
  var e = zy(), t = Se();
  function r(n, a, i) {
    var s = a(n);
    return t(n) ? s : e(s, i(n));
  }
  return gs = r, gs;
}
var _s, Tf;
function Wy() {
  if (Tf) return _s;
  Tf = 1;
  function e(t, r) {
    for (var n = -1, a = t == null ? 0 : t.length, i = 0, s = []; ++n < a; ) {
      var o = t[n];
      r(o, n, t) && (s[i++] = o);
    }
    return s;
  }
  return _s = e, _s;
}
var ms, Rf;
function Ky() {
  if (Rf) return ms;
  Rf = 1;
  function e() {
    return [];
  }
  return ms = e, ms;
}
var ys, Af;
function Xy() {
  if (Af) return ys;
  Af = 1;
  var e = Wy(), t = Ky(), r = Object.prototype, n = r.propertyIsEnumerable, a = Object.getOwnPropertySymbols, i = a ? function(s) {
    return s == null ? [] : (s = Object(s), e(a(s), function(o) {
      return n.call(s, o);
    }));
  } : t;
  return ys = i, ys;
}
var bs, kf;
function Yy() {
  if (kf) return bs;
  kf = 1;
  var e = Vy(), t = Xy(), r = Mo();
  function n(a) {
    return e(a, r, t);
  }
  return bs = n, bs;
}
var Cs, If;
function Jy() {
  if (If) return Cs;
  If = 1;
  var e = Yy(), t = 1, r = Object.prototype, n = r.hasOwnProperty;
  function a(i, s, o, u, l, d) {
    var c = o & t, f = e(i), h = f.length, g = e(s), p = g.length;
    if (h != p && !c)
      return !1;
    for (var m = h; m--; ) {
      var C = f[m];
      if (!(c ? C in s : n.call(s, C)))
        return !1;
    }
    var y = d.get(i), A = d.get(s);
    if (y && A)
      return y == s && A == i;
    var S = !0;
    d.set(i, s), d.set(s, i);
    for (var k = c; ++m < h; ) {
      C = f[m];
      var T = i[C], $ = s[C];
      if (u)
        var M = c ? u($, T, C, s, i, d) : u(T, $, C, i, s, d);
      if (!(M === void 0 ? T === $ || l(T, $, o, u, d) : M)) {
        S = !1;
        break;
      }
      k || (k = C == "constructor");
    }
    if (S && !k) {
      var j = i.constructor, F = s.constructor;
      j != F && "constructor" in i && "constructor" in s && !(typeof j == "function" && j instanceof j && typeof F == "function" && F instanceof F) && (S = !1);
    }
    return d.delete(i), d.delete(s), S;
  }
  return Cs = a, Cs;
}
var Ss, xf;
function Zy() {
  if (xf) return Ss;
  xf = 1;
  var e = Ie(), t = Ce(), r = e(t, "DataView");
  return Ss = r, Ss;
}
var qs, Pf;
function Qy() {
  if (Pf) return qs;
  Pf = 1;
  var e = Ie(), t = Ce(), r = e(t, "Promise");
  return qs = r, qs;
}
var ws, Of;
function eb() {
  if (Of) return ws;
  Of = 1;
  var e = Ie(), t = Ce(), r = e(t, "Set");
  return ws = r, ws;
}
var $s, Ef;
function tb() {
  if (Ef) return $s;
  Ef = 1;
  var e = Ie(), t = Ce(), r = e(t, "WeakMap");
  return $s = r, $s;
}
var Ts, Lf;
function rb() {
  if (Lf) return Ts;
  Lf = 1;
  var e = Zy(), t = Do(), r = Qy(), n = eb(), a = tb(), i = at(), s = Tv(), o = "[object Map]", u = "[object Object]", l = "[object Promise]", d = "[object Set]", c = "[object WeakMap]", f = "[object DataView]", h = s(e), g = s(t), p = s(r), m = s(n), C = s(a), y = i;
  return (e && y(new e(new ArrayBuffer(1))) != f || t && y(new t()) != o || r && y(r.resolve()) != l || n && y(new n()) != d || a && y(new a()) != c) && (y = function(A) {
    var S = i(A), k = S == u ? A.constructor : void 0, T = k ? s(k) : "";
    if (T)
      switch (T) {
        case h:
          return f;
        case g:
          return o;
        case p:
          return l;
        case m:
          return d;
        case C:
          return c;
      }
    return S;
  }), Ts = y, Ts;
}
var Rs, Mf;
function nb() {
  if (Mf) return Rs;
  Mf = 1;
  var e = Ov(), t = Ev(), r = Gy(), n = Jy(), a = rb(), i = Se(), s = Av(), o = Iv(), u = 1, l = "[object Arguments]", d = "[object Array]", c = "[object Object]", f = Object.prototype, h = f.hasOwnProperty;
  function g(p, m, C, y, A, S) {
    var k = i(p), T = i(m), $ = k ? d : a(p), M = T ? d : a(m);
    $ = $ == l ? c : $, M = M == l ? c : M;
    var j = $ == c, F = M == c, R = $ == M;
    if (R && s(p)) {
      if (!s(m))
        return !1;
      k = !0, j = !1;
    }
    if (R && !j)
      return S || (S = new e()), k || o(p) ? t(p, m, C, y, A, S) : r(p, m, $, C, y, A, S);
    if (!(C & u)) {
      var V = j && h.call(p, "__wrapped__"), H = F && h.call(m, "__wrapped__");
      if (V || H) {
        var ee = V ? p.value() : p, Z = H ? m.value() : m;
        return S || (S = new e()), A(ee, Z, C, y, S);
      }
    }
    return R ? (S || (S = new e()), n(p, m, C, y, A, S)) : !1;
  }
  return Rs = g, Rs;
}
var As, Df;
function Lv() {
  if (Df) return As;
  Df = 1;
  var e = nb(), t = it();
  function r(n, a, i, s, o) {
    return n === a ? !0 : n == null || a == null || !t(n) && !t(a) ? n !== n && a !== a : e(n, a, i, s, r, o);
  }
  return As = r, As;
}
var ks, jf;
function ab() {
  if (jf) return ks;
  jf = 1;
  var e = Ov(), t = Lv(), r = 1, n = 2;
  function a(i, s, o, u) {
    var l = o.length, d = l, c = !u;
    if (i == null)
      return !d;
    for (i = Object(i); l--; ) {
      var f = o[l];
      if (c && f[2] ? f[1] !== i[f[0]] : !(f[0] in i))
        return !1;
    }
    for (; ++l < d; ) {
      f = o[l];
      var h = f[0], g = i[h], p = f[1];
      if (c && f[2]) {
        if (g === void 0 && !(h in i))
          return !1;
      } else {
        var m = new e();
        if (u)
          var C = u(g, p, h, i, s, m);
        if (!(C === void 0 ? t(p, g, r | n, u, m) : C))
          return !1;
      }
    }
    return !0;
  }
  return ks = a, ks;
}
var Is, Bf;
function Mv() {
  if (Bf) return Is;
  Bf = 1;
  var e = Eo();
  function t(r) {
    return r === r && !e(r);
  }
  return Is = t, Is;
}
var xs, Ff;
function ib() {
  if (Ff) return xs;
  Ff = 1;
  var e = Mv(), t = Mo();
  function r(n) {
    for (var a = t(n), i = a.length; i--; ) {
      var s = a[i], o = n[s];
      a[i] = [s, o, e(o)];
    }
    return a;
  }
  return xs = r, xs;
}
var Ps, Nf;
function Dv() {
  if (Nf) return Ps;
  Nf = 1;
  function e(t, r) {
    return function(n) {
      return n == null ? !1 : n[t] === r && (r !== void 0 || t in Object(n));
    };
  }
  return Ps = e, Ps;
}
var Os, Uf;
function sb() {
  if (Uf) return Os;
  Uf = 1;
  var e = ab(), t = ib(), r = Dv();
  function n(a) {
    var i = t(a);
    return i.length == 1 && i[0][2] ? r(i[0][0], i[0][1]) : function(s) {
      return s === a || e(s, a, i);
    };
  }
  return Os = n, Os;
}
var Es, Hf;
function Bo() {
  if (Hf) return Es;
  Hf = 1;
  var e = at(), t = it(), r = "[object Symbol]";
  function n(a) {
    return typeof a == "symbol" || t(a) && e(a) == r;
  }
  return Es = n, Es;
}
var Ls, Gf;
function Fo() {
  if (Gf) return Ls;
  Gf = 1;
  var e = Se(), t = Bo(), r = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, n = /^\w*$/;
  function a(i, s) {
    if (e(i))
      return !1;
    var o = typeof i;
    return o == "number" || o == "symbol" || o == "boolean" || i == null || t(i) ? !0 : n.test(i) || !r.test(i) || s != null && i in Object(s);
  }
  return Ls = a, Ls;
}
var Ms, zf;
function ob() {
  if (zf) return Ms;
  zf = 1;
  var e = jo(), t = "Expected a function";
  function r(n, a) {
    if (typeof n != "function" || a != null && typeof a != "function")
      throw new TypeError(t);
    var i = function() {
      var s = arguments, o = a ? a.apply(this, s) : s[0], u = i.cache;
      if (u.has(o))
        return u.get(o);
      var l = n.apply(this, s);
      return i.cache = u.set(o, l) || u, l;
    };
    return i.cache = new (r.Cache || e)(), i;
  }
  return r.Cache = e, Ms = r, Ms;
}
var Ds, Vf;
function ub() {
  if (Vf) return Ds;
  Vf = 1;
  var e = ob(), t = 500;
  function r(n) {
    var a = e(n, function(s) {
      return i.size === t && i.clear(), s;
    }), i = a.cache;
    return a;
  }
  return Ds = r, Ds;
}
var js, Wf;
function lb() {
  if (Wf) return js;
  Wf = 1;
  var e = ub(), t = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, r = /\\(\\)?/g, n = e(function(a) {
    var i = [];
    return a.charCodeAt(0) === 46 && i.push(""), a.replace(t, function(s, o, u, l) {
      i.push(u ? l.replace(r, "$1") : o || s);
    }), i;
  });
  return js = n, js;
}
var Bs, Kf;
function cb() {
  if (Kf) return Bs;
  Kf = 1;
  function e(t, r) {
    for (var n = -1, a = t == null ? 0 : t.length, i = Array(a); ++n < a; )
      i[n] = r(t[n], n, t);
    return i;
  }
  return Bs = e, Bs;
}
var Fs, Xf;
function db() {
  if (Xf) return Fs;
  Xf = 1;
  var e = Pt(), t = cb(), r = Se(), n = Bo(), a = e ? e.prototype : void 0, i = a ? a.toString : void 0;
  function s(o) {
    if (typeof o == "string")
      return o;
    if (r(o))
      return t(o, s) + "";
    if (n(o))
      return i ? i.call(o) : "";
    var u = o + "";
    return u == "0" && 1 / o == -1 / 0 ? "-0" : u;
  }
  return Fs = s, Fs;
}
var Ns, Yf;
function fb() {
  if (Yf) return Ns;
  Yf = 1;
  var e = db();
  function t(r) {
    return r == null ? "" : e(r);
  }
  return Ns = t, Ns;
}
var Us, Jf;
function jv() {
  if (Jf) return Us;
  Jf = 1;
  var e = Se(), t = Fo(), r = lb(), n = fb();
  function a(i, s) {
    return e(i) ? i : t(i, s) ? [i] : r(n(i));
  }
  return Us = a, Us;
}
var Hs, Zf;
function Dt() {
  if (Zf) return Hs;
  Zf = 1;
  var e = Bo();
  function t(r) {
    if (typeof r == "string" || e(r))
      return r;
    var n = r + "";
    return n == "0" && 1 / r == -1 / 0 ? "-0" : n;
  }
  return Hs = t, Hs;
}
var Gs, Qf;
function Bv() {
  if (Qf) return Gs;
  Qf = 1;
  var e = jv(), t = Dt();
  function r(n, a) {
    a = e(a, n);
    for (var i = 0, s = a.length; n != null && i < s; )
      n = n[t(a[i++])];
    return i && i == s ? n : void 0;
  }
  return Gs = r, Gs;
}
var zs, eh;
function hb() {
  if (eh) return zs;
  eh = 1;
  var e = Bv();
  function t(r, n, a) {
    var i = r == null ? void 0 : e(r, n);
    return i === void 0 ? a : i;
  }
  return zs = t, zs;
}
var Vs, th;
function vb() {
  if (th) return Vs;
  th = 1;
  function e(t, r) {
    return t != null && r in Object(t);
  }
  return Vs = e, Vs;
}
var Ws, rh;
function pb() {
  if (rh) return Ws;
  rh = 1;
  var e = jv(), t = Rv(), r = Se(), n = kv(), a = Lo(), i = Dt();
  function s(o, u, l) {
    u = e(u, o);
    for (var d = -1, c = u.length, f = !1; ++d < c; ) {
      var h = i(u[d]);
      if (!(f = o != null && l(o, h)))
        break;
      o = o[h];
    }
    return f || ++d != c ? f : (c = o == null ? 0 : o.length, !!c && a(c) && n(h, c) && (r(o) || t(o)));
  }
  return Ws = s, Ws;
}
var Ks, nh;
function gb() {
  if (nh) return Ks;
  nh = 1;
  var e = vb(), t = pb();
  function r(n, a) {
    return n != null && t(n, a, e);
  }
  return Ks = r, Ks;
}
var Xs, ah;
function _b() {
  if (ah) return Xs;
  ah = 1;
  var e = Lv(), t = hb(), r = gb(), n = Fo(), a = Mv(), i = Dv(), s = Dt(), o = 1, u = 2;
  function l(d, c) {
    return n(d) && a(c) ? i(s(d), c) : function(f) {
      var h = t(f, d);
      return h === void 0 && h === c ? r(f, d) : e(c, h, o | u);
    };
  }
  return Xs = l, Xs;
}
var Ys, ih;
function mb() {
  if (ih) return Ys;
  ih = 1;
  function e(t) {
    return t;
  }
  return Ys = e, Ys;
}
var Js, sh;
function yb() {
  if (sh) return Js;
  sh = 1;
  function e(t) {
    return function(r) {
      return r == null ? void 0 : r[t];
    };
  }
  return Js = e, Js;
}
var Zs, oh;
function bb() {
  if (oh) return Zs;
  oh = 1;
  var e = Bv();
  function t(r) {
    return function(n) {
      return e(n, r);
    };
  }
  return Zs = t, Zs;
}
var Qs, uh;
function Cb() {
  if (uh) return Qs;
  uh = 1;
  var e = yb(), t = bb(), r = Fo(), n = Dt();
  function a(i) {
    return r(i) ? e(n(i)) : t(i);
  }
  return Qs = a, Qs;
}
var eo, lh;
function Sb() {
  if (lh) return eo;
  lh = 1;
  var e = sb(), t = _b(), r = mb(), n = Se(), a = Cb();
  function i(s) {
    return typeof s == "function" ? s : s == null ? r : typeof s == "object" ? n(s) ? t(s[0], s[1]) : e(s) : a(s);
  }
  return eo = i, eo;
}
var to, ch;
function qb() {
  if (ch) return to;
  ch = 1;
  var e = Ym(), t = hy(), r = Sb(), n = Se();
  function a(i, s) {
    return function(o, u) {
      var l = n(o) ? e : t, d = s ? s() : {};
      return l(o, i, r(u, 2), d);
    };
  }
  return to = a, to;
}
var ro, dh;
function wb() {
  if (dh) return ro;
  dh = 1;
  var e = Xm(), t = qb(), r = Object.prototype, n = r.hasOwnProperty, a = t(function(i, s, o) {
    n.call(i, o) ? i[o].push(s) : e(i, o, [s]);
  });
  return ro = a, ro;
}
var $b = wb();
const Tb = /* @__PURE__ */ ce($b), Rb = { class: "related-sections" }, Ab = { class: "related-sections-title" }, kb = { class: "title__span" }, Ib = ["href"], xb = { key: 0 }, Pb = {
  key: 1,
  class: "related-sections-none"
}, Ob = {
  __name: "RelatedSections",
  props: {
    base: {
      type: String,
      required: !0
    },
    item: {
      type: Object,
      required: !0
    },
    label: {
      type: String,
      default: "Related Section"
    },
    partsLastUpdated: {
      type: Object,
      default: () => {
      }
    }
  },
  setup(e) {
    const t = e, r = t.item.cfr_citations ? t.item.cfr_citations.filter((i) => {
      const { part: s } = i;
      return t.partsLastUpdated[s];
    }) : [], n = r.length, a = Tb(r, "title");
    return (i, s) => (v(), _("div", Rb, [
      b("span", Ab, I(e.label) + ": ", 1),
      K(n) > 0 ? (v(!0), _(E, { key: 0 }, X(K(a), (o, u, l) => (v(), _(E, {
        key: u + l
      }, [
        b("span", kb, I(u) + " CFR ", 1),
        o.length > 1 ? (v(), _("span", {
          key: l + u,
          class: "section-sign"
        }, "§§ ")) : (v(), _("span", {
          key: l + u + l,
          class: "section-sign"
        }, "§ ")),
        (v(!0), _(E, null, X(o, (d, c) => (v(), _("span", {
          key: d.display_name + c,
          class: "related-section-link"
        }, [
          b("a", {
            href: K(fm)(d, e.base)
          }, I(K(dm)(d)), 9, Ib),
          c + 1 != o.length ? (v(), _("span", xb, ", ")) : O("", !0)
        ]))), 128)),
        l + 1 != Object.keys(K(a)).length ? (v(), _("span", {
          key: l + u + l,
          class: "pipe-separator"
        }, " | ")) : O("", !0)
      ], 64))), 128)) : (v(), _("span", Pb, "None"))
    ]));
  }
}, Eb = {
  name: "RecentSupplementalContent",
  components: {
    CategoryLabel: Nm,
    SubjectChips: Cv,
    SupplementalContentObject: Sv,
    RelatedSections: Ob,
    CollapseButton: Qe,
    Collapsible: et
  },
  props: {
    supplementalContent: {
      type: Array,
      required: !0
    },
    limit: {
      type: Number,
      required: !1,
      default: 3
    },
    homeUrl: {
      type: String,
      required: !1,
      default: "/"
    },
    partsLastUpdated: {
      type: Object,
      required: !0
    }
  },
  computed: {
    limitedContent() {
      return this.supplementalContent.slice(0, this.limit);
    }
  },
  methods: {
    getCollapseName(e, t) {
      return `related-regulations-collapsible-${e.id || t}`;
    },
    hasValidRegulations(e) {
      return !e.cfr_citations || e.cfr_citations.length === 0 ? !1 : e.cfr_citations.some(
        (t) => this.partsLastUpdated[t.part]
      );
    }
  }
}, Lb = { class: "supplemental-content-list" }, Mb = { class: "result" }, Db = { class: "category-labels" };
function jb(e, t, r, n, a, i) {
  const s = B("CategoryLabel"), o = B("SupplementalContentObject"), u = B("SubjectChips"), l = B("CollapseButton"), d = B("RelatedSections"), c = B("Collapsible");
  return v(), _("div", Lb, [
    (v(!0), _(E, null, X(i.limitedContent, (f, h) => (v(), _(E, {
      key: f.category.name + h
    }, [
      b("div", Mb, [
        b("div", Db, [
          q(s, {
            name: f.category.name,
            type: "category"
          }, null, 8, ["name"])
        ]),
        q(o, {
          name: f.document_id,
          description: f.title,
          date: f.date,
          url: f.url
        }, null, 8, ["name", "description", "date", "url"]),
        q(u, {
          subjects: f.subjects
        }, null, 8, ["subjects"]),
        i.hasValidRegulations(f) ? (v(), D(l, {
          key: 0,
          name: i.getCollapseName(f, h),
          state: "collapsed",
          class: "related-citations__btn--collapse"
        }, {
          expanded: N(() => t[0] || (t[0] = [
            L(" Hide Related Regulations "),
            b("i", { class: "fa fa-chevron-up" }, null, -1)
          ])),
          collapsed: N(() => t[1] || (t[1] = [
            L(" Show Related Regulations "),
            b("i", { class: "fa fa-chevron-down" }, null, -1)
          ])),
          _: 2
        }, 1032, ["name"])) : O("", !0),
        i.hasValidRegulations(f) ? (v(), D(c, {
          key: 1,
          name: i.getCollapseName(f, h),
          state: "collapsed",
          class: "collapse-content",
          overflow: ""
        }, {
          default: N(() => [
            q(d, {
              base: r.homeUrl,
              item: f,
              "parts-last-updated": r.partsLastUpdated,
              label: "Regulations"
            }, null, 8, ["base", "item", "parts-last-updated"])
          ]),
          _: 2
        }, 1032, ["name"])) : O("", !0)
      ]),
      t[2] || (t[2] = b("div", { class: "spacer" }, null, -1))
    ], 64))), 128))
  ]);
}
const Bb = /* @__PURE__ */ z(Eb, [["render", jb]]), Fb = {
  name: "DefaultName",
  components: {
    RelatedRuleList: Oo,
    SimpleSpinner: Fe,
    RecentSupplementalContent: Bb
  },
  props: {
    apiUrl: {
      type: String,
      required: !0
    },
    homeUrl: {
      type: String,
      required: !1,
      default: "/"
    },
    type: {
      type: String,
      required: !1,
      default: "rules"
    },
    categories: {
      type: String,
      required: !1,
      default: null
    },
    partsLastUpdated: {
      type: Object,
      required: !1,
      default: () => ({})
    }
  },
  async created() {
    this.type !== "supplemental" && this.getRules();
  },
  data() {
    return {
      loading: !0,
      rules: []
    };
  },
  provide() {
    return {
      homeUrl: this.homeUrl,
      itemTitleLineLimit: 9,
      currentRouteName: "homepage"
    };
  },
  methods: {
    async getRules(e = {}) {
      const t = {
        page: 1,
        pageSize: 12,
        type: this.type,
        ...e
      }, r = await N1(this.apiUrl, t);
      this.rules = r.results, this.loading = !1;
    }
  },
  watch: {
    async categories(e, t) {
      t === null && this.getRules({ categories: e });
    }
  }
}, Nb = { class: "rules-container" };
function Ub(e, t, r, n, a, i) {
  const s = B("SimpleSpinner"), o = B("RelatedRuleList"), u = B("RecentSupplementalContent");
  return v(), _("div", Nb, [
    a.loading ? (v(), D(s, { key: 0 })) : O("", !0),
    !a.loading && r.type != "supplemental" ? (v(), D(o, {
      key: 1,
      rules: a.rules
    }, null, 8, ["rules"])) : O("", !0),
    !a.loading && r.type == "supplemental" ? (v(), D(u, {
      key: 2,
      "supplemental-content": a.rules,
      "parts-last-updated": r.partsLastUpdated,
      "home-url": r.homeUrl,
      limit: 12
    }, null, 8, ["supplemental-content", "parts-last-updated", "home-url"])) : O("", !0)
  ]);
}
const Hb = /* @__PURE__ */ z(Fb, [["render", Ub]]), gt = typeof window < "u", Gb = gt && "IntersectionObserver" in window;
function No(e, t) {
  if (e === t) return !0;
  if (e instanceof Date && t instanceof Date && e.getTime() !== t.getTime() || e !== Object(e) || t !== Object(t))
    return !1;
  const r = Object.keys(e);
  return r.length !== Object.keys(t).length ? !1 : r.every((n) => No(e[n], t[n]));
}
function ne(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "px";
  if (!(e == null || e === ""))
    return isNaN(+e) ? String(e) : isFinite(+e) ? `${Number(e)}${t}` : void 0;
}
function Fv(e) {
  return e !== null && typeof e == "object" && !Array.isArray(e);
}
function fh(e) {
  let t;
  return e !== null && typeof e == "object" && ((t = Object.getPrototypeOf(e)) === Object.prototype || t === null);
}
function Nv(e) {
  if (e && "$el" in e) {
    const t = e.$el;
    return (t == null ? void 0 : t.nodeType) === Node.TEXT_NODE ? t.nextElementSibling : t;
  }
  return e;
}
const hh = Object.freeze({
  enter: 13,
  tab: 9,
  delete: 46,
  esc: 27,
  space: 32,
  up: 38,
  down: 40,
  left: 37,
  right: 39,
  end: 35,
  home: 36,
  del: 46,
  backspace: 8,
  insert: 45,
  pageup: 33,
  pagedown: 34,
  shift: 16
});
function Uv(e) {
  return Object.keys(e);
}
function no(e, t) {
  return t.every((r) => e.hasOwnProperty(r));
}
function zb(e, t) {
  const r = {}, n = new Set(Object.keys(e));
  for (const a of t)
    n.has(a) && (r[a] = e[a]);
  return r;
}
function Hv(e, t) {
  const r = {
    ...e
  };
  return t.forEach((n) => delete r[n]), r;
}
function Vb(e) {
  return e == null ? [] : Array.isArray(e) ? e : [e];
}
function Wb(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
  return Math.max(t, Math.min(r, e));
}
function vh(e, t) {
  let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "0";
  return e + r.repeat(Math.max(0, t - e.length));
}
function Kb(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  const r = [];
  let n = 0;
  for (; n < e.length; )
    r.push(e.substr(n, t)), n += t;
  return r;
}
function me() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = arguments.length > 2 ? arguments[2] : void 0;
  const n = {};
  for (const a in e)
    n[a] = e[a];
  for (const a in t) {
    const i = e[a], s = t[a];
    if (fh(i) && fh(s)) {
      n[a] = me(i, s, r);
      continue;
    }
    if (r && Array.isArray(i) && Array.isArray(s)) {
      n[a] = r(i, s);
      continue;
    }
    n[a] = s;
  }
  return n;
}
function Gv(e) {
  return e.map((t) => t.type === E ? Gv(t.children) : t).flat();
}
function Te() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
  if (Te.cache.has(e)) return Te.cache.get(e);
  const t = e.replace(/[^a-z]/gi, "-").replace(/\B([A-Z])/g, "-$1").toLowerCase();
  return Te.cache.set(e, t), t;
}
Te.cache = /* @__PURE__ */ new Map();
function ze(e, t) {
  if (!t || typeof t != "object") return [];
  if (Array.isArray(t))
    return t.map((r) => ze(e, r)).flat(1);
  if (t.suspense)
    return ze(e, t.ssContent);
  if (Array.isArray(t.children))
    return t.children.map((r) => ze(e, r)).flat(1);
  if (t.component) {
    if (Object.getOwnPropertySymbols(t.component.provides).includes(e))
      return [t.component];
    if (t.component.subTree)
      return ze(e, t.component.subTree).flat(1);
  }
  return [];
}
function zv(e) {
  const t = vt({}), r = w(e);
  return yo(() => {
    for (const n in r.value)
      t[n] = r.value[n];
  }, {
    flush: "sync"
  }), Fh(t);
}
function ho(e, t) {
  return e.includes(t);
}
function ph(e, t) {
  return t = "on" + Ep(t), !!(e[t] || e[`${t}Once`] || e[`${t}Capture`] || e[`${t}OnceCapture`] || e[`${t}CaptureOnce`]);
}
function Xb(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
  const r = ["button", "[href]", 'input:not([type="hidden"])', "select", "textarea", "[tabindex]"].map((n) => `${n}${t ? ':not([tabindex="-1"])' : ""}:not([disabled])`).join(", ");
  return [...e.querySelectorAll(r)];
}
function Yb() {
  const e = oe(), t = (r) => {
    e.value = r;
  };
  return Object.defineProperty(t, "value", {
    enumerable: !0,
    get: () => e.value,
    set: (r) => e.value = r
  }), Object.defineProperty(t, "el", {
    enumerable: !0,
    get: () => Nv(e.value)
  }), t;
}
const Jb = ["top", "bottom"], Zb = ["start", "end", "left", "right"];
function Qb(e, t) {
  let [r, n] = e.split(" ");
  return n || (n = ho(Jb, r) ? "start" : ho(Zb, r) ? "top" : "center"), {
    side: gh(r, t),
    align: gh(n, t)
  };
}
function gh(e, t) {
  return e === "start" ? t ? "right" : "left" : e === "end" ? t ? "left" : "right" : e;
}
function e0(e, t, r) {
  if (typeof e.animate > "u") return {
    finished: Promise.resolve()
  };
  let n;
  try {
    n = e.animate(t, r);
  } catch {
    return {
      finished: Promise.resolve()
    };
  }
  return typeof n.finished > "u" && (n.finished = new Promise((a) => {
    n.onfinish = () => {
      a(n);
    };
  })), n;
}
const Oe = 2.4, _h = 0.2126729, mh = 0.7151522, yh = 0.072175, t0 = 0.55, r0 = 0.58, n0 = 0.57, a0 = 0.62, lt = 0.03, bh = 1.45, i0 = 5e-4, s0 = 1.25, o0 = 1.25, u0 = 0.078, Ch = 12.82051282051282, ct = 0.06, l0 = 1e-3;
function Sh(e, t) {
  const r = (e.r / 255) ** Oe, n = (e.g / 255) ** Oe, a = (e.b / 255) ** Oe, i = (t.r / 255) ** Oe, s = (t.g / 255) ** Oe, o = (t.b / 255) ** Oe;
  let u = r * _h + n * mh + a * yh, l = i * _h + s * mh + o * yh;
  if (u <= lt && (u += (lt - u) ** bh), l <= lt && (l += (lt - l) ** bh), Math.abs(l - u) < i0) return 0;
  let d;
  if (l > u) {
    const c = (l ** t0 - u ** r0) * s0;
    d = c < l0 ? 0 : c < u0 ? c - c * Ch * ct : c - ct;
  } else {
    const c = (l ** a0 - u ** n0) * o0;
    d = c > -1e-3 ? 0 : c > -0.078 ? c - c * Ch * ct : c + ct;
  }
  return d * 100;
}
function Re(e) {
  Lp(`Vuetify: ${e}`);
}
function vo(e) {
  return !!e && /^(#|var\(--|(rgb|hsl)a?\()/.test(e);
}
function c0(e) {
  return vo(e) && !/^((rgb|hsl)a?\()?var\(--/.test(e);
}
const qh = /^(?<fn>(?:rgb|hsl)a?)\((?<values>.+)\)/, d0 = {
  rgb: (e, t, r, n) => ({
    r: e,
    g: t,
    b: r,
    a: n
  }),
  rgba: (e, t, r, n) => ({
    r: e,
    g: t,
    b: r,
    a: n
  }),
  hsl: (e, t, r, n) => wh({
    h: e,
    s: t,
    l: r,
    a: n
  }),
  hsla: (e, t, r, n) => wh({
    h: e,
    s: t,
    l: r,
    a: n
  }),
  hsv: (e, t, r, n) => We({
    h: e,
    s: t,
    v: r,
    a: n
  }),
  hsva: (e, t, r, n) => We({
    h: e,
    s: t,
    v: r,
    a: n
  })
};
function Ve(e) {
  if (typeof e == "number")
    return (isNaN(e) || e < 0 || e > 16777215) && Re(`'${e}' is not a valid hex color`), {
      r: (e & 16711680) >> 16,
      g: (e & 65280) >> 8,
      b: e & 255
    };
  if (typeof e == "string" && qh.test(e)) {
    const {
      groups: t
    } = e.match(qh), {
      fn: r,
      values: n
    } = t, a = n.split(/,\s*/).map((i) => i.endsWith("%") && ["hsl", "hsla", "hsv", "hsva"].includes(r) ? parseFloat(i) / 100 : parseFloat(i));
    return d0[r](...a);
  } else if (typeof e == "string") {
    let t = e.startsWith("#") ? e.slice(1) : e;
    [3, 4].includes(t.length) ? t = t.split("").map((n) => n + n).join("") : [6, 8].includes(t.length) || Re(`'${e}' is not a valid hex(a) color`);
    const r = parseInt(t, 16);
    return (isNaN(r) || r < 0 || r > 4294967295) && Re(`'${e}' is not a valid hex(a) color`), f0(t);
  } else if (typeof e == "object") {
    if (no(e, ["r", "g", "b"]))
      return e;
    if (no(e, ["h", "s", "l"]))
      return We(Vv(e));
    if (no(e, ["h", "s", "v"]))
      return We(e);
  }
  throw new TypeError(`Invalid color: ${e == null ? e : String(e) || e.constructor.name}
Expected #hex, #hexa, rgb(), rgba(), hsl(), hsla(), object or number`);
}
function We(e) {
  const {
    h: t,
    s: r,
    v: n,
    a
  } = e, i = (o) => {
    const u = (o + t / 60) % 6;
    return n - n * r * Math.max(Math.min(u, 4 - u, 1), 0);
  }, s = [i(5), i(3), i(1)].map((o) => Math.round(o * 255));
  return {
    r: s[0],
    g: s[1],
    b: s[2],
    a
  };
}
function wh(e) {
  return We(Vv(e));
}
function Vv(e) {
  const {
    h: t,
    s: r,
    l: n,
    a
  } = e, i = n + r * Math.min(n, 1 - n), s = i === 0 ? 0 : 2 - 2 * n / i;
  return {
    h: t,
    s,
    v: i,
    a
  };
}
function f0(e) {
  e = h0(e);
  let [t, r, n, a] = Kb(e, 2).map((i) => parseInt(i, 16));
  return a = a === void 0 ? a : a / 255, {
    r: t,
    g: r,
    b: n,
    a
  };
}
function h0(e) {
  return e.startsWith("#") && (e = e.slice(1)), e = e.replace(/([^0-9a-f])/gi, "F"), (e.length === 3 || e.length === 4) && (e = e.split("").map((t) => t + t).join("")), e.length !== 6 && (e = vh(vh(e, 6), 8, "F")), e;
}
function v0(e) {
  const t = Math.abs(Sh(Ve(0), Ve(e)));
  return Math.abs(Sh(Ve(16777215), Ve(e))) > Math.min(t, 50) ? "#fff" : "#000";
}
function U(e, t) {
  return (r) => Object.keys(e).reduce((n, a) => {
    const s = typeof e[a] == "object" && e[a] != null && !Array.isArray(e[a]) ? e[a] : {
      type: e[a]
    };
    return r && a in r ? n[a] = {
      ...s,
      default: r[a]
    } : n[a] = s, t && !n[a].source && (n[a].source = t), n;
  }, {});
}
const xe = U({
  class: [String, Array, Object],
  style: {
    type: [String, Array, Object],
    default: null
  }
}, "component");
function ge(e, t) {
  const r = Nh();
  if (!r)
    throw new Error(`[Vuetify] ${e} must be called from inside a setup function`);
  return r;
}
function $e() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "composables";
  const t = ge(e).type;
  return Te((t == null ? void 0 : t.aliasName) || (t == null ? void 0 : t.name));
}
let Wv = 0, ft = /* @__PURE__ */ new WeakMap();
function Kv() {
  const e = ge("getUid");
  if (ft.has(e)) return ft.get(e);
  {
    const t = Wv++;
    return ft.set(e, t), t;
  }
}
Kv.reset = () => {
  Wv = 0, ft = /* @__PURE__ */ new WeakMap();
};
function p0(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ge("injectSelf");
  const {
    provides: r
  } = t;
  if (r && e in r)
    return r[e];
}
const _t = Symbol.for("vuetify:defaults");
function Uo() {
  const e = se(_t);
  if (!e) throw new Error("[Vuetify] Could not find defaults instance");
  return e;
}
function Ho(e, t) {
  const r = Uo(), n = J(e), a = w(() => {
    if (K(t == null ? void 0 : t.disabled)) return r.value;
    const s = K(t == null ? void 0 : t.scoped), o = K(t == null ? void 0 : t.reset), u = K(t == null ? void 0 : t.root);
    if (n.value == null && !(s || o || u)) return r.value;
    let l = me(n.value, {
      prev: r.value
    });
    if (s) return l;
    if (o || u) {
      const d = Number(o || 1 / 0);
      for (let c = 0; c <= d && !(!l || !("prev" in l)); c++)
        l = l.prev;
      return l && typeof u == "string" && u in l && (l = me(me(l, {
        prev: l
      }), l[u])), l;
    }
    return l.prev ? me(l.prev, l) : l;
  });
  return ye(_t, a), a;
}
function g0(e, t) {
  var r, n;
  return typeof ((r = e.props) == null ? void 0 : r[t]) < "u" || typeof ((n = e.props) == null ? void 0 : n[Te(t)]) < "u";
}
function _0() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 ? arguments[1] : void 0, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Uo();
  const n = ge("useDefaults");
  if (t = t ?? n.type.name ?? n.type.__name, !t)
    throw new Error("[Vuetify] Could not determine component name");
  const a = w(() => {
    var u;
    return (u = r.value) == null ? void 0 : u[e._as ?? t];
  }), i = new Proxy(e, {
    get(u, l) {
      var c, f, h, g, p, m, C;
      const d = Reflect.get(u, l);
      return l === "class" || l === "style" ? [(c = a.value) == null ? void 0 : c[l], d].filter((y) => y != null) : typeof l == "string" && !g0(n.vnode, l) ? ((f = a.value) == null ? void 0 : f[l]) !== void 0 ? (h = a.value) == null ? void 0 : h[l] : ((p = (g = r.value) == null ? void 0 : g.global) == null ? void 0 : p[l]) !== void 0 ? (C = (m = r.value) == null ? void 0 : m.global) == null ? void 0 : C[l] : d : d;
    }
  }), s = oe();
  yo(() => {
    if (a.value) {
      const u = Object.entries(a.value).filter((l) => {
        let [d] = l;
        return d.startsWith(d[0].toUpperCase());
      });
      s.value = u.length ? Object.fromEntries(u) : void 0;
    } else
      s.value = void 0;
  });
  function o() {
    const u = p0(_t, n);
    ye(_t, w(() => s.value ? me((u == null ? void 0 : u.value) ?? {}, s.value) : u == null ? void 0 : u.value));
  }
  return {
    props: i,
    provideSubDefaults: o
  };
}
function jt(e) {
  if (e._setup = e._setup ?? e.setup, !e.name)
    return Re("The component is missing an explicit name, unable to generate default prop value"), e;
  if (e._setup) {
    e.props = U(e.props ?? {}, e.name)();
    const t = Object.keys(e.props).filter((r) => r !== "class" && r !== "style");
    e.filterProps = function(n) {
      return zb(n, t);
    }, e.props._as = String, e.setup = function(n, a) {
      const i = Uo();
      if (!i.value) return e._setup(n, a);
      const {
        props: s,
        provideSubDefaults: o
      } = _0(n, n._as ?? e.name, i), u = e._setup(s, a);
      return o(), u;
    };
  }
  return e;
}
function re() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
  return (t) => (e ? jt : Mp)(t);
}
const m0 = "cubic-bezier(0.4, 0, 0.2, 1)";
function ve(e) {
  const t = ge("useRender");
  t.render = e;
}
const Xv = U({
  border: [Boolean, Number, String]
}, "border");
function Yv(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $e();
  return {
    borderClasses: w(() => {
      const n = Me(e) ? e.value : e.border, a = [];
      if (n === !0 || n === "")
        a.push(`${t}--border`);
      else if (typeof n == "string" || n === 0)
        for (const i of String(n).split(" "))
          a.push(`border-${i}`);
      return a;
    })
  };
}
const y0 = [null, "default", "comfortable", "compact"], Go = U({
  density: {
    type: String,
    default: "default",
    validator: (e) => y0.includes(e)
  }
}, "density");
function zo(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $e();
  return {
    densityClasses: w(() => `${t}--density-${e.density}`)
  };
}
const Jv = U({
  elevation: {
    type: [Number, String],
    validator(e) {
      const t = parseInt(e);
      return !isNaN(t) && t >= 0 && // Material Design has a maximum elevation of 24
      // https://material.io/design/environment/elevation.html#default-elevations
      t <= 24;
    }
  }
}, "elevation");
function Zv(e) {
  return {
    elevationClasses: w(() => {
      const r = Me(e) ? e.value : e.elevation, n = [];
      return r == null || n.push(`elevation-${r}`), n;
    })
  };
}
const Qv = U({
  rounded: {
    type: [Boolean, Number, String],
    default: void 0
  },
  tile: Boolean
}, "rounded");
function ep(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $e();
  return {
    roundedClasses: w(() => {
      const n = Me(e) ? e.value : e.rounded, a = Me(e) ? e.value : e.tile, i = [];
      if (n === !0 || n === "")
        i.push(`${t}--rounded`);
      else if (typeof n == "string" || n === 0)
        for (const s of String(n).split(" "))
          i.push(`rounded-${s}`);
      else (a || n === !1) && i.push("rounded-0");
      return i;
    })
  };
}
const Pe = U({
  tag: {
    type: String,
    default: "div"
  }
}, "tag"), $h = Symbol.for("vuetify:theme"), st = U({
  theme: String
}, "theme");
function ot(e) {
  ge("provideTheme");
  const t = se($h, null);
  if (!t) throw new Error("Could not find Vuetify theme injection");
  const r = w(() => e.theme ?? t.name.value), n = w(() => t.themes.value[r.value]), a = w(() => t.isDisabled ? void 0 : `v-theme--${r.value}`), i = {
    ...t,
    name: r,
    current: n,
    themeClasses: a
  };
  return ye($h, i), i;
}
function Vo(e) {
  return zv(() => {
    const t = [], r = {};
    if (e.value.background)
      if (vo(e.value.background)) {
        if (r.backgroundColor = e.value.background, !e.value.text && c0(e.value.background)) {
          const n = Ve(e.value.background);
          if (n.a == null || n.a === 1) {
            const a = v0(n);
            r.color = a, r.caretColor = a;
          }
        }
      } else
        t.push(`bg-${e.value.background}`);
    return e.value.text && (vo(e.value.text) ? (r.color = e.value.text, r.caretColor = e.value.text) : t.push(`text-${e.value.text}`)), {
      colorClasses: t,
      colorStyles: r
    };
  });
}
function mt(e, t) {
  const r = w(() => ({
    text: Me(e) ? e.value : t ? e[t] : null
  })), {
    colorClasses: n,
    colorStyles: a
  } = Vo(r);
  return {
    textColorClasses: n,
    textColorStyles: a
  };
}
function b0(e, t) {
  const r = w(() => ({
    background: Me(e) ? e.value : null
  })), {
    colorClasses: n,
    colorStyles: a
  } = Vo(r);
  return {
    backgroundColorClasses: n,
    backgroundColorStyles: a
  };
}
const C0 = ["elevated", "flat", "tonal", "outlined", "text", "plain"];
function S0(e, t) {
  return q(E, null, [q("span", {
    key: "overlay",
    class: `${t}__overlay`
  }, null), q("span", {
    key: "underlay",
    class: `${t}__underlay`
  }, null)]);
}
const tp = U({
  color: String,
  variant: {
    type: String,
    default: "elevated",
    validator: (e) => C0.includes(e)
  }
}, "variant");
function q0(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $e();
  const r = w(() => {
    const {
      variant: i
    } = K(e);
    return `${t}--variant-${i}`;
  }), {
    colorClasses: n,
    colorStyles: a
  } = Vo(w(() => {
    const {
      variant: i,
      color: s
    } = K(e);
    return {
      [["elevated", "flat"].includes(i) ? "background" : "text"]: s
    };
  }));
  return {
    colorClasses: n,
    colorStyles: a,
    variantClasses: r
  };
}
const rp = U({
  baseColor: String,
  divided: Boolean,
  ...Xv(),
  ...xe(),
  ...Go(),
  ...Jv(),
  ...Qv(),
  ...Pe(),
  ...st(),
  ...tp()
}, "VBtnGroup"), Th = re()({
  name: "VBtnGroup",
  props: rp(),
  setup(e, t) {
    let {
      slots: r
    } = t;
    const {
      themeClasses: n
    } = ot(e), {
      densityClasses: a
    } = zo(e), {
      borderClasses: i
    } = Yv(e), {
      elevationClasses: s
    } = Zv(e), {
      roundedClasses: o
    } = ep(e);
    Ho({
      VBtn: {
        height: "auto",
        baseColor: Q(e, "baseColor"),
        color: Q(e, "color"),
        density: Q(e, "density"),
        flat: !0,
        variant: Q(e, "variant")
      }
    }), ve(() => q(e.tag, {
      class: ["v-btn-group", {
        "v-btn-group--divided": e.divided
      }, n.value, i.value, a.value, s.value, o.value, e.class],
      style: e.style
    }, r));
  }
});
function w0(e, t) {
  let r;
  function n() {
    r = jp(), r.run(() => t.length ? t(() => {
      r == null || r.stop(), n();
    }) : t());
  }
  he(e, (a) => {
    a && !r ? n() : a || (r == null || r.stop(), r = void 0);
  }, {
    immediate: !0
  }), Dp(() => {
    r == null || r.stop();
  });
}
function Wo(e, t, r) {
  let n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : (c) => c, a = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : (c) => c;
  const i = ge("useProxiedModel"), s = J(e[t] !== void 0 ? e[t] : r), o = Te(t), l = o !== t ? w(() => {
    var c, f, h, g;
    return e[t], !!(((c = i.vnode.props) != null && c.hasOwnProperty(t) || (f = i.vnode.props) != null && f.hasOwnProperty(o)) && ((h = i.vnode.props) != null && h.hasOwnProperty(`onUpdate:${t}`) || (g = i.vnode.props) != null && g.hasOwnProperty(`onUpdate:${o}`)));
  }) : w(() => {
    var c, f;
    return e[t], !!((c = i.vnode.props) != null && c.hasOwnProperty(t) && ((f = i.vnode.props) != null && f.hasOwnProperty(`onUpdate:${t}`)));
  });
  w0(() => !l.value, () => {
    he(() => e[t], (c) => {
      s.value = c;
    });
  });
  const d = w({
    get() {
      const c = e[t];
      return n(l.value ? c : s.value);
    },
    set(c) {
      const f = a(c), h = Bp(l.value ? e[t] : s.value);
      h === f || n(h) === c || (s.value = f, i == null || i.emit(`update:${t}`, f));
    }
  });
  return Object.defineProperty(d, "externalValue", {
    get: () => l.value ? e[t] : s.value
  }), d;
}
const np = U({
  modelValue: {
    type: null,
    default: void 0
  },
  multiple: Boolean,
  mandatory: [Boolean, String],
  max: Number,
  selectedClass: String,
  disabled: Boolean
}, "group"), ap = U({
  value: null,
  disabled: Boolean,
  selectedClass: String
}, "group-item");
function ip(e, t) {
  let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
  const n = ge("useGroupItem");
  if (!n)
    throw new Error("[Vuetify] useGroupItem composable must be used inside a component setup function");
  const a = Kv();
  ye(Symbol.for(`${t.description}:id`), a);
  const i = se(t, null);
  if (!i) {
    if (!r) return i;
    throw new Error(`[Vuetify] Could not find useGroup injection with symbol ${t.description}`);
  }
  const s = Q(e, "value"), o = w(() => !!(i.disabled.value || e.disabled));
  i.register({
    id: a,
    value: s,
    disabled: o
  }, n), qt(() => {
    i.unregister(a);
  });
  const u = w(() => i.isSelected(a)), l = w(() => i.items.value[0].id === a), d = w(() => i.items.value[i.items.value.length - 1].id === a), c = w(() => u.value && [i.selectedClass.value, e.selectedClass]);
  return he(u, (f) => {
    n.emit("group:selected", {
      value: f
    });
  }, {
    flush: "sync"
  }), {
    id: a,
    isSelected: u,
    isFirst: l,
    isLast: d,
    toggle: () => i.select(a, !u.value),
    select: (f) => i.select(a, f),
    selectedClass: c,
    value: s,
    disabled: o,
    group: i
  };
}
function Ko(e, t) {
  let r = !1;
  const n = vt([]), a = Wo(e, "modelValue", [], (f) => f == null ? [] : sp(n, Vb(f)), (f) => {
    const h = T0(n, f);
    return e.multiple ? h : h[0];
  }), i = ge("useGroup");
  function s(f, h) {
    const g = f, p = Symbol.for(`${t.description}:id`), C = ze(p, i == null ? void 0 : i.vnode).indexOf(h);
    K(g.value) == null && (g.value = C, g.useIndexAsValue = !0), C > -1 ? n.splice(C, 0, g) : n.push(g);
  }
  function o(f) {
    if (r) return;
    u();
    const h = n.findIndex((g) => g.id === f);
    n.splice(h, 1);
  }
  function u() {
    const f = n.find((h) => !h.disabled);
    f && e.mandatory === "force" && !a.value.length && (a.value = [f.id]);
  }
  Le(() => {
    u();
  }), qt(() => {
    r = !0;
  }), Fp(() => {
    for (let f = 0; f < n.length; f++)
      n[f].useIndexAsValue && (n[f].value = f);
  });
  function l(f, h) {
    const g = n.find((p) => p.id === f);
    if (!(h && (g != null && g.disabled)))
      if (e.multiple) {
        const p = a.value.slice(), m = p.findIndex((y) => y === f), C = ~m;
        if (h = h ?? !C, C && e.mandatory && p.length <= 1 || !C && e.max != null && p.length + 1 > e.max) return;
        m < 0 && h ? p.push(f) : m >= 0 && !h && p.splice(m, 1), a.value = p;
      } else {
        const p = a.value.includes(f);
        if (e.mandatory && p) return;
        a.value = h ?? !p ? [f] : [];
      }
  }
  function d(f) {
    if (e.multiple && Re('This method is not supported when using "multiple" prop'), a.value.length) {
      const h = a.value[0], g = n.findIndex((C) => C.id === h);
      let p = (g + f) % n.length, m = n[p];
      for (; m.disabled && p !== g; )
        p = (p + f) % n.length, m = n[p];
      if (m.disabled) return;
      a.value = [n[p].id];
    } else {
      const h = n.find((g) => !g.disabled);
      h && (a.value = [h.id]);
    }
  }
  const c = {
    register: s,
    unregister: o,
    selected: a,
    select: l,
    disabled: Q(e, "disabled"),
    prev: () => d(n.length - 1),
    next: () => d(1),
    isSelected: (f) => a.value.includes(f),
    selectedClass: w(() => e.selectedClass),
    items: w(() => n),
    getItemIndex: (f) => $0(n, f)
  };
  return ye(t, c), c;
}
function $0(e, t) {
  const r = sp(e, [t]);
  return r.length ? e.findIndex((n) => n.id === r[0]) : -1;
}
function sp(e, t) {
  const r = [];
  return t.forEach((n) => {
    const a = e.find((s) => No(n, s.value)), i = e[n];
    (a == null ? void 0 : a.value) != null ? r.push(a.id) : i != null && r.push(i.id);
  }), r;
}
function T0(e, t) {
  const r = [];
  return t.forEach((n) => {
    const a = e.findIndex((i) => i.id === n);
    if (~a) {
      const i = e[a];
      r.push(i.value != null ? i.value : a);
    }
  }), r;
}
const op = Symbol.for("vuetify:v-btn-toggle"), R0 = U({
  ...rp(),
  ...np()
}, "VBtnToggle");
re()({
  name: "VBtnToggle",
  props: R0(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      slots: r
    } = t;
    const {
      isSelected: n,
      next: a,
      prev: i,
      select: s,
      selected: o
    } = Ko(e, op);
    return ve(() => {
      const u = Th.filterProps(e);
      return q(Th, ie({
        class: ["v-btn-toggle", e.class]
      }, u, {
        style: e.style
      }), {
        default: () => {
          var l;
          return [(l = r.default) == null ? void 0 : l.call(r, {
            isSelected: n,
            next: a,
            prev: i,
            select: s,
            selected: o
          })];
        }
      });
    }), {
      next: a,
      prev: i,
      select: s
    };
  }
});
const A0 = U({
  defaults: Object,
  disabled: Boolean,
  reset: [Number, String],
  root: [Boolean, String],
  scoped: Boolean
}, "VDefaultsProvider"), ao = re(!1)({
  name: "VDefaultsProvider",
  props: A0(),
  setup(e, t) {
    let {
      slots: r
    } = t;
    const {
      defaults: n,
      disabled: a,
      reset: i,
      root: s,
      scoped: o
    } = Fh(e);
    return Ho(n, {
      reset: i,
      root: s,
      scoped: o,
      disabled: a
    }), () => {
      var u;
      return (u = r.default) == null ? void 0 : u.call(r);
    };
  }
}), je = [String, Function, Object, Array], k0 = Symbol.for("vuetify:icons"), Bt = U({
  icon: {
    type: je
  },
  // Could not remove this and use makeTagProps, types complained because it is not required
  tag: {
    type: String,
    required: !0
  }
}, "icon"), Rh = re()({
  name: "VComponentIcon",
  props: Bt(),
  setup(e, t) {
    let {
      slots: r
    } = t;
    return () => {
      const n = e.icon;
      return q(e.tag, null, {
        default: () => {
          var a;
          return [e.icon ? q(n, null, null) : (a = r.default) == null ? void 0 : a.call(r)];
        }
      });
    };
  }
}), I0 = jt({
  name: "VSvgIcon",
  inheritAttrs: !1,
  props: Bt(),
  setup(e, t) {
    let {
      attrs: r
    } = t;
    return () => q(e.tag, ie(r, {
      style: null
    }), {
      default: () => [q("svg", {
        class: "v-icon__svg",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        role: "img",
        "aria-hidden": "true"
      }, [Array.isArray(e.icon) ? e.icon.map((n) => Array.isArray(n) ? q("path", {
        d: n[0],
        "fill-opacity": n[1]
      }, null) : q("path", {
        d: n
      }, null)) : q("path", {
        d: e.icon
      }, null)])]
    });
  }
});
jt({
  name: "VLigatureIcon",
  props: Bt(),
  setup(e) {
    return () => q(e.tag, null, {
      default: () => [e.icon]
    });
  }
});
jt({
  name: "VClassIcon",
  props: Bt(),
  setup(e) {
    return () => q(e.tag, {
      class: e.icon
    }, null);
  }
});
const x0 = (e) => {
  const t = se(k0);
  if (!t) throw new Error("Missing Vuetify Icons provide!");
  return {
    iconData: w(() => {
      var u;
      const n = K(e);
      if (!n) return {
        component: Rh
      };
      let a = n;
      if (typeof a == "string" && (a = a.trim(), a.startsWith("$") && (a = (u = t.aliases) == null ? void 0 : u[a.slice(1)])), a || Re(`Could not find aliased icon "${n}"`), Array.isArray(a))
        return {
          component: I0,
          icon: a
        };
      if (typeof a != "string")
        return {
          component: Rh,
          icon: a
        };
      const i = Object.keys(t.sets).find((l) => typeof a == "string" && a.startsWith(`${l}:`)), s = i ? a.slice(i.length + 1) : a;
      return {
        component: t.sets[i ?? t.defaultSet].component,
        icon: s
      };
    })
  };
}, P0 = ["x-small", "small", "default", "large", "x-large"], Xo = U({
  size: {
    type: [String, Number],
    default: "default"
  }
}, "size");
function Yo(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $e();
  return zv(() => {
    let r, n;
    return ho(P0, e.size) ? r = `${t}--size-${e.size}` : e.size && (n = {
      width: ne(e.size),
      height: ne(e.size)
    }), {
      sizeClasses: r,
      sizeStyles: n
    };
  });
}
const O0 = U({
  color: String,
  disabled: Boolean,
  start: Boolean,
  end: Boolean,
  icon: je,
  ...xe(),
  ...Xo(),
  ...Pe({
    tag: "i"
  }),
  ...st()
}, "VIcon"), Ee = re()({
  name: "VIcon",
  props: O0(),
  setup(e, t) {
    let {
      attrs: r,
      slots: n
    } = t;
    const a = J(), {
      themeClasses: i
    } = ot(e), {
      iconData: s
    } = x0(w(() => a.value || e.icon)), {
      sizeClasses: o
    } = Yo(e), {
      textColorClasses: u,
      textColorStyles: l
    } = mt(Q(e, "color"));
    return ve(() => {
      var f, h;
      const d = (f = n.default) == null ? void 0 : f.call(n);
      d && (a.value = (h = Gv(d).filter((g) => g.type === Np && g.children && typeof g.children == "string")[0]) == null ? void 0 : h.children);
      const c = !!(r.onClick || r.onClickOnce);
      return q(s.value.component, {
        tag: e.tag,
        icon: s.value.icon,
        class: ["v-icon", "notranslate", i.value, o.value, u.value, {
          "v-icon--clickable": c,
          "v-icon--disabled": e.disabled,
          "v-icon--start": e.start,
          "v-icon--end": e.end
        }, e.class],
        style: [o.value ? void 0 : {
          fontSize: ne(e.size),
          height: ne(e.size),
          width: ne(e.size)
        }, l.value, e.style],
        role: c ? "button" : void 0,
        "aria-hidden": !c,
        tabindex: c ? e.disabled ? -1 : 0 : void 0
      }, {
        default: () => [d]
      });
    }), {};
  }
});
function E0(e, t) {
  const r = J(), n = oe(!1);
  if (Gb) {
    const a = new IntersectionObserver((i) => {
      n.value = !!i.find((s) => s.isIntersecting);
    }, t);
    qt(() => {
      a.disconnect();
    }), he(r, (i, s) => {
      s && (a.unobserve(s), n.value = !1), i && a.observe(i);
    }, {
      flush: "post"
    });
  }
  return {
    intersectionRef: r,
    isIntersecting: n
  };
}
function po(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "content";
  const r = Yb(), n = J();
  if (gt) {
    const a = new ResizeObserver((i) => {
      i.length && (t === "content" ? n.value = i[0].contentRect : n.value = i[0].target.getBoundingClientRect());
    });
    qt(() => {
      a.disconnect();
    }), he(() => r.el, (i, s) => {
      s && (a.unobserve(s), n.value = void 0), i && a.observe(i);
    }, {
      flush: "post"
    });
  }
  return {
    resizeRef: r,
    contentRect: Uh(n)
  };
}
const L0 = U({
  bgColor: String,
  color: String,
  indeterminate: [Boolean, String],
  modelValue: {
    type: [Number, String],
    default: 0
  },
  rotate: {
    type: [Number, String],
    default: 0
  },
  width: {
    type: [Number, String],
    default: 4
  },
  ...xe(),
  ...Xo(),
  ...Pe({
    tag: "div"
  }),
  ...st()
}, "VProgressCircular"), M0 = re()({
  name: "VProgressCircular",
  props: L0(),
  setup(e, t) {
    let {
      slots: r
    } = t;
    const n = 20, a = 2 * Math.PI * n, i = J(), {
      themeClasses: s
    } = ot(e), {
      sizeClasses: o,
      sizeStyles: u
    } = Yo(e), {
      textColorClasses: l,
      textColorStyles: d
    } = mt(Q(e, "color")), {
      textColorClasses: c,
      textColorStyles: f
    } = mt(Q(e, "bgColor")), {
      intersectionRef: h,
      isIntersecting: g
    } = E0(), {
      resizeRef: p,
      contentRect: m
    } = po(), C = w(() => Math.max(0, Math.min(100, parseFloat(e.modelValue)))), y = w(() => Number(e.width)), A = w(() => u.value ? Number(e.size) : m.value ? m.value.width : Math.max(y.value, 32)), S = w(() => n / (1 - y.value / A.value) * 2), k = w(() => y.value / A.value * S.value), T = w(() => ne((100 - C.value) / 100 * a));
    return yo(() => {
      h.value = i.value, p.value = i.value;
    }), ve(() => q(e.tag, {
      ref: i,
      class: ["v-progress-circular", {
        "v-progress-circular--indeterminate": !!e.indeterminate,
        "v-progress-circular--visible": g.value,
        "v-progress-circular--disable-shrink": e.indeterminate === "disable-shrink"
      }, s.value, o.value, l.value, e.class],
      style: [u.value, d.value, e.style],
      role: "progressbar",
      "aria-valuemin": "0",
      "aria-valuemax": "100",
      "aria-valuenow": e.indeterminate ? void 0 : C.value
    }, {
      default: () => [q("svg", {
        style: {
          transform: `rotate(calc(-90deg + ${Number(e.rotate)}deg))`
        },
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: `0 0 ${S.value} ${S.value}`
      }, [q("circle", {
        class: ["v-progress-circular__underlay", c.value],
        style: f.value,
        fill: "transparent",
        cx: "50%",
        cy: "50%",
        r: n,
        "stroke-width": k.value,
        "stroke-dasharray": a,
        "stroke-dashoffset": 0
      }, null), q("circle", {
        class: "v-progress-circular__overlay",
        fill: "transparent",
        cx: "50%",
        cy: "50%",
        r: n,
        "stroke-width": k.value,
        "stroke-dasharray": a,
        "stroke-dashoffset": T.value
      }, null)]), r.default && q("div", {
        class: "v-progress-circular__content"
      }, [r.default({
        value: C.value
      })])]
    })), {};
  }
}), D0 = U({
  height: [Number, String],
  maxHeight: [Number, String],
  maxWidth: [Number, String],
  minHeight: [Number, String],
  minWidth: [Number, String],
  width: [Number, String]
}, "dimension");
function j0(e) {
  return {
    dimensionStyles: w(() => {
      const r = {}, n = ne(e.height), a = ne(e.maxHeight), i = ne(e.maxWidth), s = ne(e.minHeight), o = ne(e.minWidth), u = ne(e.width);
      return n != null && (r.height = n), a != null && (r.maxHeight = a), i != null && (r.maxWidth = i), s != null && (r.minHeight = s), o != null && (r.minWidth = o), u != null && (r.width = u), r;
    })
  };
}
const up = Symbol.for("vuetify:locale");
function B0() {
  const e = se(up);
  if (!e) throw new Error("[Vuetify] Could not find injected locale instance");
  return e;
}
function Ft() {
  const e = se(up);
  if (!e) throw new Error("[Vuetify] Could not find injected rtl instance");
  return {
    isRtl: e.isRtl,
    rtlClasses: e.rtlClasses
  };
}
const Ah = {
  center: "center",
  top: "bottom",
  bottom: "top",
  left: "right",
  right: "left"
}, F0 = U({
  location: String
}, "location");
function N0(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, r = arguments.length > 2 ? arguments[2] : void 0;
  const {
    isRtl: n
  } = Ft();
  return {
    locationStyles: w(() => {
      if (!e.location) return {};
      const {
        side: i,
        align: s
      } = Qb(e.location.split(" ").length > 1 ? e.location : `${e.location} center`, n.value);
      function o(l) {
        return r ? r(l) : 0;
      }
      const u = {};
      return i !== "center" && (t ? u[Ah[i]] = `calc(100% - ${o(i)}px)` : u[i] = 0), s !== "center" ? t ? u[Ah[s]] = `calc(100% - ${o(s)}px)` : u[s] = 0 : (i === "center" ? u.top = u.left = "50%" : u[{
        top: "left",
        bottom: "left",
        left: "top",
        right: "top"
      }[i]] = "50%", u.transform = {
        top: "translateX(-50%)",
        bottom: "translateX(-50%)",
        left: "translateY(-50%)",
        right: "translateY(-50%)",
        center: "translate(-50%, -50%)"
      }[i]), u;
    })
  };
}
const U0 = U({
  loading: [Boolean, String]
}, "loader");
function H0(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $e();
  return {
    loaderClasses: w(() => ({
      [`${t}--loading`]: e.loading
    }))
  };
}
const G0 = ["static", "relative", "fixed", "absolute", "sticky"], z0 = U({
  position: {
    type: String,
    validator: (
      /* istanbul ignore next */
      (e) => G0.includes(e)
    )
  }
}, "position");
function V0(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $e();
  return {
    positionClasses: w(() => e.position ? `${t}--${e.position}` : void 0)
  };
}
function W0() {
  const e = ge("useRoute");
  return w(() => {
    var t;
    return (t = e == null ? void 0 : e.proxy) == null ? void 0 : t.$route;
  });
}
function K0(e, t) {
  var c, f;
  const r = Up("RouterLink"), n = w(() => !!(e.href || e.to)), a = w(() => (n == null ? void 0 : n.value) || ph(t, "click") || ph(e, "click"));
  if (typeof r == "string" || !("useLink" in r)) {
    const h = Q(e, "href");
    return {
      isLink: n,
      isClickable: a,
      href: h,
      linkProps: vt({
        href: h
      })
    };
  }
  const i = w(() => ({
    ...e,
    to: Q(() => e.to || "")
  })), s = r.useLink(i.value), o = w(() => e.to ? s : void 0), u = W0(), l = w(() => {
    var h, g, p;
    return o.value ? e.exact ? u.value ? ((p = o.value.isExactActive) == null ? void 0 : p.value) && No(o.value.route.value.query, u.value.query) : ((g = o.value.isExactActive) == null ? void 0 : g.value) ?? !1 : ((h = o.value.isActive) == null ? void 0 : h.value) ?? !1 : !1;
  }), d = w(() => {
    var h;
    return e.to ? (h = o.value) == null ? void 0 : h.route.value.href : e.href;
  });
  return {
    isLink: n,
    isClickable: a,
    isActive: l,
    route: (c = o.value) == null ? void 0 : c.route,
    navigate: (f = o.value) == null ? void 0 : f.navigate,
    href: d,
    linkProps: vt({
      href: d,
      "aria-current": w(() => l.value ? "page" : void 0)
    })
  };
}
const X0 = U({
  href: String,
  replace: Boolean,
  to: [String, Object],
  exact: Boolean
}, "router");
function Y0(e, t) {
  he(() => {
    var r;
    return (r = e.isActive) == null ? void 0 : r.value;
  }, (r) => {
    e.isLink.value && r && t && Hh(() => {
      t(!0);
    });
  }, {
    immediate: !0
  });
}
const go = Symbol("rippleStop"), J0 = 80;
function kh(e, t) {
  e.style.transform = t, e.style.webkitTransform = t;
}
function _o(e) {
  return e.constructor.name === "TouchEvent";
}
function lp(e) {
  return e.constructor.name === "KeyboardEvent";
}
const Z0 = function(e, t) {
  var c;
  let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, n = 0, a = 0;
  if (!lp(e)) {
    const f = t.getBoundingClientRect(), h = _o(e) ? e.touches[e.touches.length - 1] : e;
    n = h.clientX - f.left, a = h.clientY - f.top;
  }
  let i = 0, s = 0.3;
  (c = t._ripple) != null && c.circle ? (s = 0.15, i = t.clientWidth / 2, i = r.center ? i : i + Math.sqrt((n - i) ** 2 + (a - i) ** 2) / 4) : i = Math.sqrt(t.clientWidth ** 2 + t.clientHeight ** 2) / 2;
  const o = `${(t.clientWidth - i * 2) / 2}px`, u = `${(t.clientHeight - i * 2) / 2}px`, l = r.center ? o : `${n - i}px`, d = r.center ? u : `${a - i}px`;
  return {
    radius: i,
    scale: s,
    x: l,
    y: d,
    centerX: o,
    centerY: u
  };
}, yt = {
  /* eslint-disable max-statements */
  show(e, t) {
    var h;
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    if (!((h = t == null ? void 0 : t._ripple) != null && h.enabled))
      return;
    const n = document.createElement("span"), a = document.createElement("span");
    n.appendChild(a), n.className = "v-ripple__container", r.class && (n.className += ` ${r.class}`);
    const {
      radius: i,
      scale: s,
      x: o,
      y: u,
      centerX: l,
      centerY: d
    } = Z0(e, t, r), c = `${i * 2}px`;
    a.className = "v-ripple__animation", a.style.width = c, a.style.height = c, t.appendChild(n);
    const f = window.getComputedStyle(t);
    f && f.position === "static" && (t.style.position = "relative", t.dataset.previousPosition = "static"), a.classList.add("v-ripple__animation--enter"), a.classList.add("v-ripple__animation--visible"), kh(a, `translate(${o}, ${u}) scale3d(${s},${s},${s})`), a.dataset.activated = String(performance.now()), requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        a.classList.remove("v-ripple__animation--enter"), a.classList.add("v-ripple__animation--in"), kh(a, `translate(${l}, ${d}) scale3d(1,1,1)`);
      });
    });
  },
  hide(e) {
    var i;
    if (!((i = e == null ? void 0 : e._ripple) != null && i.enabled)) return;
    const t = e.getElementsByClassName("v-ripple__animation");
    if (t.length === 0) return;
    const r = t[t.length - 1];
    if (r.dataset.isHiding) return;
    r.dataset.isHiding = "true";
    const n = performance.now() - Number(r.dataset.activated), a = Math.max(250 - n, 0);
    setTimeout(() => {
      r.classList.remove("v-ripple__animation--in"), r.classList.add("v-ripple__animation--out"), setTimeout(() => {
        var o;
        e.getElementsByClassName("v-ripple__animation").length === 1 && e.dataset.previousPosition && (e.style.position = e.dataset.previousPosition, delete e.dataset.previousPosition), ((o = r.parentNode) == null ? void 0 : o.parentNode) === e && e.removeChild(r.parentNode);
      }, 300);
    }, a);
  }
};
function cp(e) {
  return typeof e > "u" || !!e;
}
function Ke(e) {
  const t = {}, r = e.currentTarget;
  if (!(!(r != null && r._ripple) || r._ripple.touched || e[go])) {
    if (e[go] = !0, _o(e))
      r._ripple.touched = !0, r._ripple.isTouch = !0;
    else if (r._ripple.isTouch) return;
    if (t.center = r._ripple.centered || lp(e), r._ripple.class && (t.class = r._ripple.class), _o(e)) {
      if (r._ripple.showTimerCommit) return;
      r._ripple.showTimerCommit = () => {
        yt.show(e, r, t);
      }, r._ripple.showTimer = window.setTimeout(() => {
        var n;
        (n = r == null ? void 0 : r._ripple) != null && n.showTimerCommit && (r._ripple.showTimerCommit(), r._ripple.showTimerCommit = null);
      }, J0);
    } else
      yt.show(e, r, t);
  }
}
function Ih(e) {
  e[go] = !0;
}
function ue(e) {
  const t = e.currentTarget;
  if (t != null && t._ripple) {
    if (window.clearTimeout(t._ripple.showTimer), e.type === "touchend" && t._ripple.showTimerCommit) {
      t._ripple.showTimerCommit(), t._ripple.showTimerCommit = null, t._ripple.showTimer = window.setTimeout(() => {
        ue(e);
      });
      return;
    }
    window.setTimeout(() => {
      t._ripple && (t._ripple.touched = !1);
    }), yt.hide(t);
  }
}
function dp(e) {
  const t = e.currentTarget;
  t != null && t._ripple && (t._ripple.showTimerCommit && (t._ripple.showTimerCommit = null), window.clearTimeout(t._ripple.showTimer));
}
let Xe = !1;
function fp(e) {
  !Xe && (e.keyCode === hh.enter || e.keyCode === hh.space) && (Xe = !0, Ke(e));
}
function hp(e) {
  Xe = !1, ue(e);
}
function vp(e) {
  Xe && (Xe = !1, ue(e));
}
function pp(e, t, r) {
  const {
    value: n,
    modifiers: a
  } = t, i = cp(n);
  if (i || yt.hide(e), e._ripple = e._ripple ?? {}, e._ripple.enabled = i, e._ripple.centered = a.center, e._ripple.circle = a.circle, Fv(n) && n.class && (e._ripple.class = n.class), i && !r) {
    if (a.stop) {
      e.addEventListener("touchstart", Ih, {
        passive: !0
      }), e.addEventListener("mousedown", Ih);
      return;
    }
    e.addEventListener("touchstart", Ke, {
      passive: !0
    }), e.addEventListener("touchend", ue, {
      passive: !0
    }), e.addEventListener("touchmove", dp, {
      passive: !0
    }), e.addEventListener("touchcancel", ue), e.addEventListener("mousedown", Ke), e.addEventListener("mouseup", ue), e.addEventListener("mouseleave", ue), e.addEventListener("keydown", fp), e.addEventListener("keyup", hp), e.addEventListener("blur", vp), e.addEventListener("dragstart", ue, {
      passive: !0
    });
  } else !i && r && gp(e);
}
function gp(e) {
  e.removeEventListener("mousedown", Ke), e.removeEventListener("touchstart", Ke), e.removeEventListener("touchend", ue), e.removeEventListener("touchmove", dp), e.removeEventListener("touchcancel", ue), e.removeEventListener("mouseup", ue), e.removeEventListener("mouseleave", ue), e.removeEventListener("keydown", fp), e.removeEventListener("keyup", hp), e.removeEventListener("dragstart", ue), e.removeEventListener("blur", vp);
}
function Q0(e, t) {
  pp(e, t, !1);
}
function eC(e) {
  delete e._ripple, gp(e);
}
function tC(e, t) {
  if (t.value === t.oldValue)
    return;
  const r = cp(t.oldValue);
  pp(e, t, r);
}
const rC = {
  mounted: Q0,
  unmounted: eC,
  updated: tC
}, _p = U({
  active: {
    type: Boolean,
    default: void 0
  },
  activeColor: String,
  baseColor: String,
  symbol: {
    type: null,
    default: op
  },
  flat: Boolean,
  icon: [Boolean, String, Function, Object],
  prependIcon: je,
  appendIcon: je,
  block: Boolean,
  readonly: Boolean,
  slim: Boolean,
  stacked: Boolean,
  ripple: {
    type: [Boolean, Object],
    default: !0
  },
  text: String,
  ...Xv(),
  ...xe(),
  ...Go(),
  ...D0(),
  ...Jv(),
  ...ap(),
  ...U0(),
  ...F0(),
  ...z0(),
  ...Qv(),
  ...X0(),
  ...Xo(),
  ...Pe({
    tag: "button"
  }),
  ...st(),
  ...tp({
    variant: "elevated"
  })
}, "VBtn"), Ye = re()({
  name: "VBtn",
  props: _p(),
  emits: {
    "group:selected": (e) => !0
  },
  setup(e, t) {
    let {
      attrs: r,
      slots: n
    } = t;
    const {
      themeClasses: a
    } = ot(e), {
      borderClasses: i
    } = Yv(e), {
      densityClasses: s
    } = zo(e), {
      dimensionStyles: o
    } = j0(e), {
      elevationClasses: u
    } = Zv(e), {
      loaderClasses: l
    } = H0(e), {
      locationStyles: d
    } = N0(e), {
      positionClasses: c
    } = V0(e), {
      roundedClasses: f
    } = ep(e), {
      sizeClasses: h,
      sizeStyles: g
    } = Yo(e), p = ip(e, e.symbol, !1), m = K0(e, r), C = w(() => {
      var R;
      return e.active !== void 0 ? e.active : m.isLink.value ? (R = m.isActive) == null ? void 0 : R.value : p == null ? void 0 : p.isSelected.value;
    }), y = w(() => C.value ? e.activeColor ?? e.color : e.color), A = w(() => {
      var V, H;
      return {
        color: (p == null ? void 0 : p.isSelected.value) && (!m.isLink.value || ((V = m.isActive) == null ? void 0 : V.value)) || !p || ((H = m.isActive) == null ? void 0 : H.value) ? y.value ?? e.baseColor : e.baseColor,
        variant: e.variant
      };
    }), {
      colorClasses: S,
      colorStyles: k,
      variantClasses: T
    } = q0(A), $ = w(() => (p == null ? void 0 : p.disabled.value) || e.disabled), M = w(() => e.variant === "elevated" && !(e.disabled || e.flat || e.border)), j = w(() => {
      if (!(e.value === void 0 || typeof e.value == "symbol"))
        return Object(e.value) === e.value ? JSON.stringify(e.value, null, 0) : e.value;
    });
    function F(R) {
      var V;
      $.value || m.isLink.value && (R.metaKey || R.ctrlKey || R.shiftKey || R.button !== 0 || r.target === "_blank") || ((V = m.navigate) == null || V.call(m, R), p == null || p.toggle());
    }
    return Y0(m, p == null ? void 0 : p.select), ve(() => {
      const R = m.isLink.value ? "a" : e.tag, V = !!(e.prependIcon || n.prepend), H = !!(e.appendIcon || n.append), ee = !!(e.icon && e.icon !== !0);
      return te(q(R, ie({
        type: R === "a" ? void 0 : "button",
        class: ["v-btn", p == null ? void 0 : p.selectedClass.value, {
          "v-btn--active": C.value,
          "v-btn--block": e.block,
          "v-btn--disabled": $.value,
          "v-btn--elevated": M.value,
          "v-btn--flat": e.flat,
          "v-btn--icon": !!e.icon,
          "v-btn--loading": e.loading,
          "v-btn--readonly": e.readonly,
          "v-btn--slim": e.slim,
          "v-btn--stacked": e.stacked
        }, a.value, i.value, S.value, s.value, u.value, l.value, c.value, f.value, h.value, T.value, e.class],
        style: [k.value, o.value, d.value, g.value, e.style],
        "aria-busy": e.loading ? !0 : void 0,
        disabled: $.value || void 0,
        tabindex: e.loading || e.readonly ? -1 : void 0,
        onClick: F,
        value: j.value
      }, m.linkProps), {
        default: () => {
          var Z;
          return [S0(!0, "v-btn"), !e.icon && V && q("span", {
            key: "prepend",
            class: "v-btn__prepend"
          }, [n.prepend ? q(ao, {
            key: "prepend-defaults",
            disabled: !e.prependIcon,
            defaults: {
              VIcon: {
                icon: e.prependIcon
              }
            }
          }, n.prepend) : q(Ee, {
            key: "prepend-icon",
            icon: e.prependIcon
          }, null)]), q("span", {
            class: "v-btn__content",
            "data-no-activator": ""
          }, [!n.default && ee ? q(Ee, {
            key: "content-icon",
            icon: e.icon
          }, null) : q(ao, {
            key: "content-defaults",
            disabled: !ee,
            defaults: {
              VIcon: {
                icon: e.icon
              }
            }
          }, {
            default: () => {
              var _e;
              return [((_e = n.default) == null ? void 0 : _e.call(n)) ?? e.text];
            }
          })]), !e.icon && H && q("span", {
            key: "append",
            class: "v-btn__append"
          }, [n.append ? q(ao, {
            key: "append-defaults",
            disabled: !e.appendIcon,
            defaults: {
              VIcon: {
                icon: e.appendIcon
              }
            }
          }, n.append) : q(Ee, {
            key: "append-icon",
            icon: e.appendIcon
          }, null)]), !!e.loading && q("span", {
            key: "loader",
            class: "v-btn__loader"
          }, [((Z = n.loader) == null ? void 0 : Z.call(n)) ?? q(M0, {
            color: typeof e.loading == "boolean" ? void 0 : e.loading,
            indeterminate: !0,
            width: "2"
          }, null)])];
        }
      }), [[rC, !$.value && e.ripple, "", {
        center: !!e.icon
      }]]);
    }), {
      group: p
    };
  }
}), io = Symbol("Forwarded refs");
function so(e, t) {
  let r = e;
  for (; r; ) {
    const n = Reflect.getOwnPropertyDescriptor(r, t);
    if (n) return n;
    r = Object.getPrototypeOf(r);
  }
}
function nC(e) {
  for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)
    r[n - 1] = arguments[n];
  return e[io] = r, new Proxy(e, {
    get(a, i) {
      if (Reflect.has(a, i))
        return Reflect.get(a, i);
      if (!(typeof i == "symbol" || i.startsWith("$") || i.startsWith("__"))) {
        for (const s of r)
          if (s.value && Reflect.has(s.value, i)) {
            const o = Reflect.get(s.value, i);
            return typeof o == "function" ? o.bind(s.value) : o;
          }
      }
    },
    has(a, i) {
      if (Reflect.has(a, i))
        return !0;
      if (typeof i == "symbol" || i.startsWith("$") || i.startsWith("__")) return !1;
      for (const s of r)
        if (s.value && Reflect.has(s.value, i))
          return !0;
      return !1;
    },
    set(a, i, s) {
      if (Reflect.has(a, i))
        return Reflect.set(a, i, s);
      if (typeof i == "symbol" || i.startsWith("$") || i.startsWith("__")) return !1;
      for (const o of r)
        if (o.value && Reflect.has(o.value, i))
          return Reflect.set(o.value, i, s);
      return !1;
    },
    getOwnPropertyDescriptor(a, i) {
      var o;
      const s = Reflect.getOwnPropertyDescriptor(a, i);
      if (s) return s;
      if (!(typeof i == "symbol" || i.startsWith("$") || i.startsWith("__"))) {
        for (const u of r) {
          if (!u.value) continue;
          const l = so(u.value, i) ?? ("_" in u.value ? so((o = u.value._) == null ? void 0 : o.setupState, i) : void 0);
          if (l) return l;
        }
        for (const u of r) {
          const l = u.value && u.value[io];
          if (!l) continue;
          const d = l.slice();
          for (; d.length; ) {
            const c = d.shift(), f = so(c.value, i);
            if (f) return f;
            const h = c.value && c.value[io];
            h && d.push(...h);
          }
        }
      }
    }
  });
}
const Jo = Symbol.for("vuetify:v-tabs"), aC = U({
  fixed: Boolean,
  sliderColor: String,
  hideSlider: Boolean,
  direction: {
    type: String,
    default: "horizontal"
  },
  ...Hv(_p({
    selectedClass: "v-tab--selected",
    variant: "text"
  }), ["active", "block", "flat", "location", "position", "symbol"])
}, "VTab"), bt = re()({
  name: "VTab",
  props: aC(),
  setup(e, t) {
    let {
      slots: r,
      attrs: n
    } = t;
    const {
      textColorClasses: a,
      textColorStyles: i
    } = mt(e, "sliderColor"), s = J(), o = J(), u = w(() => e.direction === "horizontal"), l = w(() => {
      var c, f;
      return ((f = (c = s.value) == null ? void 0 : c.group) == null ? void 0 : f.isSelected.value) ?? !1;
    });
    function d(c) {
      var h, g;
      let {
        value: f
      } = c;
      if (f) {
        const p = (g = (h = s.value) == null ? void 0 : h.$el.parentElement) == null ? void 0 : g.querySelector(".v-tab--selected .v-tab__slider"), m = o.value;
        if (!p || !m) return;
        const C = getComputedStyle(p).color, y = p.getBoundingClientRect(), A = m.getBoundingClientRect(), S = u.value ? "x" : "y", k = u.value ? "X" : "Y", T = u.value ? "right" : "bottom", $ = u.value ? "width" : "height", M = y[S], j = A[S], F = M > j ? y[T] - A[T] : y[S] - A[S], R = Math.sign(F) > 0 ? u.value ? "right" : "bottom" : Math.sign(F) < 0 ? u.value ? "left" : "top" : "center", H = (Math.abs(F) + (Math.sign(F) < 0 ? y[$] : A[$])) / Math.max(y[$], A[$]) || 0, ee = y[$] / A[$] || 0, Z = 1.5;
        e0(m, {
          backgroundColor: [C, "currentcolor"],
          transform: [`translate${k}(${F}px) scale${k}(${ee})`, `translate${k}(${F / Z}px) scale${k}(${(H - 1) / Z + 1})`, "none"],
          transformOrigin: Array(3).fill(R)
        }, {
          duration: 225,
          easing: m0
        });
      }
    }
    return ve(() => {
      const c = Ye.filterProps(e);
      return q(Ye, ie({
        symbol: Jo,
        ref: s,
        class: ["v-tab", e.class],
        style: e.style,
        tabindex: l.value ? 0 : -1,
        role: "tab",
        "aria-selected": String(l.value),
        active: !1
      }, c, n, {
        block: e.fixed,
        maxWidth: e.fixed ? 300 : void 0,
        "onGroup:selected": d
      }), {
        ...r,
        default: () => {
          var f;
          return q(E, null, [((f = r.default) == null ? void 0 : f.call(r)) ?? e.text, !e.hideSlider && q("div", {
            ref: o,
            class: ["v-tab__slider", a.value],
            style: i.value
          }, null)]);
        }
      });
    }), nC({}, s);
  }
}), iC = (e) => {
  const {
    touchstartX: t,
    touchendX: r,
    touchstartY: n,
    touchendY: a
  } = e, i = 0.5, s = 16;
  e.offsetX = r - t, e.offsetY = a - n, Math.abs(e.offsetY) < i * Math.abs(e.offsetX) && (e.left && r < t - s && e.left(e), e.right && r > t + s && e.right(e)), Math.abs(e.offsetX) < i * Math.abs(e.offsetY) && (e.up && a < n - s && e.up(e), e.down && a > n + s && e.down(e));
};
function sC(e, t) {
  var n;
  const r = e.changedTouches[0];
  t.touchstartX = r.clientX, t.touchstartY = r.clientY, (n = t.start) == null || n.call(t, {
    originalEvent: e,
    ...t
  });
}
function oC(e, t) {
  var n;
  const r = e.changedTouches[0];
  t.touchendX = r.clientX, t.touchendY = r.clientY, (n = t.end) == null || n.call(t, {
    originalEvent: e,
    ...t
  }), iC(t);
}
function uC(e, t) {
  var n;
  const r = e.changedTouches[0];
  t.touchmoveX = r.clientX, t.touchmoveY = r.clientY, (n = t.move) == null || n.call(t, {
    originalEvent: e,
    ...t
  });
}
function lC() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  const t = {
    touchstartX: 0,
    touchstartY: 0,
    touchendX: 0,
    touchendY: 0,
    touchmoveX: 0,
    touchmoveY: 0,
    offsetX: 0,
    offsetY: 0,
    left: e.left,
    right: e.right,
    up: e.up,
    down: e.down,
    start: e.start,
    move: e.move,
    end: e.end
  };
  return {
    touchstart: (r) => sC(r, t),
    touchend: (r) => oC(r, t),
    touchmove: (r) => uC(r, t)
  };
}
function cC(e, t) {
  var o;
  const r = t.value, n = r != null && r.parent ? e.parentElement : e, a = (r == null ? void 0 : r.options) ?? {
    passive: !0
  }, i = (o = t.instance) == null ? void 0 : o.$.uid;
  if (!n || !i) return;
  const s = lC(t.value);
  n._touchHandlers = n._touchHandlers ?? /* @__PURE__ */ Object.create(null), n._touchHandlers[i] = s, Uv(s).forEach((u) => {
    n.addEventListener(u, s[u], a);
  });
}
function dC(e, t) {
  var i, s;
  const r = (i = t.value) != null && i.parent ? e.parentElement : e, n = (s = t.instance) == null ? void 0 : s.$.uid;
  if (!(r != null && r._touchHandlers) || !n) return;
  const a = r._touchHandlers[n];
  Uv(a).forEach((o) => {
    r.removeEventListener(o, a[o]);
  }), delete r._touchHandlers[n];
}
const mp = {
  mounted: cC,
  unmounted: dC
}, yp = Symbol.for("vuetify:v-window"), bp = Symbol.for("vuetify:v-window-group"), Cp = U({
  continuous: Boolean,
  nextIcon: {
    type: [Boolean, String, Function, Object],
    default: "$next"
  },
  prevIcon: {
    type: [Boolean, String, Function, Object],
    default: "$prev"
  },
  reverse: Boolean,
  showArrows: {
    type: [Boolean, String],
    validator: (e) => typeof e == "boolean" || e === "hover"
  },
  touch: {
    type: [Object, Boolean],
    default: void 0
  },
  direction: {
    type: String,
    default: "horizontal"
  },
  modelValue: null,
  disabled: Boolean,
  selectedClass: {
    type: String,
    default: "v-window-item--active"
  },
  // TODO: mandatory should probably not be exposed but do this for now
  mandatory: {
    type: [Boolean, String],
    default: "force"
  },
  ...xe(),
  ...Pe(),
  ...st()
}, "VWindow"), Ct = re()({
  name: "VWindow",
  directives: {
    Touch: mp
  },
  props: Cp(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      slots: r
    } = t;
    const {
      themeClasses: n
    } = ot(e), {
      isRtl: a
    } = Ft(), {
      t: i
    } = B0(), s = Ko(e, bp), o = J(), u = w(() => a.value ? !e.reverse : e.reverse), l = oe(!1), d = w(() => {
      const S = e.direction === "vertical" ? "y" : "x", T = (u.value ? !l.value : l.value) ? "-reverse" : "";
      return `v-window-${S}${T}-transition`;
    }), c = oe(0), f = J(void 0), h = w(() => s.items.value.findIndex((S) => s.selected.value.includes(S.id)));
    he(h, (S, k) => {
      const T = s.items.value.length, $ = T - 1;
      T <= 2 ? l.value = S < k : S === $ && k === 0 ? l.value = !0 : S === 0 && k === $ ? l.value = !1 : l.value = S < k;
    }), ye(yp, {
      transition: d,
      isReversed: l,
      transitionCount: c,
      transitionHeight: f,
      rootRef: o
    });
    const g = w(() => e.continuous || h.value !== 0), p = w(() => e.continuous || h.value !== s.items.value.length - 1);
    function m() {
      g.value && s.prev();
    }
    function C() {
      p.value && s.next();
    }
    const y = w(() => {
      const S = [], k = {
        icon: a.value ? e.nextIcon : e.prevIcon,
        class: `v-window__${u.value ? "right" : "left"}`,
        onClick: s.prev,
        "aria-label": i("$vuetify.carousel.prev")
      };
      S.push(g.value ? r.prev ? r.prev({
        props: k
      }) : q(Ye, k, null) : q("div", null, null));
      const T = {
        icon: a.value ? e.prevIcon : e.nextIcon,
        class: `v-window__${u.value ? "left" : "right"}`,
        onClick: s.next,
        "aria-label": i("$vuetify.carousel.next")
      };
      return S.push(p.value ? r.next ? r.next({
        props: T
      }) : q(Ye, T, null) : q("div", null, null)), S;
    }), A = w(() => e.touch === !1 ? e.touch : {
      ...{
        left: () => {
          u.value ? m() : C();
        },
        right: () => {
          u.value ? C() : m();
        },
        start: (k) => {
          let {
            originalEvent: T
          } = k;
          T.stopPropagation();
        }
      },
      ...e.touch === !0 ? {} : e.touch
    });
    return ve(() => te(q(e.tag, {
      ref: o,
      class: ["v-window", {
        "v-window--show-arrows-on-hover": e.showArrows === "hover"
      }, n.value, e.class],
      style: e.style
    }, {
      default: () => {
        var S, k;
        return [q("div", {
          class: "v-window__container",
          style: {
            height: f.value
          }
        }, [(S = r.default) == null ? void 0 : S.call(r, {
          group: s
        }), e.showArrows !== !1 && q("div", {
          class: "v-window__controls"
        }, [y.value])]), (k = r.additional) == null ? void 0 : k.call(r, {
          group: s
        })];
      }
    }), [[Be("touch"), A.value]])), {
      group: s
    };
  }
}), fC = U({
  ...Hv(Cp(), ["continuous", "nextIcon", "prevIcon", "showArrows", "touch", "mandatory"])
}, "VTabsWindow"), hC = re()({
  name: "VTabsWindow",
  props: fC(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      slots: r
    } = t;
    const n = se(Jo, null), a = Wo(e, "modelValue"), i = w({
      get() {
        var s;
        return a.value != null || !n ? a.value : (s = n.items.value.find((o) => n.selected.value.includes(o.id))) == null ? void 0 : s.value;
      },
      set(s) {
        a.value = s;
      }
    });
    return ve(() => {
      const s = Ct.filterProps(e);
      return q(Ct, ie({
        _as: "VTabsWindow"
      }, s, {
        modelValue: i.value,
        "onUpdate:modelValue": (o) => i.value = o,
        class: ["v-tabs-window", e.class],
        style: e.style,
        mandatory: !1,
        touch: !1
      }), r);
    }), {};
  }
}), vC = U({
  eager: Boolean
}, "lazy");
function pC(e, t) {
  const r = oe(!1), n = w(() => r.value || e.eager || t.value);
  he(t, () => r.value = !0);
  function a() {
    e.eager || (r.value = !1);
  }
  return {
    isBooted: r,
    hasContent: n,
    onAfterLeave: a
  };
}
function gC() {
  const e = oe(!1);
  return Le(() => {
    window.requestAnimationFrame(() => {
      e.value = !0;
    });
  }), {
    ssrBootStyles: w(() => e.value ? void 0 : {
      transition: "none !important"
    }),
    isBooted: Uh(e)
  };
}
const _C = (e, t) => {
  let {
    slots: r
  } = t;
  const {
    transition: n,
    disabled: a,
    group: i,
    ...s
  } = e, {
    component: o = i ? bo : Co,
    ...u
  } = typeof n == "object" ? n : {};
  return So(o, ie(typeof n == "string" ? {
    name: a ? "" : n
  } : u, typeof n == "string" ? {} : Object.fromEntries(Object.entries({
    disabled: a,
    group: i
  }).filter((l) => {
    let [d, c] = l;
    return c !== void 0;
  })), s), r);
}, Sp = U({
  reverseTransition: {
    type: [Boolean, String],
    default: void 0
  },
  transition: {
    type: [Boolean, String],
    default: void 0
  },
  ...xe(),
  ...ap(),
  ...vC()
}, "VWindowItem"), Je = re()({
  name: "VWindowItem",
  directives: {
    Touch: mp
  },
  props: Sp(),
  emits: {
    "group:selected": (e) => !0
  },
  setup(e, t) {
    let {
      slots: r
    } = t;
    const n = se(yp), a = ip(e, bp), {
      isBooted: i
    } = gC();
    if (!n || !a) throw new Error("[Vuetify] VWindowItem must be used inside VWindow");
    const s = oe(!1), o = w(() => i.value && (n.isReversed.value ? e.reverseTransition !== !1 : e.transition !== !1));
    function u() {
      !s.value || !n || (s.value = !1, n.transitionCount.value > 0 && (n.transitionCount.value -= 1, n.transitionCount.value === 0 && (n.transitionHeight.value = void 0)));
    }
    function l() {
      var g;
      s.value || !n || (s.value = !0, n.transitionCount.value === 0 && (n.transitionHeight.value = ne((g = n.rootRef.value) == null ? void 0 : g.clientHeight)), n.transitionCount.value += 1);
    }
    function d() {
      u();
    }
    function c(g) {
      s.value && Hh(() => {
        !o.value || !s.value || !n || (n.transitionHeight.value = ne(g.clientHeight));
      });
    }
    const f = w(() => {
      const g = n.isReversed.value ? e.reverseTransition : e.transition;
      return o.value ? {
        name: typeof g != "string" ? n.transition.value : g,
        onBeforeEnter: l,
        onAfterEnter: u,
        onEnterCancelled: d,
        onBeforeLeave: l,
        onAfterLeave: u,
        onLeaveCancelled: d,
        onEnter: c
      } : !1;
    }), {
      hasContent: h
    } = pC(e, a.isSelected);
    return ve(() => q(_C, {
      transition: f.value,
      disabled: !i.value
    }, {
      default: () => {
        var g;
        return [te(q("div", {
          class: ["v-window-item", a.selectedClass.value, e.class],
          style: e.style
        }, [h.value && ((g = r.default) == null ? void 0 : g.call(r))]), [[De, a.isSelected.value]])];
      }
    })), {
      groupItem: a
    };
  }
}), mC = U({
  ...Sp()
}, "VTabsWindowItem"), yC = re()({
  name: "VTabsWindowItem",
  props: mC(),
  setup(e, t) {
    let {
      slots: r
    } = t;
    return ve(() => {
      const n = Je.filterProps(e);
      return q(Je, ie({
        _as: "VTabsWindowItem"
      }, n, {
        class: ["v-tabs-window-item", e.class],
        style: e.style
      }), r);
    }), {};
  }
}), bC = U({
  disabled: Boolean,
  group: Boolean,
  hideOnLeave: Boolean,
  leaveAbsolute: Boolean,
  mode: String,
  origin: String
}, "transition");
function fe(e, t, r) {
  return re()({
    name: e,
    props: bC({
      mode: r,
      origin: t
    }),
    setup(n, a) {
      let {
        slots: i
      } = a;
      const s = {
        onBeforeEnter(o) {
          n.origin && (o.style.transformOrigin = n.origin);
        },
        onLeave(o) {
          if (n.leaveAbsolute) {
            const {
              offsetTop: u,
              offsetLeft: l,
              offsetWidth: d,
              offsetHeight: c
            } = o;
            o._transitionInitialStyles = {
              position: o.style.position,
              top: o.style.top,
              left: o.style.left,
              width: o.style.width,
              height: o.style.height
            }, o.style.position = "absolute", o.style.top = `${u}px`, o.style.left = `${l}px`, o.style.width = `${d}px`, o.style.height = `${c}px`;
          }
          n.hideOnLeave && o.style.setProperty("display", "none", "important");
        },
        onAfterLeave(o) {
          if (n.leaveAbsolute && (o != null && o._transitionInitialStyles)) {
            const {
              position: u,
              top: l,
              left: d,
              width: c,
              height: f
            } = o._transitionInitialStyles;
            delete o._transitionInitialStyles, o.style.position = u || "", o.style.top = l || "", o.style.left = d || "", o.style.width = c || "", o.style.height = f || "";
          }
        }
      };
      return () => {
        const o = n.group ? bo : Co;
        return So(o, {
          name: n.disabled ? "" : e,
          css: !n.disabled,
          ...n.group ? void 0 : {
            mode: n.mode
          },
          ...n.disabled ? {} : s
        }, i.default);
      };
    }
  });
}
function qp(e, t) {
  let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "in-out";
  return re()({
    name: e,
    props: {
      mode: {
        type: String,
        default: r
      },
      disabled: Boolean,
      group: Boolean
    },
    setup(n, a) {
      let {
        slots: i
      } = a;
      const s = n.group ? bo : Co;
      return () => So(s, {
        name: n.disabled ? "" : e,
        css: !n.disabled,
        // mode: props.mode, // TODO: vuejs/vue-next#3104
        ...n.disabled ? {} : t
      }, i.default);
    }
  });
}
function wp() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
  const r = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1) ? "width" : "height", n = Hp(`offset-${r}`);
  return {
    onBeforeEnter(s) {
      s._parent = s.parentNode, s._initialStyle = {
        transition: s.style.transition,
        overflow: s.style.overflow,
        [r]: s.style[r]
      };
    },
    onEnter(s) {
      const o = s._initialStyle;
      if (!o) return;
      s.style.setProperty("transition", "none", "important"), s.style.overflow = "hidden";
      const u = `${s[n]}px`;
      s.style[r] = "0", s.offsetHeight, s.style.transition = o.transition, e && s._parent && s._parent.classList.add(e), requestAnimationFrame(() => {
        s.style[r] = u;
      });
    },
    onAfterEnter: i,
    onEnterCancelled: i,
    onLeave(s) {
      s._initialStyle = {
        transition: "",
        overflow: s.style.overflow,
        [r]: s.style[r]
      }, s.style.overflow = "hidden", s.style[r] = `${s[n]}px`, s.offsetHeight, requestAnimationFrame(() => s.style[r] = "0");
    },
    onAfterLeave: a,
    onLeaveCancelled: a
  };
  function a(s) {
    e && s._parent && s._parent.classList.remove(e), i(s);
  }
  function i(s) {
    if (!s._initialStyle) return;
    const o = s._initialStyle[r];
    s.style.overflow = s._initialStyle.overflow, o != null && (s.style[r] = o), delete s._initialStyle;
  }
}
fe("fab-transition", "center center", "out-in");
fe("dialog-bottom-transition");
fe("dialog-top-transition");
const xh = fe("fade-transition");
fe("scale-transition");
fe("scroll-x-transition");
fe("scroll-x-reverse-transition");
fe("scroll-y-transition");
fe("scroll-y-reverse-transition");
fe("slide-x-transition");
fe("slide-x-reverse-transition");
fe("slide-y-transition");
fe("slide-y-reverse-transition");
qp("expand-transition", wp());
qp("expand-x-transition", wp("", !0));
const CC = Symbol.for("vuetify:display"), SC = U({
  mobile: {
    type: Boolean,
    default: !1
  },
  mobileBreakpoint: [Number, String]
}, "display");
function qC() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
    mobile: null
  }, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $e();
  const r = se(CC);
  if (!r) throw new Error("Could not find Vuetify display injection");
  const n = w(() => e.mobile ? !0 : typeof e.mobileBreakpoint == "number" ? r.width.value < e.mobileBreakpoint : e.mobileBreakpoint ? r.width.value < r.thresholds.value[e.mobileBreakpoint] : e.mobile === null ? r.mobile.value : !1), a = w(() => t ? {
    [`${t}--mobile`]: n.value
  } : {});
  return {
    ...r,
    displayClasses: a,
    mobile: n
  };
}
const wC = Symbol.for("vuetify:goto");
function $C() {
  return {
    container: void 0,
    duration: 300,
    layout: !1,
    offset: 0,
    easing: "easeInOutCubic",
    patterns: {
      linear: (e) => e,
      easeInQuad: (e) => e ** 2,
      easeOutQuad: (e) => e * (2 - e),
      easeInOutQuad: (e) => e < 0.5 ? 2 * e ** 2 : -1 + (4 - 2 * e) * e,
      easeInCubic: (e) => e ** 3,
      easeOutCubic: (e) => --e ** 3 + 1,
      easeInOutCubic: (e) => e < 0.5 ? 4 * e ** 3 : (e - 1) * (2 * e - 2) * (2 * e - 2) + 1,
      easeInQuart: (e) => e ** 4,
      easeOutQuart: (e) => 1 - --e ** 4,
      easeInOutQuart: (e) => e < 0.5 ? 8 * e ** 4 : 1 - 8 * --e ** 4,
      easeInQuint: (e) => e ** 5,
      easeOutQuint: (e) => 1 + --e ** 5,
      easeInOutQuint: (e) => e < 0.5 ? 16 * e ** 5 : 1 + 16 * --e ** 5
    }
  };
}
function TC(e) {
  return Zo(e) ?? (document.scrollingElement || document.body);
}
function Zo(e) {
  return typeof e == "string" ? document.querySelector(e) : Nv(e);
}
function oo(e, t, r) {
  if (typeof e == "number") return t && r ? -e : e;
  let n = Zo(e), a = 0;
  for (; n; )
    a += t ? n.offsetLeft : n.offsetTop, n = n.offsetParent;
  return a;
}
async function Ph(e, t, r, n) {
  const a = r ? "scrollLeft" : "scrollTop", i = me((n == null ? void 0 : n.options) ?? $C(), t), s = n == null ? void 0 : n.rtl.value, o = (typeof e == "number" ? e : Zo(e)) ?? 0, u = i.container === "parent" && o instanceof HTMLElement ? o.parentElement : TC(i.container), l = typeof i.easing == "function" ? i.easing : i.patterns[i.easing];
  if (!l) throw new TypeError(`Easing function "${i.easing}" not found.`);
  let d;
  if (typeof o == "number")
    d = oo(o, r, s);
  else if (d = oo(o, r, s) - oo(u, r, s), i.layout) {
    const g = window.getComputedStyle(o).getPropertyValue("--v-layout-top");
    g && (d -= parseInt(g, 10));
  }
  d += i.offset, d = AC(u, d, !!s, !!r);
  const c = u[a] ?? 0;
  if (d === c) return Promise.resolve(d);
  const f = performance.now();
  return new Promise((h) => requestAnimationFrame(function g(p) {
    const C = (p - f) / i.duration, y = Math.floor(c + (d - c) * l(Wb(C, 0, 1)));
    if (u[a] = y, C >= 1 && Math.abs(y - u[a]) < 10)
      return h(d);
    if (C > 2)
      return Re("Scroll target is not reachable"), h(u[a]);
    requestAnimationFrame(g);
  }));
}
function RC() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  const t = se(wC), {
    isRtl: r
  } = Ft();
  if (!t) throw new Error("[Vuetify] Could not find injected goto instance");
  const n = {
    ...t,
    // can be set via VLocaleProvider
    rtl: w(() => t.rtl.value || r.value)
  };
  async function a(i, s) {
    return Ph(i, me(e, s), !1, n);
  }
  return a.horizontal = async (i, s) => Ph(i, me(e, s), !0, n), a;
}
function AC(e, t, r, n) {
  const {
    scrollWidth: a,
    scrollHeight: i
  } = e, [s, o] = e === document.scrollingElement ? [window.innerWidth, window.innerHeight] : [e.offsetWidth, e.offsetHeight];
  let u, l;
  return n ? r ? (u = -(a - s), l = 0) : (u = 0, l = a - s) : (u = 0, l = i + -o), Math.max(Math.min(t, l), u);
}
function kC(e) {
  let {
    selectedElement: t,
    containerElement: r,
    isRtl: n,
    isHorizontal: a
  } = e;
  const i = Ze(a, r), s = $p(a, n, r), o = Ze(a, t), u = Tp(a, t), l = o * 0.4;
  return s > u ? u - l : s + i < u + o ? u - i + o + l : s;
}
function IC(e) {
  let {
    selectedElement: t,
    containerElement: r,
    isHorizontal: n
  } = e;
  const a = Ze(n, r), i = Tp(n, t), s = Ze(n, t);
  return i - a / 2 + s / 2;
}
function Oh(e, t) {
  const r = e ? "scrollWidth" : "scrollHeight";
  return (t == null ? void 0 : t[r]) || 0;
}
function xC(e, t) {
  const r = e ? "clientWidth" : "clientHeight";
  return (t == null ? void 0 : t[r]) || 0;
}
function $p(e, t, r) {
  if (!r)
    return 0;
  const {
    scrollLeft: n,
    offsetWidth: a,
    scrollWidth: i
  } = r;
  return e ? t ? i - a + n : n : r.scrollTop;
}
function Ze(e, t) {
  const r = e ? "offsetWidth" : "offsetHeight";
  return (t == null ? void 0 : t[r]) || 0;
}
function Tp(e, t) {
  const r = e ? "offsetLeft" : "offsetTop";
  return (t == null ? void 0 : t[r]) || 0;
}
const PC = Symbol.for("vuetify:v-slide-group"), Rp = U({
  centerActive: Boolean,
  direction: {
    type: String,
    default: "horizontal"
  },
  symbol: {
    type: null,
    default: PC
  },
  nextIcon: {
    type: je,
    default: "$next"
  },
  prevIcon: {
    type: je,
    default: "$prev"
  },
  showArrows: {
    type: [Boolean, String],
    validator: (e) => typeof e == "boolean" || ["always", "desktop", "mobile"].includes(e)
  },
  ...xe(),
  ...SC({
    mobile: null
  }),
  ...Pe(),
  ...np({
    selectedClass: "v-slide-group-item--active"
  })
}, "VSlideGroup"), Eh = re()({
  name: "VSlideGroup",
  props: Rp(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      slots: r
    } = t;
    const {
      isRtl: n
    } = Ft(), {
      displayClasses: a,
      mobile: i
    } = qC(e), s = Ko(e, e.symbol), o = oe(!1), u = oe(0), l = oe(0), d = oe(0), c = w(() => e.direction === "horizontal"), {
      resizeRef: f,
      contentRect: h
    } = po(), {
      resizeRef: g,
      contentRect: p
    } = po(), m = RC(), C = w(() => ({
      container: f.el,
      duration: 200,
      easing: "easeOutQuart"
    })), y = w(() => s.selected.value.length ? s.items.value.findIndex((P) => P.id === s.selected.value[0]) : -1), A = w(() => s.selected.value.length ? s.items.value.findIndex((P) => P.id === s.selected.value[s.selected.value.length - 1]) : -1);
    if (gt) {
      let P = -1;
      he(() => [s.selected.value, h.value, p.value, c.value], () => {
        cancelAnimationFrame(P), P = requestAnimationFrame(() => {
          if (h.value && p.value) {
            const x = c.value ? "width" : "height";
            l.value = h.value[x], d.value = p.value[x], o.value = l.value + 1 < d.value;
          }
          if (y.value >= 0 && g.el) {
            const x = g.el.children[A.value];
            k(x, e.centerActive);
          }
        });
      });
    }
    const S = oe(!1);
    function k(P, x) {
      let W = 0;
      x ? W = IC({
        containerElement: f.el,
        isHorizontal: c.value,
        selectedElement: P
      }) : W = kC({
        containerElement: f.el,
        isHorizontal: c.value,
        isRtl: n.value,
        selectedElement: P
      }), T(W);
    }
    function T(P) {
      if (!gt || !f.el) return;
      const x = Ze(c.value, f.el), W = $p(c.value, n.value, f.el);
      if (!(Oh(c.value, f.el) <= x || // Prevent scrolling by only a couple of pixels, which doesn't look smooth
      Math.abs(P - W) < 16)) {
        if (c.value && n.value && f.el) {
          const {
            scrollWidth: Vt,
            offsetWidth: Wt
          } = f.el;
          P = Vt - Wt - P;
        }
        c.value ? m.horizontal(P, C.value) : m(P, C.value);
      }
    }
    function $(P) {
      const {
        scrollTop: x,
        scrollLeft: W
      } = P.target;
      u.value = c.value ? W : x;
    }
    function M(P) {
      if (S.value = !0, !(!o.value || !g.el)) {
        for (const x of P.composedPath())
          for (const W of g.el.children)
            if (W === x) {
              k(W);
              return;
            }
      }
    }
    function j(P) {
      S.value = !1;
    }
    let F = !1;
    function R(P) {
      var x;
      !F && !S.value && !(P.relatedTarget && ((x = g.el) != null && x.contains(P.relatedTarget))) && Z(), F = !1;
    }
    function V() {
      F = !0;
    }
    function H(P) {
      if (!g.el) return;
      function x(W) {
        P.preventDefault(), Z(W);
      }
      c.value ? P.key === "ArrowRight" ? x(n.value ? "prev" : "next") : P.key === "ArrowLeft" && x(n.value ? "next" : "prev") : P.key === "ArrowDown" ? x("next") : P.key === "ArrowUp" && x("prev"), P.key === "Home" ? x("first") : P.key === "End" && x("last");
    }
    function ee(P, x) {
      if (!P) return;
      let W = P;
      do
        W = W == null ? void 0 : W[x === "next" ? "nextElementSibling" : "previousElementSibling"];
      while (W != null && W.hasAttribute("disabled"));
      return W;
    }
    function Z(P) {
      if (!g.el) return;
      let x;
      if (!P)
        x = Xb(g.el)[0];
      else if (P === "next") {
        if (x = ee(g.el.querySelector(":focus"), P), !x) return Z("first");
      } else if (P === "prev") {
        if (x = ee(g.el.querySelector(":focus"), P), !x) return Z("last");
      } else P === "first" ? (x = g.el.firstElementChild, x != null && x.hasAttribute("disabled") && (x = ee(x, "next"))) : P === "last" && (x = g.el.lastElementChild, x != null && x.hasAttribute("disabled") && (x = ee(x, "prev")));
      x && x.focus({
        preventScroll: !0
      });
    }
    function _e(P) {
      const x = c.value && n.value ? -1 : 1, W = (P === "prev" ? -x : x) * l.value;
      let zt = u.value + W;
      if (c.value && n.value && f.el) {
        const {
          scrollWidth: Vt,
          offsetWidth: Wt
        } = f.el;
        zt += Vt - Wt;
      }
      T(zt);
    }
    const Nt = w(() => ({
      next: s.next,
      prev: s.prev,
      select: s.select,
      isSelected: s.isSelected
    })), Ut = w(() => {
      switch (e.showArrows) {
        // Always show arrows on desktop & mobile
        case "always":
          return !0;
        // Always show arrows on desktop
        case "desktop":
          return !i.value;
        // Show arrows on mobile when overflowing.
        // This matches the default 2.2 behavior
        case !0:
          return o.value || Math.abs(u.value) > 0;
        // Always show on mobile
        case "mobile":
          return i.value || o.value || Math.abs(u.value) > 0;
        // https://material.io/components/tabs#scrollable-tabs
        // Always show arrows when
        // overflowed on desktop
        default:
          return !i.value && (o.value || Math.abs(u.value) > 0);
      }
    }), Ht = w(() => Math.abs(u.value) > 1), Gt = w(() => {
      if (!f.value) return !1;
      const P = Oh(c.value, f.el), x = xC(c.value, f.el);
      return P - x - Math.abs(u.value) > 1;
    });
    return ve(() => q(e.tag, {
      class: ["v-slide-group", {
        "v-slide-group--vertical": !c.value,
        "v-slide-group--has-affixes": Ut.value,
        "v-slide-group--is-overflowing": o.value
      }, a.value, e.class],
      style: e.style,
      tabindex: S.value || s.selected.value.length ? -1 : 0,
      onFocus: R
    }, {
      default: () => {
        var P, x, W;
        return [Ut.value && q("div", {
          key: "prev",
          class: ["v-slide-group__prev", {
            "v-slide-group__prev--disabled": !Ht.value
          }],
          onMousedown: V,
          onClick: () => Ht.value && _e("prev")
        }, [((P = r.prev) == null ? void 0 : P.call(r, Nt.value)) ?? q(xh, null, {
          default: () => [q(Ee, {
            icon: n.value ? e.nextIcon : e.prevIcon
          }, null)]
        })]), q("div", {
          key: "container",
          ref: f,
          class: "v-slide-group__container",
          onScroll: $
        }, [q("div", {
          ref: g,
          class: "v-slide-group__content",
          onFocusin: M,
          onFocusout: j,
          onKeydown: H
        }, [(x = r.default) == null ? void 0 : x.call(r, Nt.value)])]), Ut.value && q("div", {
          key: "next",
          class: ["v-slide-group__next", {
            "v-slide-group__next--disabled": !Gt.value
          }],
          onMousedown: V,
          onClick: () => Gt.value && _e("next")
        }, [((W = r.next) == null ? void 0 : W.call(r, Nt.value)) ?? q(xh, null, {
          default: () => [q(Ee, {
            icon: n.value ? e.prevIcon : e.nextIcon
          }, null)]
        })])];
      }
    })), {
      selected: s.selected,
      scrollTo: _e,
      scrollOffset: u,
      focus: Z,
      hasPrev: Ht,
      hasNext: Gt
    };
  }
});
function OC() {
  const t = ge("useScopeId").vnode.scopeId;
  return {
    scopeId: t ? {
      [t]: ""
    } : void 0
  };
}
function EC(e) {
  return e ? e.map((t) => Fv(t) ? t : {
    text: t,
    value: t
  }) : [];
}
const LC = U({
  alignTabs: {
    type: String,
    default: "start"
  },
  color: String,
  fixedTabs: Boolean,
  items: {
    type: Array,
    default: () => []
  },
  stacked: Boolean,
  bgColor: String,
  grow: Boolean,
  height: {
    type: [Number, String],
    default: void 0
  },
  hideSlider: Boolean,
  sliderColor: String,
  ...Rp({
    mandatory: "force",
    selectedClass: "v-tab-item--selected"
  }),
  ...Go(),
  ...Pe()
}, "VTabs"), Ap = re()({
  name: "VTabs",
  props: LC(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      attrs: r,
      slots: n
    } = t;
    const a = Wo(e, "modelValue"), i = w(() => EC(e.items)), {
      densityClasses: s
    } = zo(e), {
      backgroundColorClasses: o,
      backgroundColorStyles: u
    } = b0(Q(e, "bgColor")), {
      scopeId: l
    } = OC();
    return Ho({
      VTab: {
        color: Q(e, "color"),
        direction: Q(e, "direction"),
        stacked: Q(e, "stacked"),
        fixed: Q(e, "fixedTabs"),
        sliderColor: Q(e, "sliderColor"),
        hideSlider: Q(e, "hideSlider")
      }
    }), ve(() => {
      const d = Eh.filterProps(e), c = !!(n.window || e.items.length > 0);
      return q(E, null, [q(Eh, ie(d, {
        modelValue: a.value,
        "onUpdate:modelValue": (f) => a.value = f,
        class: ["v-tabs", `v-tabs--${e.direction}`, `v-tabs--align-tabs-${e.alignTabs}`, {
          "v-tabs--fixed-tabs": e.fixedTabs,
          "v-tabs--grow": e.grow,
          "v-tabs--stacked": e.stacked
        }, s.value, o.value, e.class],
        style: [{
          "--v-tabs-height": ne(e.height)
        }, u.value, e.style],
        role: "tablist",
        symbol: Jo
      }, l, r), {
        default: () => {
          var f;
          return [((f = n.default) == null ? void 0 : f.call(n)) ?? i.value.map((h) => {
            var g;
            return ((g = n.tab) == null ? void 0 : g.call(n, {
              item: h
            })) ?? q(bt, ie(h, {
              key: h.text,
              value: h.value
            }), {
              default: n[`tab.${h.value}`] ? () => {
                var p;
                return (p = n[`tab.${h.value}`]) == null ? void 0 : p.call(n, {
                  item: h
                });
              } : void 0
            });
          })];
        }
      }), c && q(hC, ie({
        modelValue: a.value,
        "onUpdate:modelValue": (f) => a.value = f,
        key: "tabs-window"
      }, l), {
        default: () => {
          var f;
          return [i.value.map((h) => {
            var g;
            return ((g = n.item) == null ? void 0 : g.call(n, {
              item: h
            })) ?? q(yC, {
              value: h.value
            }, {
              default: () => {
                var p;
                return (p = n[`item.${h.value}`]) == null ? void 0 : p.call(n, {
                  item: h
                });
              }
            });
          }), (f = n.window) == null ? void 0 : f.call(n)];
        }
      })]);
    }), {};
  }
}), MC = {
  name: "RecentResources",
  props: {
    apiUrl: {
      type: String,
      required: !0
    },
    homeUrl: {
      type: String,
      required: !1,
      default: "/"
    }
  },
  async created() {
    const e = await mv({
      apiUrl: this.apiUrl
    });
    this.categories = e.results.map((t) => `&categories=${t.id}`).join("");
    try {
      const t = await Po({ apiUrl: this.apiUrl });
      this.partsLastUpdated = await F1({
        apiUrl: this.apiUrl,
        titles: t
      });
    } catch (t) {
      console.error("Error fetching parts last updated:", t);
    } finally {
      this.partsLastUpdatedLoading = !1;
    }
  },
  data() {
    return {
      tab: 0,
      categories: null,
      partsLastUpdated: {},
      partsLastUpdatedLoading: !0
    };
  },
  components: {
    RecentChangesContainer: Hb
  }
};
function DC(e, t, r, n, a, i) {
  const s = B("RecentChangesContainer");
  return v(), _("div", null, [
    q(Ap, {
      modelValue: a.tab,
      "onUpdate:modelValue": t[0] || (t[0] = (o) => a.tab = o),
      grow: ""
    }, {
      default: N(() => [
        q(bt, {
          class: "content-tabs",
          tabindex: "0"
        }, {
          default: N(() => t[2] || (t[2] = [
            L(" Recent Documents ")
          ])),
          _: 1
        }),
        q(bt, {
          class: "content-tabs",
          tabindex: "0"
        }, {
          default: N(() => t[3] || (t[3] = [
            L(" Recent Rules ")
          ])),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    q(Ct, {
      modelValue: a.tab,
      "onUpdate:modelValue": t[1] || (t[1] = (o) => a.tab = o)
    }, {
      default: N(() => [
        q(Je, null, {
          default: N(() => [
            q(s, {
              "api-url": r.apiUrl,
              "home-url": r.homeUrl,
              categories: a.categories,
              "parts-last-updated": a.partsLastUpdated,
              type: "supplemental",
              class: "recent-supplemental-content"
            }, null, 8, ["api-url", "home-url", "categories", "parts-last-updated"])
          ]),
          _: 1
        }),
        q(Je, null, {
          default: N(() => [
            q(s, {
              "api-url": r.apiUrl,
              type: "rules"
            }, null, 8, ["api-url"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]);
}
const ew = /* @__PURE__ */ z(MC, [["render", DC]]), jC = {
  components: {
    CollapseButton: Qe,
    Collapsible: et,
    RelatedRuleList: Oo,
    SimpleSpinner: Fe
  },
  props: {
    title: {
      type: String,
      required: !0
    },
    part: {
      type: String,
      required: !0
    },
    limit: {
      type: Number,
      default: 5
    },
    activeCategory: {
      type: String,
      default: ""
    },
    categoryList: {
      type: Array,
      default() {
        return ["FINAL", "PROPOSED", "RFI"];
      }
    },
    categories: {
      type: Object,
      default() {
        return {
          FINAL: {
            getRules: (e) => e.filter((t) => t.type === "Rule"),
            title: "Final Rules"
          },
          PROPOSED: {
            getRules: (e) => e.filter(
              (t) => t.type === "Proposed Rule" && t.action === "Proposed rule."
            ),
            title: "Notices of Proposed Rulemaking"
          },
          RFI: {
            getRules: (e) => e.filter(
              (t) => t.type === "Proposed Rule" && t.action === "Request for information."
            ),
            title: "Requests for Information"
          }
        };
      }
    }
  },
  data() {
    return {
      isFetching: !0,
      limitedList: !0,
      rules: []
    };
  },
  computed: {
    currentActiveCategory() {
      return this.activeCategory;
    }
  },
  created() {
    this.fetch_rules(this.title, this.part);
  },
  methods: {
    async fetch_rules(e, t) {
      let r = `https://www.federalregister.gov/api/v1/documents.json?fields[]=type&fields[]=abstract&fields[]=citation&fields[]=correction_of&fields[]=action&fields[]=dates&fields[]=docket_id&fields[]=docket_ids&fields[]=document_number&fields[]=effective_on&fields[]=html_url&fields[]=publication_date&fields[]=regulation_id_number_info&fields[]=regulation_id_numbers&fields[]=title&order=newest&conditions[cfr][title]=${e}&conditions[cfr][part]=${t}`, n = [];
      try {
        for (; r; ) {
          const i = await (await fetch(r)).json();
          n = n.concat(i.results ?? []), r = i.next_page_url;
        }
        this.rules = n;
      } catch (a) {
        console.error(a);
      } finally {
        this.isFetching = !1;
      }
    },
    showCategory(e) {
      this.currentActiveCategory = e === this.currentActiveCategory ? "" : e;
    },
    buttonClass(e) {
      return this.categories[e].getRules(this.rules).length > 0 ? "show-more-button" : "show-more-button show-more-inactive";
    },
    getRules(e) {
      return this.categories[e].getRules(this.rules);
    }
  }
}, BC = { class: "category" };
function FC(e, t, r, n, a, i) {
  const s = B("collapse-button"), o = B("simple-spinner"), u = B("related-rule-list"), l = B("collapsible");
  return v(), _("div", null, [
    (v(!0), _(E, null, X(r.categoryList, (d, c) => (v(), _("div", { key: c }, [
      b("div", BC, [
        q(s, {
          class: G([{ category: d }, "related-rules-title"]),
          name: d,
          state: "collapsed"
        }, {
          expanded: N(() => [
            L(I(r.categories[d].title) + " ", 1),
            t[0] || (t[0] = b("i", { class: "fa fa-chevron-up category-toggle" }, null, -1))
          ]),
          collapsed: N(() => [
            L(I(r.categories[d].title) + " ", 1),
            t[1] || (t[1] = b("i", { class: "fa fa-chevron-down category-toggle" }, null, -1))
          ]),
          _: 2
        }, 1032, ["class", "name"]),
        q(l, {
          name: d,
          state: i.currentActiveCategory === d ? "expanded" : "collapsed"
        }, {
          default: N(() => [
            a.isFetching ? (v(), D(o, {
              key: 0,
              size: "small"
            })) : (v(), D(u, {
              key: 1,
              rules: i.getRules(d),
              limit: r.limit,
              title: r.categories[d].title
            }, null, 8, ["rules", "limit", "title"]))
          ]),
          _: 2
        }, 1032, ["name", "state"])
      ])
    ]))), 128))
  ]);
}
const tw = /* @__PURE__ */ z(jC, [["render", FC]]);
function NC() {
  return document.getElementById("categories") ? JSON.parse(
    document.getElementById("categories").textContent
  ).map((t) => {
    const r = JSON.parse(JSON.stringify(t));
    return r.subcategories = [], r;
  }) : [];
}
const UC = async (e) => {
  let t = [];
  try {
    t = await mv({
      apiUrl: e
    });
  } catch (r) {
    console.error(r);
  }
  return t;
}, HC = {
  components: {
    SupplementalContentCategory: qv,
    SimpleSpinner: Fe
  },
  props: {
    apiUrl: {
      type: String,
      required: !1,
      default: ""
    },
    title: {
      type: String,
      required: !0
    },
    part: {
      type: String,
      required: !0
    },
    subparts: {
      type: Array,
      required: !1,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      categories: [],
      isFetching: !0,
      selectedPart: void 0,
      resourceCount: 0,
      partDict: {},
      // To support go-back button; LLM code
      scrollOrigin: null,
      hasScrolled: !1
    };
  },
  computed: {
    activePart() {
      return this.selectedPart !== void 0 ? this.selectedPart : this.subparts && this.subparts.length > 0 ? `Subpart ${this.subparts[0]}` : `Part ${this.part}`;
    }
  },
  watch: {
    subparts() {
      this.categories = [], this.isFetching = !0, this.fetchContent();
    },
    selectedPart() {
      this.categories = [], this.isFetching = !0, this.selectedPart ? this.fetchContent(
        `citations=${this.title}.${this.part}.${this.selectedPart.split(".")[1]}`
      ) : this.fetchContent();
    }
  },
  created() {
    let e = "";
    window.location.hash ? e = this.parseHash(window.location.hash) : this.fetchContent(), this.fetchContent(e), window.addEventListener("hashchange", this.handleHashChange);
  },
  mounted() {
    ae.on(pe.SetSection, (e) => {
      this.selectedPart = e.section;
    }), ae.on(pe.TrackScrollOrigin, this.handleScrollTracking), this.categories = NC();
  },
  beforeUnmount() {
    ae.off(pe.SetSection), ae.off(pe.TrackScrollOrigin, this.handleScrollTracking);
  },
  unmounted() {
    window.removeEventListener("hashchange", this.handleHashChange);
  },
  methods: {
    handleHashChange() {
      const e = this.parseHash(window.location.hash);
      this.fetchContent(e);
    },
    parseHash(e) {
      if (window.location.hash === "#main-content") return "";
      if (e.toLowerCase().includes("appendix"))
        return this.selectedPart = void 0, "";
      let t = e.substring(1).replace("-", ".");
      return t.includes("-") && ([t] = t.split("-")), Number.isNaN(t) ? `citations=${this.title}.${this.part}.${t}` : (this.selectedPart = `§ ${t}`, `citations=${this.title}.${t}`);
    },
    /* start of LLM code*/
    async fetchContent(e) {
      try {
        let t = "";
        e && (t = await Na({
          apiUrl: this.apiUrl,
          builtCitationString: e,
          pageSize: 1e3
        })), await this.getPartDictionary();
        const r = await Promise.all([
          UC(this.apiUrl),
          // Choose the appropriate method to get resources based on whether subparts exist
          this.subparts && this.subparts.length > 0 ? Na({
            apiUrl: this.apiUrl,
            partDict: this.partDict,
            pageSize: 1e3
          }) : Na({
            apiUrl: this.apiUrl,
            builtCitationString: `citations=${this.title}.${this.part}`,
            pageSize: 1e3
          })
        ]), n = r[0], a = r[1];
        this.resourceCount = a.count, t !== "" ? this.categories = lo({
          apiUrl: this.apiUrl,
          categories: n.results,
          resources: t.results
        }) : this.categories = lo({
          apiUrl: this.apiUrl,
          categories: n.results,
          resources: a.results
        });
      } catch (t) {
        console.error(t);
      } finally {
        this.isFetching = !1;
      }
    },
    /* end of LLM code*/
    /* start of LLM code */
    async getPartDictionary() {
      if (this.subparts && this.subparts.length > 0)
        try {
          const e = await B1({
            apiUrl: this.apiUrl,
            title: this.title,
            part: this.part,
            subPart: this.subparts[0]
          }), t = _v(e);
          this.partDict[this.part] = {
            title: this.title,
            subparts: this.subparts,
            sections: t
          };
        } catch (e) {
          console.error("Error fetching subpart TOC:", e), this.partDict[this.part] = {
            title: this.title,
            subparts: this.subparts,
            sections: []
          };
        }
      else
        this.partDict[this.part] = {
          title: this.title,
          subparts: [],
          sections: []
        };
    },
    /*  end of LLM code*/
    /* start of more LLM code */
    // New method to handle scroll tracking
    handleScrollTracking(e) {
      this.scrollOrigin = e.origin, this.hasScrolled = !0;
    },
    // New method to handle going back
    goBack() {
      this.scrollOrigin !== null && (window.scrollTo({
        top: this.scrollOrigin,
        behavior: "smooth"
      }), this.scrollOrigin = null, this.hasScrolled = !1);
    },
    /*  end of more LLM code*/
    clearSection() {
      this.selectedPart = void 0, this.location = void 0, ae.emit(pe.ClearSections);
    }
  }
}, GC = { id: "subpart-resources-heading" }, zC = { class: "supplemental-content-container" }, VC = { class: "view-all__container" }, WC = { class: "bold" }, KC = { class: "bold" };
function XC(e, t, r, n, a, i) {
  const s = B("supplemental-content-category"), o = B("simple-spinner");
  return v(), _(E, null, [
    b("div", null, [
      b("h1", GC, I(i.activePart) + " Documents ", 1),
      Y(e.$slots, "login-banner"),
      Y(e.$slots, "public-label"),
      b("div", zC, [
        (v(!0), _(E, null, X(a.categories, (u) => (v(), D(s, {
          key: u.name,
          name: u.name,
          subcategory: !1,
          description: u.description,
          supplemental_content: u.supplemental_content,
          subcategories: u.subcategories,
          "is-fetching": a.isFetching,
          "is-fr-link-category": u.is_fr_link_category,
          "show-if-empty": u.show_if_empty
        }, null, 8, ["name", "description", "supplemental_content", "subcategories", "is-fetching", "is-fr-link-category", "show-if-empty"]))), 128)),
        a.isFetching ? (v(), D(o, { key: 0 })) : O("", !0)
      ])
    ]),
    Y(e.$slots, "authed-documents"),
    b("div", VC, [
      a.selectedPart && r.subparts && r.subparts.length === 1 ? (v(), _("a", {
        key: 0,
        class: "show-subpart-resources",
        "data-testid": "view-all-subpart-resources",
        onClick: t[0] || (t[0] = (...u) => i.clearSection && i.clearSection(...u))
      }, [
        b("span", WC, " View All Subpart " + I(r.subparts[0]) + " Documents", 1),
        L(" (" + I(a.resourceCount) + ") ", 1)
      ])) : a.selectedPart && (!r.subparts || r.subparts.length === 0) ? (v(), _("a", {
        key: 1,
        class: "show-part-resources",
        "data-testid": "view-all-part-resources",
        onClick: t[1] || (t[1] = (...u) => i.clearSection && i.clearSection(...u))
      }, [
        b("span", KC, " View All Part " + I(r.part) + " Documents", 1),
        L(" (" + I(a.resourceCount) + ") ", 1)
      ])) : O("", !0)
    ]),
    a.hasScrolled ? (v(), _("button", {
      key: 0,
      class: "btn go-back-button",
      onClick: t[2] || (t[2] = (...u) => i.goBack && i.goBack(...u))
    }, t[3] || (t[3] = [
      b("div", { class: "view-resources-link" }, [
        b("span", { class: "bold" }, "Go back to regulation")
      ], -1)
    ]))) : O("", !0)
  ], 64);
}
const rw = /* @__PURE__ */ z(HC, [["render", XC]]), YC = {
  name: "TableComponent",
  props: {
    table_markup: {
      type: String,
      required: !0
    }
  },
  computed: {
    table() {
      return this.table_markup;
    }
  }
}, JC = { class: "table-section" };
function ZC(e, t, r, n, a, i) {
  const s = Be("sanitize-html");
  return te((v(), _("section", JC, null, 512)), [
    [s, i.table]
  ]);
}
const nw = /* @__PURE__ */ z(YC, [["render", ZC]]), QC = {
  name: "ViewResourcesLink",
  /* Start LLM code */
  data() {
    return {
      scrollOrigin: null,
      hasScrolled: !1
    };
  },
  /* End LLM code */
  props: {
    section: {
      type: String,
      required: !0
    },
    count: {
      type: String,
      required: !0
    },
    type: {
      type: String,
      required: !1,
      default: "link"
    }
  },
  methods: {
    /* Start partially LLM code */
    clickHandler() {
      const e = window.pageYOffset;
      if (ae.emit(pe.TrackScrollOrigin, {
        origin: e
      }), ae.emit(pe.SetSection, {
        section: this.section,
        count: this.count
      }), window.innerWidth < 767) {
        const t = document.querySelector("#right-sidebar");
        if (t) {
          const r = t.getBoundingClientRect().top + window.pageYOffset, n = document.querySelector("#header").offsetHeight;
          window.scrollTo({
            top: r - n,
            behavior: "smooth"
          });
        }
      }
    },
    goBack() {
      this.scrollOrigin !== null && (window.scrollTo({
        top: this.scrollOrigin,
        behavior: "smooth"
      }), this.scrollOrigin = null, this.hasScrolled = !1);
    },
    /* End partially LLM code */
    isLink() {
      return this.type === "link";
    }
  }
}, eS = {
  key: 0,
  class: "view-resources-link"
}, tS = { class: "bold" }, rS = {
  key: 1,
  class: "bold disabled"
}, nS = {
  key: 1,
  class: "view-resources-link",
  style: { "padding-left": "5px" }
}, aS = { class: "bold" }, iS = { class: "count" }, sS = {
  key: 1,
  class: "btn disabled"
}, oS = { class: "bold" };
function uS(e, t, r, n, a, i) {
  return i.isLink() ? (v(), _("div", eS, [
    r.count !== "0" ? (v(), _("button", {
      key: 0,
      class: "link-btn",
      onClick: t[0] || (t[0] = (...s) => i.clickHandler && i.clickHandler(...s))
    }, [
      b("span", tS, "View " + I(r.section) + " Documents", 1),
      L(" (" + I(r.count) + ") ", 1)
    ])) : (v(), _("div", rS, " No documents for " + I(r.section) + ". ", 1))
  ])) : (v(), _("div", nS, [
    r.count !== "0" ? (v(), _("button", {
      key: 0,
      class: "btn",
      onClick: t[1] || (t[1] = (...s) => i.clickHandler && i.clickHandler(...s))
    }, [
      b("span", aS, "View " + I(r.section) + " Documents", 1),
      b("span", iS, " (" + I(r.count) + ")", 1)
    ])) : (v(), _("button", sS, [
      b("span", oS, I(r.section) + " Documents", 1),
      t[2] || (t[2] = b("span", { class: "count" }, " (0)", -1))
    ]))
  ]));
}
const aw = /* @__PURE__ */ z(QC, [["render", uS]]), lS = {
  name: "ActionButton",
  props: {
    actionType: {
      type: String,
      required: !0
    },
    selectedAction: {
      type: String,
      required: !0
    },
    status: {
      type: String,
      required: !0
    }
  },
  computed: {
    selected() {
      return this.selectedAction === this.actionType && this.status !== "idle";
    },
    labelState() {
      return this.selected && this.status === "success" ? "copied" : "copy";
    },
    label() {
      return `${this.labelState} ${this.actionType}`;
    },
    buttonClasses() {
      return {
        "selected-btn": this.selected && this.status === "success",
        "default-btn": !this.selected
      };
    }
  },
  emits: ["action-btn-click"],
  methods: {
    handleClick() {
      this.$emit("action-btn-click", {
        actionType: this.actionType
      });
    }
  }
}, cS = ["disabled"], dS = {
  key: 0,
  width: "17",
  height: "17",
  viewBox: "0 0 17 17"
};
function fS(e, t, r, n, a, i) {
  return v(), _("button", {
    class: G(["action-btn", i.buttonClasses]),
    disabled: i.selected && r.status === "success",
    onClick: t[0] || (t[0] = (...s) => i.handleClick && i.handleClick(...s))
  }, [
    i.selected && r.status === "success" ? (v(), _("svg", dS, t[1] || (t[1] = [
      b("svg", {
        width: "17",
        height: "17"
      }, [
        b("path", {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M8.50007 16C4.36452 16 1 12.6355 1 8.50007C1 4.36452 4.36452 1 8.50007 1C12.6355 1 15.9999 4.36452 15.9999 8.50007C15.9999 12.6355 12.6355 16 8.50007 16ZM8.50007 2.02937C4.93206 2.02937 2.02922 4.93221 2.02922 8.50007C2.02922 12.0681 4.93206 14.9708 8.50007 14.9708C12.0679 14.9708 14.9706 12.0681 14.9706 8.50007C14.9706 4.93221 12.0679 2.02937 8.50007 2.02937Z",
          fill: "#2A7A3B",
          stroke: "#2A7A3B",
          "stroke-width": "0.25"
        })
      ], -1),
      b("svg", {
        width: "17",
        height: "17",
        x: "4",
        y: "5"
      }, [
        b("path", {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M3.48221 5.98237C3.34562 5.98237 3.21476 5.92812 3.11831 5.83166L1.2191 3.93246C1.01811 3.73161 1.01811 3.40565 1.2191 3.2048C1.4201 3.00366 1.74577 3.00366 1.94676 3.2048L3.48221 4.73996L7.05287 1.1693C7.25357 0.968307 7.57954 0.968307 7.78053 1.1693C7.98152 1.37014 7.98152 1.69611 7.78053 1.89696L3.84597 5.83166C3.74951 5.92812 3.61866 5.98237 3.48221 5.98237Z",
          fill: "#2A7A3B",
          stroke: "#2A7A3B",
          "stroke-width": "0.25"
        })
      ], -1)
    ]))) : O("", !0),
    L(" " + I(i.label), 1)
  ], 10, cS);
}
const hS = /* @__PURE__ */ z(lS, [["render", fS]]), vS = {
  name: "CopyCitation",
  components: {
    ActionBtn: hS
  },
  props: {
    formattedCitation: {
      type: String,
      required: !0
    },
    hash: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      selectedAction: null,
      copyStatus: "idle"
    };
  },
  watch: {
    async copyStatus(e, t) {
      if (e === "pending" && (t === "idle" || t === "success"))
        try {
          await navigator.clipboard.writeText(this.getCopyText()), this.copyStatus = "success";
        } catch (r) {
          console.info("Error copying to clipboard", r), this.copyStatus = "idle";
        }
    }
  },
  methods: {
    handleActionClick(e) {
      this.selectedAction = e.actionType, this.copyStatus = "pending";
    },
    getCopyText() {
      return this.selectedAction === "citation" ? this.formattedCitation : `${new URL(window.location.href.split("#")[0]).toString()}#${this.hash}`;
    }
  }
}, pS = { class: "action-btns" };
function gS(e, t, r, n, a, i) {
  const s = B("ActionBtn");
  return v(), _("div", pS, [
    q(s, {
      "selected-action": a.selectedAction,
      status: a.copyStatus,
      "action-type": "link",
      onActionBtnClick: i.handleActionClick
    }, null, 8, ["selected-action", "status", "onActionBtnClick"]),
    q(s, {
      "selected-action": a.selectedAction,
      status: a.copyStatus,
      "action-type": "citation",
      onActionBtnClick: i.handleActionClick
    }, null, 8, ["selected-action", "status", "onActionBtnClick"])
  ]);
}
const iw = /* @__PURE__ */ z(vS, [["render", gS]]), _S = {
  name: "GovInfoLinks",
  components: {
    SimpleSpinner: Fe
  },
  props: {
    apiUrl: {
      type: String,
      required: !0
    },
    title: {
      type: String,
      required: !0
    },
    part: {
      type: String,
      required: !0
    },
    section: {
      type: String,
      required: !0
    }
  },
  created() {
    U1({
      apiUrl: this.apiUrl,
      filterParams: {
        title: this.title,
        part: this.part,
        section: this.section
      }
    }).then((e) => {
      this.govInfoLinks = e.sort((t, r) => r.year - t.year);
    }).catch((e) => {
      console.error("Error", e), this.govInfoLinks = [];
    }).finally(() => {
      this.loading = !1;
    });
  },
  data() {
    return {
      govInfoLinks: [],
      loading: !0
    };
  }
}, mS = { class: "gov-info-links-container" }, yS = { class: "gov-info-links" }, bS = {
  key: 1,
  class: "no-results"
}, CS = {
  key: 2,
  class: "links-container"
}, SS = ["href"];
function qS(e, t, r, n, a, i) {
  const s = B("SimpleSpinner");
  return v(), _("div", mS, [
    b("div", yS, [
      a.loading ? (v(), D(s, {
        key: 0,
        size: "medium"
      })) : a.govInfoLinks.length === 0 ? (v(), _("div", bS, " No results found. ")) : (v(), _("div", CS, [
        (v(!0), _(E, null, X(a.govInfoLinks, (o, u) => (v(), _("a", {
          key: u,
          href: o.link,
          class: "external",
          target: "_blank",
          rel: "noopener noreferrer"
        }, I(o.year), 9, SS))), 128))
      ]))
    ]),
    t[0] || (t[0] = b("div", { class: "gov-info-source" }, [
      L(" Source: CFR Annual Edition from "),
      b("a", {
        href: "https://www.govinfo.gov/app/collection/cfr",
        class: "external",
        target: "_blank",
        rel: "noopener noreferrer"
      }, " GovInfo"),
      L(" (1996–Present) ")
    ], -1))
  ]);
}
const sw = /* @__PURE__ */ z(_S, [["render", qS]]), Lh = (e, t) => e ? t === "labeled-icon" || t === "link" ? e.offsetWidth / 2 : e.offsetWidth * 0.7 : 0, Mh = (e, t, r) => {
  if (!e) return 0;
  const n = r === "over" ? 20 : 10;
  return parseInt(window.getComputedStyle(e).fontSize, 10) + n;
}, dt = (e) => `${e}px`, Dh = (e) => e.getBoundingClientRect().left < 130, wS = {
  name: "TooltipContainer",
  props: {
    btnClass: {
      type: String,
      default: "copy-btn"
    },
    buttonIcon: {
      type: String,
      default: "link"
    },
    btnType: {
      default: "normal",
      validator: (e) => ["btn", "icon", "labeled-btn", "labeled-icon", "link"].includes(
        e
      )
    },
    click: {
      type: Boolean,
      default: !1
    },
    hover: {
      type: Boolean,
      default: !1
    },
    label: {
      type: String,
      required: !0
    },
    position: {
      type: String,
      default: "over"
    },
    title: {
      type: String,
      required: !0
    },
    tooltipTitle: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      entered: !1,
      clicked: !1,
      leftSafe: !0,
      anchorX: 0,
      anchorY: 0
    };
  },
  computed: {
    ariaLabel() {
      return this.btnType === "icon" ? `${this.label} for ${this.title}` : !1;
    },
    closeAriaLabel() {
      return `close ${this.label} dialog`;
    },
    buttonClasses() {
      return {
        "trigger-btn-labeled": this.btnType === "labeled-icon",
        "trigger-btn-link": this.btnType === "link",
        [this.btnClass]: !0
      };
    },
    buttonContainerClasses() {
      return {
        [`${this.btnClass}-container`]: !0
      };
    },
    tooltipClasses() {
      return {
        "tooltip-caret": this.leftSafe && this.position === "over",
        "tooltip-caret-top": this.leftSafe && this.position === "under",
        "tooltip-caret-left": !this.leftSafe && this.position === "over",
        "tooltip-caret-top-left": !this.leftSafe && this.position === "under"
      };
    },
    tooltipStyles() {
      if (this.position === "over")
        return {
          left: this.anchorX,
          transform: `translate(-${this.leftSafe ? 50 : 20}%, 0)`,
          bottom: this.anchorY
        };
      if (this.position === "under") {
        const e = {
          "margin-top": "10px"
        };
        return this.leftSafe ? {
          transform: `translate(-${this.anchorX}, 0)`,
          ...e
        } : e;
      }
      return {};
    },
    faIconType() {
      return `fa-${this.buttonIcon}`;
    }
  },
  methods: {
    handleEnter(e) {
      this.entered = !this.entered && !this.clicked, this.leftSafe = !Dh(e.currentTarget), this.anchorX = dt(
        Lh(e.currentTarget, this.btnType)
      ), this.anchorY = dt(
        Mh(this.$el, this.btnType, this.position)
      );
    },
    handleExit() {
      this.clicked || (this.entered = !1, this.anchorX = void 0, this.leftSafe = !0);
    },
    handleClick(e) {
      this.clicked || (this.entered = !1, this.clicked = !0, Dh(e.currentTarget) && (this.leftSafe = !1), this.anchorX = dt(
        Lh(e.currentTarget, this.btnType)
      ), this.anchorY = dt(
        Mh(this.$el, this.btnType)
      ));
    },
    handleCloseClick() {
      this.clicked && (this.clicked = !1, this.entered = !1, this.anchorX = void 0, this.leftSafe = !0, this.selectedAction = null);
    }
  }
}, $S = ["aria-label"], TS = { key: 0 }, RS = { class: "hover-msg" }, AS = ["aria-label"], kS = { class: "tooltip-title" };
function IS(e, t, r, n, a, i) {
  const s = Be("clickaway");
  return v(), _("div", {
    class: G(["trigger-btn-container", i.buttonContainerClasses])
  }, [
    b("button", {
      class: G(["trigger-btn text-btn", i.buttonClasses]),
      "aria-label": i.ariaLabel,
      onFocus: t[0] || (t[0] = (...o) => i.handleEnter && i.handleEnter(...o)),
      onFocusout: t[1] || (t[1] = (...o) => i.handleExit && i.handleExit(...o)),
      onMouseenter: t[2] || (t[2] = (...o) => i.handleEnter && i.handleEnter(...o)),
      onMouseleave: t[3] || (t[3] = (...o) => i.handleExit && i.handleExit(...o)),
      onClick: t[4] || (t[4] = (...o) => i.handleClick && i.handleClick(...o))
    }, [
      r.btnType === "link" ? (v(), _(E, { key: 0 }, [
        L(I(r.title), 1)
      ], 64)) : (v(), _(E, { key: 1 }, [
        b("i", {
          class: G(["fa", i.faIconType])
        }, null, 2),
        r.btnType === "labeled-icon" ? (v(), _("span", TS, I(r.label), 1)) : O("", !0)
      ], 64))
    ], 42, $S),
    r.hover && a.entered ? (v(), _("div", {
      key: 0,
      class: G(["tooltip hovered", i.tooltipClasses]),
      style: ht(i.tooltipStyles)
    }, [
      b("p", RS, I(r.label), 1)
    ], 6)) : O("", !0),
    r.click && a.clicked ? te((v(), _("div", {
      key: 1,
      class: G(["tooltip clicked", i.tooltipClasses]),
      style: ht(i.tooltipStyles)
    }, [
      b("button", {
        class: "close-btn text-btn",
        "aria-label": i.closeAriaLabel,
        onClick: t[5] || (t[5] = (...o) => i.handleCloseClick && i.handleCloseClick(...o))
      }, t[6] || (t[6] = [
        b("svg", {
          width: "11",
          height: "11",
          viewBox: "0 0 11 11",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, [
          b("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M1.47149 1.08383L5.49969 5.11209L9.52851 1.08383C9.63637 0.975965 9.81124 0.975965 9.91911 1.08383C10.027 1.19169 10.027 1.36656 9.91911 1.47442L5.89023 5.50262L9.91911 9.53144C10.027 9.6393 10.027 9.81417 9.91911 9.92204C9.81124 10.0299 9.63637 10.0299 9.52851 9.92204L5.49969 5.89316L1.47149 9.92204C1.36363 10.0299 1.18876 10.0299 1.0809 9.92204C0.973035 9.81417 0.973035 9.6393 1.0809 9.53144L5.10916 5.50262L1.0809 1.47442C0.973035 1.36656 0.973035 1.19169 1.0809 1.08383C1.18876 0.975965 1.36363 0.975965 1.47149 1.08383Z"
          })
        ], -1)
      ]), 8, AS),
      b("p", kS, I(r.tooltipTitle), 1),
      Y(e.$slots, "tooltip-content")
    ], 6)), [
      [s, i.handleCloseClick]
    ]) : O("", !0)
  ], 2);
}
const ow = /* @__PURE__ */ z(wS, [["render", IS]]), xS = { class: "doc-type__label" }, uw = {
  __name: "DocTypeLabel",
  props: {
    iconType: {
      type: String,
      required: !0
    },
    docType: {
      type: String,
      required: !0
    }
  },
  setup(e) {
    const t = {
      Public: "users",
      Internal: "key"
    };
    return (r, n) => (v(), _("div", xS, [
      b("i", {
        class: G(`fa fa-${t[K(uo)[e.iconType]]}`)
      }, null, 2),
      L(" " + I(e.docType), 1)
    ]));
  }
}, PS = {
  key: 0,
  class: "nav-toggle__button--label"
}, lw = {
  __name: "LeftNavCollapse",
  props: {
    contentsDescription: {
      type: String,
      required: !1,
      default: "menu"
    }
  },
  setup(e) {
    const t = e;
    Le(() => {
      const { $rootNav: A } = Nh().proxy.$refs;
      document.getElementById("placeholderNav").replaceWith(A);
    });
    const r = J(window.innerWidth), n = () => {
      r.value = window.innerWidth;
    };
    Le(() => window.addEventListener("resize", n)), mo(() => window.removeEventListener("resize", n));
    const a = J(!1), i = J(!1), s = () => {
      a.value = !0;
    }, o = () => {
      a.value = !1;
    }, u = () => {
      i.value = !i.value;
    }, l = w(() => ({
      "nav-toggle__button--hovered": a.value || i.value
    })), d = J(r.value >= 1024), c = w(() => r.value >= 1024), f = J(!1), h = w(() => f.value ? d.value : c.value), g = () => {
      f.value === !1 ? (f.value = !0, d.value = !c.value) : d.value = !d.value;
    }, p = w(() => ({
      open: h.value,
      closed: !h.value
    })), m = w(() => h.value ? "mdi-close" : "mdi-menu"), C = w(() => ({
      "full-btn": h.value === !0,
      "icon-only": h.value === !1
    })), y = w(
      () => h.value ? `Close ${t.contentsDescription}` : `Open ${t.contentsDescription}`
    );
    return (A, S) => (v(), _("nav", {
      id: "leftNav",
      ref: "$rootNav",
      class: G(p.value)
    }, [
      q(Ye, {
        class: G(["nav-toggle__button", C.value]),
        ripple: !1,
        icon: h.value,
        "aria-label": y.value,
        variant: "text",
        onClick: g,
        onMouseenter: s,
        onMouseleave: o,
        onFocus: u,
        onBlur: u
      }, {
        default: N(() => [
          q(Ee, {
            class: G(["nav-toggle__button--icon", l.value])
          }, {
            default: N(() => [
              L(I(m.value), 1)
            ]),
            _: 1
          }, 8, ["class"]),
          h.value ? O("", !0) : (v(), _("span", PS, S[0] || (S[0] = [
            L("Read "),
            b("br", null, null, -1),
            L("Regulations")
          ])))
        ]),
        _: 1
      }, 8, ["class", "icon", "aria-label"]),
      te(b("div", null, [
        Y(A.$slots, "nav-contents")
      ], 512), [
        [De, h.value]
      ])
    ], 2));
  }
}, OS = { class: "toc-title__container" }, ES = { class: "toc-title__heading" }, LS = {
  key: 0,
  class: "toc-title__subheading"
}, MS = {
  __name: "TocTitle",
  props: {
    title: {
      type: String,
      required: !0
    },
    subheading: {
      type: String,
      required: !1,
      default: void 0
    }
  },
  setup(e) {
    return (t, r) => (v(), _("div", OS, [
      b("h2", ES, I(e.title), 1),
      e.subheading ? (v(), _("h3", LS, I(e.subheading), 1)) : O("", !0)
    ]));
  }
}, DS = { class: "toc-part__container" }, jS = ["href"], BS = { class: "toc-part__label" }, FS = { class: "toc-part__label--bold" }, kp = {
  __name: "TocPart",
  props: {
    part: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const t = e, r = se("homeUrl"), n = se("titleIdentifier"), a = w(() => `${r}${n}/${t.part.identifier[0]}`);
    return (i, s) => (v(), _("div", DS, [
      b("a", {
        class: "toc-part__anchor",
        href: a.value
      }, [
        b("div", BS, [
          b("span", FS, I(t.part.label_level), 1),
          L(" - " + I(t.part.label_description), 1)
        ])
      ], 8, jS)
    ]));
  }
}, NS = { class: "toc-subchapter__container" }, US = { class: "toc-subchapter__label" }, jh = {
  __name: "TocSubchapter",
  props: {
    subchapter: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    return (t, r) => (v(), _("div", NS, [
      b("h4", US, I(e.subchapter.label_level) + " - " + I(e.subchapter.label_description), 1),
      (v(!0), _(E, null, X(e.subchapter.children, (n) => (v(), D(kp, {
        key: n.label_level,
        part: n
      }, null, 8, ["part"]))), 128))
    ]));
  }
}, HS = { class: "toc__container--inner" }, GS = {
  key: 0,
  class: "toc-subtitle__heading"
}, zS = {
  key: 1,
  class: "toc-subchapter__container"
}, VS = { class: "toc-subchapter__label" }, WS = {
  __name: "Toc",
  props: {
    structure: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const t = e, r = w(() => t.structure.identifier[0]);
    ye("titleIdentifier", r.value);
    const n = w(
      () => `${t.structure.label_level} - ${t.structure.label_description}`.replace(
        /&amp;/g,
        "&"
      )
    ), a = w(() => {
      const l = t.structure.children.find(
        (c) => c.type === "chapter"
      );
      if (l) return l;
      const d = t.structure.children.find(
        (c) => c.type === "subtitle"
      );
      if (d && Array.isArray(d.children)) {
        const c = d.children.find(
          (f) => f.type === "chapter"
        );
        return c || d;
      }
    }), i = w(
      () => t.structure.children.find((l) => l.type === "subtitle")
    ), s = w(
      () => (t.structure.children || []).filter((l) => (l == null ? void 0 : l.type) === "subtitle").length
    ), o = w(() => {
      const l = a.value, d = i.value, c = l && l.type === "chapter" ? `${l.label_level} - ${l.label_description}` : void 0, f = d ? `${d.label_level} - ${d.label_description}` : void 0, h = s.value === 1, g = s.value === 0, p = [h ? f : void 0, g ? c : void 0].filter(Boolean).join(" | ");
      return p ? p.replace(/&amp;/g, "&") : void 0;
    }), u = w(() => {
      const l = [], d = Array.isArray(t.structure.children) ? t.structure.children : [], c = d.filter((h) => (h == null ? void 0 : h.type) === "subtitle");
      if (c.length > 0) {
        for (const h of c) {
          const g = [], p = h.children ?? [], m = p.filter((y) => (y == null ? void 0 : y.type) === "chapter"), C = p.filter((y) => (y == null ? void 0 : y.type) === "subchapter");
          if (m.length > 0) {
            const y = /* @__PURE__ */ new Set();
            for (const A of m) {
              const S = Array.isArray(A.identifier) ? A.identifier.join(".") : String(A.identifier ?? "");
              if (y.has(S)) continue;
              y.add(S);
              const k = [], T = [];
              for (const $ of A.children ?? [])
                ($ == null ? void 0 : $.type) === "subchapter" && k.push($), ($ == null ? void 0 : $.type) === "part" && T.push($);
              g.push({
                kind: "chapter",
                chapter: A,
                subchapters: k,
                parts: T
              });
            }
          } else
            for (const y of C)
              g.push({ kind: "subchapter", subchapter: y });
          l.push({ subtitle: h, entries: g });
        }
        return l;
      }
      const f = d.filter((h) => (h == null ? void 0 : h.type) === "chapter");
      if (f.length > 0) {
        const h = [];
        for (const g of f) {
          const p = [], m = [];
          for (const C of g.children ?? [])
            (C == null ? void 0 : C.type) === "subchapter" && p.push(C), (C == null ? void 0 : C.type) === "part" && m.push(C);
          h.push({
            kind: "chapter",
            chapter: g,
            subchapters: p,
            parts: m
          });
        }
        l.push({ subtitle: void 0, entries: h });
      }
      return l;
    });
    return (l, d) => (v(), _("div", HS, [
      q(MS, {
        title: n.value,
        subheading: o.value
      }, null, 8, ["title", "subheading"]),
      (v(!0), _(E, null, X(u.value, (c, f) => {
        var h;
        return v(), _("div", {
          key: ((h = c.subtitle) == null ? void 0 : h.label_level) || f
        }, [
          c.subtitle && s.value > 1 ? (v(), _("h3", GS, I(c.subtitle.label_level) + " - " + I(c.subtitle.label_description), 1)) : O("", !0),
          (v(!0), _(E, null, X(c.entries, (g, p) => (v(), _(E, { key: p }, [
            g.kind === "subchapter" ? (v(), D(jh, {
              key: 0,
              subchapter: g.subchapter
            }, null, 8, ["subchapter"])) : g.kind === "chapter" ? (v(), _("div", zS, [
              b("h4", VS, I(g.chapter.label_level) + " - " + I(g.chapter.label_description), 1),
              (v(!0), _(E, null, X(g.subchapters, (m) => (v(), D(jh, {
                key: m.label_level,
                subchapter: m
              }, null, 8, ["subchapter"]))), 128)),
              (v(!0), _(E, null, X(g.parts, (m) => (v(), D(kp, {
                key: m.label_level,
                part: m
              }, null, 8, ["part"]))), 128))
            ])) : O("", !0)
          ], 64))), 128))
        ]);
      }), 128))
    ]));
  }
}, KS = { class: "toc__container" }, Ip = async ({ apiUrl: e, titles: t }) => {
  const n = (await Po({ apiUrl: e })).map(
    (a) => `Title ${a}`
  );
  t.value = n;
}, xp = async ({ apiUrl: e, titlesArr: t, TOCs: r }) => {
  const n = await Promise.all(
    t.map(async (a) => await j1({ title: a, apiUrl: e }))
  );
  r.value = n;
}, XS = { getTitlesArray: Ip, getTOCs: xp }, cw = /* @__PURE__ */ Object.assign(XS, {
  __name: "TocContainer",
  props: {
    apiUrl: {
      type: String,
      default: void 0
    },
    homeUrl: {
      type: String,
      default: void 0
    }
  },
  setup(e) {
    const t = e;
    ye("homeUrl", t.homeUrl);
    const r = J([]), n = J([]);
    he(r, (i) => {
      const s = i.map((o) => o.split(" ")[1]);
      xp({ apiUrl: t.apiUrl, titlesArr: s, TOCs: n });
    });
    const a = J(0);
    return Ip({ apiUrl: t.apiUrl, titles: r }), (i, s) => (v(), _("div", KS, [
      q(Ap, {
        modelValue: a.value,
        "onUpdate:modelValue": s[0] || (s[0] = (o) => a.value = o)
      }, {
        default: N(() => [
          (v(!0), _(E, null, X(r.value, (o, u) => (v(), D(bt, {
            key: u,
            tabindex: "0"
          }, {
            default: N(() => [
              L(I(o), 1)
            ]),
            _: 2
          }, 1024))), 128))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      q(Ct, {
        modelValue: a.value,
        "onUpdate:modelValue": s[1] || (s[1] = (o) => a.value = o),
        dark: ""
      }, {
        default: N(() => [
          (v(!0), _(E, null, X(r.value, (o, u) => (v(), D(Je, { key: u }, {
            default: N(() => [
              n.value[u] ? (v(), D(WS, {
                key: 0,
                structure: n.value[u]
              }, null, 8, ["structure"])) : O("", !0)
            ]),
            _: 2
          }, 1024))), 128))
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]));
  }
}), YS = ["data-testid", "href"], JS = { class: "anchor__span" }, St = {
  __name: "HeaderLink",
  props: {
    name: {
      type: String,
      required: !0
    },
    label: {
      type: String,
      required: !0
    },
    active: {
      type: Boolean,
      required: !0
    },
    href: {
      type: String,
      required: !0
    }
  },
  setup(e) {
    return (t, r) => (v(), _("a", {
      "data-testid": e.name,
      class: G(["header--links__anchor", { active: e.active }]),
      href: e.href
    }, [
      b("span", JS, I(e.label), 1)
    ], 10, YS));
  }
}, dw = {
  __name: "AccessLink",
  props: {
    base: {
      type: String,
      required: !0
    }
  },
  setup(e) {
    const t = e, r = w(() => `${t.base}about/`), a = {
      active: window.location.pathname.includes("about"),
      href: r.value
    };
    return (i, s) => (v(), _(E, null, [
      q(St, ie(a, {
        name: "get-account-access-narrow",
        class: "header__access-link header__access-link--narrow",
        label: "About"
      }), null, 16),
      q(St, ie(a, {
        name: "get-account-access-wide",
        class: "header__access-link header__access-link--wide",
        label: "About"
      }), null, 16)
    ], 64));
  }
}, ZS = { class: "header--content-container" }, QS = { class: "header__row header__row--first" }, eq = { class: "header--brand" }, tq = ["href"], rq = { class: "header--search" }, nq = { class: "header__row header__row--second" }, aq = { class: "header--jump-to" }, iq = { class: "header--links" }, fw = {
  __name: "HeaderComponent",
  props: {
    homeUrl: {
      type: String,
      required: !0
    }
  },
  setup(e) {
    const t = window.location.pathname.includes("login");
    return (r, n) => (v(), _("div", ZS, [
      b("div", QS, [
        b("div", eq, [
          b("a", { href: e.homeUrl }, n[0] || (n[0] = [
            L("Policy "),
            b("br", null, null, -1),
            L("Connector")
          ]), 8, tq),
          n[1] || (n[1] = b("span", { class: "indicator" }, "DEMO", -1)),
          n[2] || (n[2] = b("span", { class: "subtext" }, [
            L("Human Services"),
            b("br"),
            L(" Eligibility")
          ], -1))
        ]),
        b("div", rq, [
          Y(r.$slots, "search")
        ]),
        b("div", {
          class: G(["header--sign-in", { active: K(t) }])
        }, [
          Y(r.$slots, "sign-in")
        ], 2),
        Y(r.$slots, "get-access")
      ]),
      b("div", nq, [
        b("div", aq, [
          Y(r.$slots, "jump-to")
        ]),
        b("div", iq, [
          Y(r.$slots, "links")
        ])
      ])
    ]));
  }
};
function Pp() {
  const e = J(!1);
  return {
    menuExpanded: e,
    toggleClick: () => {
      e.value = !e.value;
    },
    closeClick: () => {
      e.value = !1;
    }
  };
}
const sq = {}, oq = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "13",
  height: "7",
  viewBox: "0 0 13 7",
  fill: "none"
};
function uq(e, t) {
  return v(), _("svg", oq, t[0] || (t[0] = [
    b("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M11.8861 6.27859C11.9665 6.19811 12.0053 6.10614 12.0053 6.00267C12.0053 5.89633 11.9665 5.80579 11.8861 5.72531L6.28002 0.119277C6.19955 0.0388007 6.10757 0 6.00267 0C5.8992 0 5.80723 0.0388007 5.72675 0.119277L0.120714 5.72531C0.0416752 5.80579 0 5.89633 0 6.00267C0 6.10614 0.0416752 6.19811 0.120714 6.27859L0.721412 6.87929C0.801889 6.95976 0.895299 7 0.998768 7C1.10367 7 1.19565 6.95976 1.27612 6.87929L6.00267 2.15274L10.7306 6.87929C10.8111 6.95976 10.9031 7 11.008 7C11.1115 7 11.2034 6.95976 11.2839 6.87929L11.8861 6.27859Z",
      fill: "#212121"
    }, null, -1)
  ]));
}
const lq = /* @__PURE__ */ z(sq, [["render", uq]]), cq = {}, dq = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "13",
  height: "7",
  viewBox: "0 0 13 7",
  fill: "none"
};
function fq(e, t) {
  return v(), _("svg", dq, t[0] || (t[0] = [
    b("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M11.8861 0.721412C11.9665 0.801889 12.0053 0.893862 12.0053 0.997331C12.0053 1.10367 11.9665 1.19421 11.8861 1.27469L6.28002 6.88072C6.19955 6.9612 6.10757 7 6.00267 7C5.8992 7 5.80723 6.9612 5.72675 6.88072L0.120714 1.27469C0.0416752 1.19421 0 1.10367 0 0.997331C0 0.893862 0.0416752 0.801889 0.120714 0.721412L0.721412 0.120714C0.801889 0.0402381 0.895299 0 0.998768 0C1.10367 0 1.19565 0.0402381 1.27612 0.120714L6.00267 4.84726L10.7306 0.120714C10.8111 0.0402381 10.9031 0 11.008 0C11.1115 0 11.2034 0.0402381 11.2839 0.120714L11.8861 0.721412Z",
      fill: "#046791"
    }, null, -1)
  ]));
}
const hq = /* @__PURE__ */ z(cq, [["render", fq]]), vq = { class: "dropdown-menu__container" }, Op = {
  __name: "HeaderDropdownMenu",
  emits: ["closeMenu"],
  setup(e, { emit: t }) {
    const r = t, n = () => {
      r("closeMenu");
    };
    return (a, i) => {
      const s = Be("clickaway");
      return te((v(), _("div", vq, [
        Y(a.$slots, "dropdown-menu-content")
      ])), [
        [s, n]
      ]);
    };
  }
}, pq = { class: "links--container" }, gq = { class: "links__list links__list--wide" }, _q = { class: "links__list links__list--dropdown" }, hw = {
  __name: "HeaderLinks",
  props: {
    statutesUrl: {
      type: String,
      required: !0
    },
    subjectsUrl: {
      type: String,
      required: !0
    }
  },
  emits: ["link-clicked"],
  setup(e) {
    const t = e, r = [
      {
        name: "statutes",
        label: "OBBBA",
        active: window.location.pathname.includes("statutes"),
        href: t.statutesUrl
      },
      {
        name: "subjects",
        label: "Research a Subject",
        active: window.location.pathname.includes("subjects"),
        href: t.subjectsUrl
      }
    ], { menuExpanded: n, toggleClick: a, closeClick: i } = Pp();
    return (s, o) => (v(), _("div", pq, [
      b("ul", gq, [
        (v(), _(E, null, X(r, (u, l) => b("li", { key: l }, [
          q(St, ie({ ref_for: !0 }, u, {
            onClick: (d) => s.$emit("link-clicked", u.name)
          }), null, 16, ["onClick"])
        ])), 64))
      ]),
      b("button", {
        class: "more__button",
        onClick: o[0] || (o[0] = (...u) => K(a) && K(a)(...u))
      }, [
        te(q(lq, null, null, 512), [
          [De, K(n)]
        ]),
        te(q(hq, null, null, 512), [
          [De, !K(n)]
        ]),
        o[1] || (o[1] = b("span", null, "More", -1))
      ]),
      K(n) ? (v(), D(Op, {
        key: 0,
        class: "more--dropdown-menu",
        onCloseMenu: K(i)
      }, {
        "dropdown-menu-content": N(() => [
          b("ul", _q, [
            (v(), _(E, null, X(r, (u, l) => b("li", { key: l }, [
              q(St, ie({ ref_for: !0 }, u), null, 16)
            ])), 64))
          ])
        ]),
        _: 1
      }, 8, ["onCloseMenu"])) : O("", !0)
    ]));
  }
}, mq = {}, yq = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "24",
  viewBox: "0 -2 22 20",
  fill: "none"
};
function bq(e, t) {
  return v(), _("svg", yq, t[0] || (t[0] = [
    b("path", {
      d: "M14.9012 8.09846C14.9012 4.59913 11.9002 1.79966 8.3819 1.79966C4.76009 1.79966 1.86265 4.59913 1.86265 8.09846C1.86265 11.4978 4.76009 14.3973 8.3819 14.3973C11.9002 14.3973 14.9012 11.4978 14.9012 8.09846ZM15.2116 12.6976L21.2135 18.3965C22.0413 19.2963 20.7995 20.5961 19.8682 19.6963L13.9698 13.9973C12.5211 15.3971 10.555 16.1969 8.3819 16.1969C3.72529 16.1969 0 12.4976 0 8.09846C0 3.59932 3.72529 0 8.3819 0C12.935 0 16.7638 3.59932 16.7638 8.09846C16.7638 9.79814 16.1429 11.3978 15.2116 12.6976Z",
      fill: "#046791"
    }, null, -1)
  ]));
}
const Bh = /* @__PURE__ */ z(mq, [["render", bq]]), Cq = {}, Sq = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "10",
  height: "22",
  viewBox: "0 -2 10 18",
  fill: "none"
};
function qq(e, t) {
  return v(), _("svg", Sq, t[0] || (t[0] = [
    b("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M8.96941 17.5165C8.85444 17.6351 8.72305 17.6923 8.57524 17.6923C8.42332 17.6923 8.29398 17.6351 8.17902 17.5165L0.170395 9.25489C0.0554291 9.1363 -3.93436e-07 9.00075 -3.86678e-07 8.84615C-3.80012e-07 8.69367 0.0554291 8.55813 0.170395 8.43953L8.17902 0.177897C8.29398 0.0614168 8.42332 -6.89188e-08 8.57524 -6.22782e-08C8.72305 -5.5817e-08 8.85444 0.0614169 8.96941 0.177897L9.82755 1.06315C9.94252 1.18175 10 1.3194 10 1.47189C10 1.62649 9.94252 1.76203 9.82755 1.88063L3.07534 8.84615L9.82755 15.8138C9.94252 15.9324 10 16.0679 10 16.2225C10 16.375 9.94252 16.5106 9.82755 16.6292L8.96941 17.5165Z",
      fill: "#046791"
    }, null, -1)
  ]));
}
const wq = /* @__PURE__ */ z(Cq, [["render", qq]]), $q = ["action"], Tq = ["aria-label"], vw = {
  __name: "HeaderSearch",
  props: {
    searchUrl: {
      type: String,
      required: !0
    }
  },
  setup(e) {
    const t = J(!1), r = () => {
      t.value = !t.value;
    }, n = w(() => ({
      "search__form--expanded": t.value
    })), a = w(() => ({
      hidden: !t.value,
      "visible--mobile": t.value
    })), i = w(
      () => `${t.value ? "Hide" : "Show"} search bar`
    );
    return (s, o) => (v(), _("form", {
      class: G(["search__form", n.value]),
      action: e.searchUrl
    }, [
      b("button", {
        type: "button",
        class: "form__button--toggle-mobile-search",
        "aria-label": i.value,
        onClick: r
      }, [
        te(q(wq, null, null, 512), [
          [De, t.value]
        ]),
        te(q(Bh, null, null, 512), [
          [De, !t.value]
        ])
      ], 8, Tq),
      b("input", {
        class: G(a.value),
        type: "search",
        name: "q",
        placeholder: "Search"
      }, null, 2),
      b("button", {
        type: "submit",
        class: G(["search__button--submit", a.value]),
        "aria-label": "Search"
      }, [
        o[0] || (o[0] = b("i", { class: "fa fa-search" }, null, -1)),
        q(Bh)
      ], 2)
    ], 10, $q));
  }
}, Rq = { class: "login-cta__div" }, Aq = ["data-testid"], kq = ["href"], pw = {
  __name: "SignInCTA",
  props: {
    accessUrl: {
      type: String,
      required: !0
    },
    testId: {
      type: String,
      default: "loginSpa"
    }
  },
  setup(e) {
    return (t, r) => (v(), _("div", Rq, [
      b("span", { "data-testid": e.testId }, [
        r[1] || (r[1] = L("To see internal documents, ")),
        Y(t.$slots, "sign-in-link", {}, () => [
          r[0] || (r[0] = L("sign in"))
        ])
      ], 8, Aq),
      r[2] || (r[2] = L(" or ")),
      b("a", {
        class: "access__anchor",
        href: e.accessUrl
      }, "learn how to get account access", 8, kq),
      r[3] || (r[3] = L(". "))
    ]));
  }
};
function Iq({
  customLoginUrl: e,
  homeUrl: t,
  route: r,
  directLink: n = void 0
}) {
  const a = J(e), i = () => {
    let s, o = "no-url-params", u;
    if (r ? (s = r.path.substring(1), o = r.fullPath, u = `${e}?next=${t}${s}`) : n ? u = `${e}?next=${n}` : (s = window.location.pathname, o = window.location.href, u = `${e}?next=${s}`), !o.includes("?")) {
      if (o.includes("#")) {
        a.value = `${u}${window.location.hash}`;
        return;
      }
      a.value = u;
      return;
    }
    const l = o.split("?")[1];
    if (l.length == 0) {
      a.value = u;
      return;
    }
    a.value = `${u}?${l}`;
  };
  return Le(() => {
    r || window.addEventListener("hashchange", i), i();
  }), mo(() => {
    window.removeEventListener("hashchange", i);
  }), he(
    () => r == null ? void 0 : r.query,
    async () => {
      i();
    }
  ), a;
}
const gw = {
  __name: "SignInLink",
  props: {
    customLoginUrl: {
      type: String,
      required: !0
    },
    homeUrl: {
      type: Object,
      required: !0
    },
    isAuthenticated: {
      type: Boolean,
      required: !0
    },
    linkLabel: {
      type: String,
      default: "sign in"
    },
    route: {
      type: Object,
      default: void 0
    },
    location: {
      type: String,
      default: void 0
    },
    directLink: {
      type: String,
      default: void 0
    }
  },
  setup(e) {
    const t = e;
    return Iq({
      customLoginUrl: t.customLoginUrl,
      homeUrl: t.homeUrl,
      route: t.route,
      directLink: t.directLink
    }), w(() => ({
      disabled: t.location === "login_page"
    })), () => {
    };
  }
}, xq = {
  name: "JumpTo",
  props: {
    apiUrl: {
      type: String,
      required: !0
    },
    title: {
      type: String,
      required: !1,
      default: ""
    },
    part: {
      type: String,
      required: !1,
      default: ""
    },
    homeUrl: {
      type: String,
      default: "/"
    }
  },
  data() {
    return {
      titles: [],
      selectedPart: "",
      defaultTitle: "",
      selectedTitle: "",
      selectedSection: "",
      hideTitle: !1,
      filteredParts: [],
      isActive: !1,
      parts: [],
      link: ""
    };
  },
  async created() {
    this.titles = await Po({ apiUrl: this.apiUrl }), this.titles.length === 1 && (this.selectedTitle = this.titles[0], this.defaultTitle = this.selectedTitle), this.title !== "" && (this.selectedTitle = this.title), this.part !== "" && (this.selectedPart = this.part, this.isActive = !0);
  },
  watch: {
    selectedTitle(e) {
      e === "" ? (this.selectedPart = "", this.isActive = !1) : this.getParts(e);
    },
    selectedPart(e) {
      e !== "" ? this.isActive = !0 : this.isActive = !1;
    }
  },
  methods: {
    async getParts(e) {
      const t = await H1({ title: e, apiUrl: this.apiUrl });
      this.filteredParts = t.map((r) => r.name);
    },
    getLink() {
      let e = `${this.homeUrl}goto/?title=${this.selectedTitle}&part=${this.selectedPart}`;
      this.selectedSection !== "" && (e += `&section=${this.selectedSection}&-version='latest'`), window.location.href = e;
    }
  }
}, Pq = { class: "jump-to-input" }, Oq = ["value"], Eq = ["disabled"], Lq = ["value"];
function Mq(e, t, r, n, a, i) {
  return v(), _("div", null, [
    b("form", {
      onSubmit: t[3] || (t[3] = Gp((...s) => i.getLink && i.getLink(...s), ["prevent"]))
    }, [
      b("div", Pq, [
        te(b("select", {
          id: "jumpToTitle",
          "onUpdate:modelValue": t[0] || (t[0] = (s) => a.selectedTitle = s),
          name: "title",
          "aria-label": "Regulation title number",
          class: "ds-c-field",
          required: ""
        }, [
          t[4] || (t[4] = b("option", {
            value: "",
            disabled: "",
            selected: ""
          }, " Title ", -1)),
          (v(!0), _(E, null, X(a.titles, (s) => (v(), _("option", {
            key: s,
            value: s
          }, I(s) + " CFR ", 9, Oq))), 128))
        ], 512), [
          [Qo, a.selectedTitle]
        ]),
        t[6] || (t[6] = b("span", { class: "section-symbol" }, "§", -1)),
        te(b("select", {
          id: "jumpToPart",
          "onUpdate:modelValue": t[1] || (t[1] = (s) => a.selectedPart = s),
          name: "part",
          class: "ds-c-field",
          "aria-label": "Regulation part number",
          required: "",
          disabled: !a.selectedTitle
        }, [
          t[5] || (t[5] = b("option", {
            value: "",
            disable: "",
            selected: ""
          }, " Part ", -1)),
          (v(!0), _(E, null, X(a.filteredParts, (s) => (v(), _("option", {
            key: s,
            value: s
          }, I(s), 9, Lq))), 128))
        ], 8, Eq), [
          [Qo, a.selectedPart]
        ]),
        t[7] || (t[7] = b("span", { class: "dot" }, ".", -1)),
        te(b("input", {
          id: "jumpToSection",
          "onUpdate:modelValue": t[2] || (t[2] = (s) => a.selectedSection = s),
          class: "number-box ds-c-field",
          name: "section",
          placeholder: "",
          type: "text",
          pattern: "\\d+",
          title: "Regulation section number, i.e. 111",
          "aria-label": "Regulation section number, i.e. 111"
        }, null, 512), [
          [zp, a.selectedSection]
        ]),
        b("input", {
          id: "jumpBtn",
          class: G(["submit", { active: a.isActive }]),
          type: "submit",
          value: "Go"
        }, null, 2)
      ])
    ], 32)
  ]);
}
const _w = /* @__PURE__ */ z(xq, [["render", Mq]]), Dq = {}, jq = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  role: "img"
};
function Bq(e, t) {
  return v(), _("svg", jq, t[0] || (t[0] = [
    b("title", null, "User Icon", -1),
    b("svg", {
      width: "40px",
      height: "40px"
    }, [
      b("circle", {
        cx: "20",
        cy: "20",
        r: "19.5"
      })
    ], -1),
    b("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "40",
      height: "40",
      x: "8",
      y: "7"
    }, [
      b("path", { d: "M12 12.007C14.9688 12.007 17.4286 9.58963 17.4286 6.57847C17.4286 3.60972 14.9688 1.1499 12 1.1499C8.98884 1.1499 6.57143 3.60972 6.57143 6.57847C6.57143 9.58963 8.98884 12.007 12 12.007ZM15.7746 13.3642H15.0536C14.1205 13.8307 13.1027 14.0428 12 14.0428C10.8973 14.0428 9.83705 13.8307 8.90402 13.3642H8.18304C5.04464 13.3642 1.5 15.9512 1.5 19.0896V20.8285C1.5 21.9736 2.39062 22.8642 3.53571 22.8642H20.4643C21.567 22.8642 22.5 21.9736 22.5 20.8285V19.0896C22.5 15.9512 18.9129 13.3642 15.7746 13.3642Z" })
    ], -1)
  ]));
}
const Fq = /* @__PURE__ */ z(Dq, [["render", Bq]]), Nq = { class: "account-info__container" }, Uq = { class: "account-info--username" }, Hq = { class: "account-info--links" }, Gq = ["href"], zq = { class: "account--sign-out" }, mw = {
  __name: "HeaderUserWidget",
  props: {
    adminUrl: {
      type: String,
      default: "/admin/"
    }
  },
  setup(e) {
    const { menuExpanded: t, toggleClick: r, closeClick: n } = Pp(), a = () => {
      document.oidc_logout.submit();
    }, i = w(() => ({
      "user-account__button": !0,
      "user-account__button--expanded": t.value
    }));
    return (s, o) => (v(), _(E, null, [
      b("button", {
        "aria-label": "Account Information",
        class: G(i.value),
        "data-testid": "user-account-button",
        onClick: o[0] || (o[0] = (...u) => K(r) && K(r)(...u))
      }, [
        q(Fq)
      ], 2),
      K(t) ? (v(), D(Op, {
        key: 0,
        class: "dropdown-menu--account",
        onCloseMenu: K(n)
      }, {
        "dropdown-menu-content": N(() => [
          b("div", Nq, [
            b("div", Uq, [
              b("strong", null, [
                Y(s.$slots, "username")
              ])
            ]),
            o[1] || (o[1] = b("div", { class: "account-info--msg" }, [
              b("div", { class: "account-message" })
            ], -1)),
            b("div", Hq, [
              b("a", {
                href: e.adminUrl,
                rel: "noopener noreferrer",
                "data-testid": "manage-content-link"
              }, "Manage Content", 8, Gq)
            ])
          ]),
          o[2] || (o[2] = b("hr", null, null, -1)),
          b("div", zq, [
            Y(s.$slots, "sign-out-link", {}, () => [
              b("button", {
                class: "sign-out__button",
                "data-testid": "vue-sign-out-button",
                onClick: a
              }, " Sign Out ")
            ])
          ])
        ]),
        _: 3
      }, 8, ["onCloseMenu"])) : O("", !0)
    ], 64));
  }
};
export {
  dw as AccessLink,
  hS as ActionBtn,
  Nm as CategoryLabel,
  Qe as CollapseButton,
  et as Collapsible,
  iw as CopyCitation,
  uw as DocTypeLabel,
  Wq as Dropdown,
  Kq as DropdownContent,
  Xq as DropdownHeader,
  Yq as DropdownItem,
  sw as GovInfoLinks,
  fw as HeaderComponent,
  hw as HeaderLinks,
  vw as HeaderSearch,
  mw as HeaderUserWidget,
  J1 as IndicatorLabel,
  Jq as InternalDocsContainer,
  _w as JumpTo,
  Zq as LastParserSuccessDate,
  lw as LeftNavCollapse,
  Qq as PartButton,
  Hb as RecentChangesContainer,
  ew as RecentResources,
  nm as RelatedRule,
  Oo as RelatedRuleList,
  tw as RelatedRules,
  bv as ShowMoreButton,
  pw as SignInCta,
  gw as SignInLink,
  Fe as SimpleSpinner,
  rw as SupplementalContent,
  qv as SupplementalContentCategory,
  wm as SupplementalContentList,
  Sv as SupplementalContentObject,
  nw as TableComponent,
  WS as Toc,
  cw as TocContainer,
  kp as TocPart,
  jh as TocSubchapter,
  MS as TocTitle,
  ow as TooltipContainer,
  aw as ViewResourcesLink
};
//# sourceMappingURL=eregs-components.es.js.map
